(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("gQ2K1", function(module, exports) {
$parcel$export(module.exports, "WacAppSwitcher", function () { return (parcelRequire("bsPa3")).WacAppSwitcher; });
parcelRequire("bsPa3");

});
parcelRegister("bsPa3", function(module, exports) {

$parcel$export(module.exports, "WacAppSwitcher", function () { return $33f2d816086e299c$export$3c0dc247d15524dc; });

var $jjExS = parcelRequire("jjExS");

var $e8dor = parcelRequire("e8dor");

var $e6gyJ = parcelRequire("e6gyJ");

var $fGIeY = parcelRequire("fGIeY");

var $145N3 = parcelRequire("145N3");

var $eQudw = parcelRequire("eQudw");

var $h2kRh = parcelRequire("h2kRh");

var $8f17I = parcelRequire("8f17I");

var $fD1ai = parcelRequire("fD1ai");

var $bIYG9 = parcelRequire("bIYG9");

var $4Yhoc = parcelRequire("4Yhoc");

var $fFM8K = parcelRequire("fFM8K");

var $95rD4 = parcelRequire("95rD4");
var $8E9PO = parcelRequire("8E9PO");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fLllH = parcelRequire("fLllH");
parcelRequire("fqWHu");
var $kZduL = parcelRequire("kZduL");
var $eBpDn = parcelRequire("eBpDn");
var $j5XuS = parcelRequire("j5XuS");
var $7uLpc = parcelRequire("7uLpc");

var $1rY3h = parcelRequire("1rY3h");
function $33f2d816086e299c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $33f2d816086e299c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $33f2d816086e299c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $33f2d816086e299c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $33f2d816086e299c$var$AVATAR_IMG_URL = "http://wac-cdn.atlassian.com/dam/wac/icons/ADG3-Icons-36px-N700/object-avatar-man.svg";
var $33f2d816086e299c$var$remoteSwitcherPlugin = new (0, $h2kRh.default)({
    env: "production",
    variant: "latest"
});
var $33f2d816086e299c$var$RemoteSwitcherPreloader = function RemoteSwitcherPreloader() {
    (0, $fD1ai.default)($33f2d816086e299c$var$remoteSwitcherPlugin);
    return null;
};
var $33f2d816086e299c$export$3c0dc247d15524dc = function WacAppSwitcher(_ref) {
    var appSwitcherLabel = _ref.appSwitcherLabel, allowJoinSitesProvider = _ref.allowJoinSitesProvider;
    var _useState = (0, $1Mpn7.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), hasHovered = _useState2[0], setHasHovered = _useState2[1];
    var _useState3 = (0, $1Mpn7.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState3, 2), isAppSwitcherMenu = _useState4[0], setAppSwitcherMenu = _useState4[1];
    var _useState5 = (0, $1Mpn7.useState)("en"), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState5, 2), locale = _useState6[0], setLocale = _useState6[1];
    var _useState7 = (0, $1Mpn7.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState7, 2), isUserLoggedIn = _useState8[0], setIsUserLoggedIn = _useState8[1];
    var _useState9 = (0, $1Mpn7.useState)(), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState9, 2), joinableSites = _useState10[0], setJoinableSites = _useState10[1];
    var _useState11 = (0, $1Mpn7.useState)(true), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState11, 2), isFirstSwitcherOpen = _useState12[0], setIsFirstSwitcherOpen = _useState12[1];
    var customAvailableProductsDataProvider = (0, $95rD4.createAvailableProductsProvider)("".concat("https://www.atlassian.com/gateway/api", "/available-products/api/available-products"));
    var stargateClient = (0, $4Yhoc.useBxpWebStargateClient)();
    var _useAnalyticsEvents = (0, $145N3.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handleClickOutside = function handleClickOutside(event) {
        var path = event.composedPath && event.composedPath();
        var insideAppswitcher = Array.prototype.includes.call(Array.prototype.map.call(path, function(el) {
            return el.id === "global-nav--wac__app-switcher";
        }), true);
        if (!insideAppswitcher) setAppSwitcherMenu(false);
    };
    var handleKeydown = function handleKeydown(event) {
        if (event.code == "Escape" && isAppSwitcherMenu) setAppSwitcherMenu(false);
    };
    (0, $1Mpn7.useEffect)(function() {
        function getUserProfile() {
            return _getUserProfile.apply(this, arguments);
        }
        function _getUserProfile() {
            _getUserProfile = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee() {
                var userProfile;
                return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            _context.next = 2;
                            return stargateClient.me({});
                        case 2:
                            userProfile = _context.sent;
                            return _context.abrupt("return", userProfile);
                        case 4:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return _getUserProfile.apply(this, arguments);
        }
        getUserProfile().then(function() {
            setIsUserLoggedIn(true);
        })["catch"](function(error) {
            console.log(error);
        });
    }, []);
    (0, $1Mpn7.useEffect)(function() {
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("keydown", handleKeydown);
        return function() {
            document.removeEventListener("click", handleClickOutside);
            document.removeEventListener("keydown", handleKeydown);
        };
    });
    (0, $1Mpn7.useEffect)(function() {
        setLocale(document.documentElement.lang);
    }, []);
    (0, $1Mpn7.useEffect)(function() {
        if ((0, $fFM8K.util).getCookie("login_user_detected") === "true") {
            if (allowJoinSitesProvider) getJoinableSites();
        }
    }, []);
    (0, $1Mpn7.useEffect)(function() {
        if (isAppSwitcherMenu) createAnalyticsEvent({
            name: "WacAppSwitcher",
            action: "clicked",
            label: "WacAppSwitcherMenuRendered"
        }).fire();
    }, [
        isAppSwitcherMenu
    ]);
    var toggleSwitcherDropdown = /*#__PURE__*/ function() {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee2(allowWacJoinSitesProvider) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        if (isFirstSwitcherOpen) setIsFirstSwitcherOpen(false);
                        else if (joinableSites === undefined) // reload the joinable sites data if a joinable site has been clicked
                        {
                            if (allowWacJoinSitesProvider) getJoinableSites();
                        }
                        if (isAppSwitcherMenu) // user closing switcher
                        createAnalyticsEvent({
                            name: "WacAppSwitcherIconClickedToClose",
                            action: "clicked",
                            label: "Closing the switcher"
                        }).fire();
                        setAppSwitcherMenu(!isAppSwitcherMenu);
                    case 3:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function toggleSwitcherDropdown(_x) {
            return _ref2.apply(this, arguments);
        };
    }();
    var getJoinableSites = /*#__PURE__*/ function() {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee3() {
            var sites, reMappedSitesData, joinableSitesPromiseMaker;
            return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _context3.next = 2;
                        return fetch("".concat("https://www.atlassian.com/gateway/api", "/joinable-sites"), {
                            method: "POST",
                            credentials: "include",
                            body: JSON.stringify({
                                products: [
                                    "confluence.ondemand",
                                    "jira-software.ondemand",
                                    "jira-servicedesk.ondemand",
                                    "jira-core.ondemand"
                                ]
                            }),
                            headers: {
                                "Content-type": "application/json; charset=UTF-8"
                            }
                        }).then(function(res) {
                            return res.json();
                        });
                    case 2:
                        sites = _context3.sent;
                        reMappedSitesData = (sites.joinableSites || []).map(// eslint-disable-next-line complexity
                        function(site) {
                            var userData = {};
                            Array.prototype.forEach.call(site.products, function(val) {
                                userData[val] = [
                                    {
                                        avatarUrl: $33f2d816086e299c$var$AVATAR_IMG_URL,
                                        displayName: ""
                                    }
                                ];
                            });
                            return {
                                cloudId: site.cloudId || "",
                                displayName: site.displayName || "",
                                url: site.url || "",
                                avatarUrl: site.avatarUrl,
                                relevance: site.relevance,
                                users: userData
                            };
                        });
                        joinableSitesPromiseMaker = function joinableSitesPromiseMaker() {
                            return new Promise(function(resolve) {
                                setTimeout(function() {
                                    resolve({
                                        sites: reMappedSitesData
                                    });
                                });
                            });
                        };
                        setJoinableSites((0, $8E9PO.createJoinableSitesProvider)(joinableSitesPromiseMaker));
                    case 6:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }));
        return function getJoinableSites() {
            return _ref3.apply(this, arguments);
        };
    }();
    var switcherProps = (0, $1Mpn7.useMemo)(function() {
        return {
            product: "WAC",
            appearance: "standalone",
            joinableSitesDataProvider: joinableSites,
            availableProductsDataProvider: customAvailableProductsDataProvider,
            onJoinableSiteClicked: function onJoinableSiteClicked() {
                setAppSwitcherMenu(false);
                // joinable sites might now change if user follows through joining this site
                // so dump joinable sites data to indicate it must be reloaded
                setJoinableSites(undefined);
            }
        };
    }, [
        joinableSites,
        customAvailableProductsDataProvider
    ]);
    var appSwitcher = (0, $1rY3h.jsx)((0, $kZduL.AppSwitcherMenu), {
        children: (0, $1rY3h.jsx)((0, $8f17I.default), $33f2d816086e299c$var$_objectSpread($33f2d816086e299c$var$_objectSpread({
            remotePlugin: $33f2d816086e299c$var$remoteSwitcherPlugin,
            analyticsChannel: "navigation",
            ErrorFallback: (0, $1rY3h.jsx)((0, $bIYG9.AtlassianSwitcherLoader), $33f2d816086e299c$var$_objectSpread({}, switcherProps))
        }, switcherProps), {}, {
            product: "WAC"
        }))
    });
    if (!isUserLoggedIn) return null;
    return (0, $1rY3h.jsx)((0, $fLllH.default), {
        locale: locale || "en",
        children: (0, $1rY3h.jsxs)((0, $eBpDn.AppSwitcherContainer), {
            children: [
                (0, $1rY3h.jsx)((0, $j5XuS.StyledAppSwitcherIcon), {
                    allowJoinSitesProvider: allowJoinSitesProvider,
                    appSwitcherLabel: appSwitcherLabel,
                    toggleSwitcherDropdown: toggleSwitcherDropdown,
                    setHasHovered: setHasHovered,
                    children: (0, $1rY3h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eQudw))), {
                        size: "large",
                        primaryColor: "#0747a6",
                        label: "App Switcher"
                    })
                }),
                (0, $1rY3h.jsxs)((0, $7uLpc.RemoteSwitcherContainer), {
                    display: isAppSwitcherMenu,
                    children: [
                        hasHovered && (0, $1rY3h.jsx)($33f2d816086e299c$var$RemoteSwitcherPreloader, {}),
                        hasHovered && appSwitcher
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("eQudw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aced5c801968c2a8$var$_react = $aced5c801968c2a8$var$_interopRequireDefault((parcelRequire("1Mpn7")));

var $cotNw = parcelRequire("cotNw");
function $aced5c801968c2a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $aced5c801968c2a8$var$AppSwitcherIcon = function(props) {
    return /*#__PURE__*/ $aced5c801968c2a8$var$_react.default.createElement($cotNw.Icon, Object.assign({
        dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98z"/></svg>'
    }, props));
};
$aced5c801968c2a8$var$AppSwitcherIcon.displayName = "AppSwitcherIcon";
var $aced5c801968c2a8$var$_default = $aced5c801968c2a8$var$AppSwitcherIcon;
module.exports.default = $aced5c801968c2a8$var$_default;

});

parcelRegister("h2kRh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c672cd9c2c4c5bd6$export$2e2bcd8739ae039; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $eUBSC = parcelRequire("eUBSC");
var $c672cd9c2c4c5bd6$var$MODULE_NAME = "@atlassian/app-switcher-remote-module";
var $c672cd9c2c4c5bd6$var$MODULE_URI_STG = "https://remote-app-switcher.stg-east.frontend.public.atl-paas.net/assets/";
var $c672cd9c2c4c5bd6$var$MODULE_URI_PROD = "https://remote-app-switcher.prod-east.frontend.public.atl-paas.net/assets/";
var $c672cd9c2c4c5bd6$var$EXTERNALS = [
    {
        name: "react"
    },
    {
        name: "react-dom"
    },
    {
        name: "react-intl-next"
    },
    {
        name: "@emotion/react"
    }
];
var $c672cd9c2c4c5bd6$var$RemoteSwitcherPlugin = /*#__PURE__*/ function() {
    function RemoteSwitcherPlugin(dimensions, config) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, RemoteSwitcherPlugin);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_manifestMap", new Map([
            [
                "local",
                new Map([
                    [
                        "latest",
                        {
                            moduleName: $c672cd9c2c4c5bd6$var$MODULE_NAME,
                            moduleUri: "http://localhost:9001/",
                            externals: $c672cd9c2c4c5bd6$var$EXTERNALS
                        }
                    ]
                ])
            ],
            [
                "staging",
                new Map([
                    [
                        "latest",
                        {
                            moduleName: $c672cd9c2c4c5bd6$var$MODULE_NAME,
                            moduleUri: $c672cd9c2c4c5bd6$var$MODULE_URI_STG,
                            externals: $c672cd9c2c4c5bd6$var$EXTERNALS
                        }
                    ],
                    [
                        "stable",
                        {
                            moduleName: $c672cd9c2c4c5bd6$var$MODULE_NAME,
                            moduleUri: $c672cd9c2c4c5bd6$var$MODULE_URI_STG,
                            externals: $c672cd9c2c4c5bd6$var$EXTERNALS
                        }
                    ]
                ])
            ],
            [
                "production",
                new Map([
                    [
                        "latest",
                        {
                            moduleName: $c672cd9c2c4c5bd6$var$MODULE_NAME,
                            moduleUri: $c672cd9c2c4c5bd6$var$MODULE_URI_PROD,
                            externals: $c672cd9c2c4c5bd6$var$EXTERNALS
                        }
                    ],
                    [
                        "stable",
                        {
                            moduleName: $c672cd9c2c4c5bd6$var$MODULE_NAME,
                            moduleUri: $c672cd9c2c4c5bd6$var$MODULE_URI_PROD,
                            externals: $c672cd9c2c4c5bd6$var$EXTERNALS
                        }
                    ]
                ])
            ]
        ]));
        /**
     * This is optional and when defined can be used to override the logic for creating the moduleUri.
     * If it isn't defined or passed in then we will use the moduleUri from the manifestMap as per the defined dimensions.
     *
     * @param uri
     * @param variant
     * @param computeHash
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "moduleUriMapper", (0, $eUBSC.default)(function(uri) {
            var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "latest";
            var computeHash = arguments.length > 2 ? arguments[2] : undefined;
            // We want to hash the major version of React installed, alongside the chosen variant
            var hashedDependencies = [
                "react",
                "react-dom"
            ];
            var hashedValues = hashedDependencies.reduce(function(acc, dep) {
                return acc.concat([
                    {
                        name: dep,
                        version: (0, $1Mpn7.version).split(".")[0]
                    }
                ]);
            }, []);
            var hash = computeHash(variant, hashedValues);
            var cacheTime = Date.now().toString().substring(0, 6); // approx 3hrs
            return "".concat(uri).concat(hash, ".js?t=").concat(cacheTime);
        }));
        this._dimensions = dimensions;
        // allow either of these config options to be overridden
        if (config) {
            if (config.manifestMap) this._manifestMap = config.manifestMap;
            if ("moduleUriMapper" in config) this.moduleUriMapper = config.moduleUriMapper;
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(RemoteSwitcherPlugin, [
        {
            key: "bifrostOverrideKey",
            get: function get() {
                return "remote-app-switcher-bifrost-override";
            }
        },
        {
            key: "dimensions",
            get: function get() {
                return this._dimensions;
            }
        },
        {
            key: "manifestMap",
            get: function get() {
                return this._manifestMap;
            }
        }
    ]);
    return RemoteSwitcherPlugin;
}();
var $c672cd9c2c4c5bd6$export$2e2bcd8739ae039 = $c672cd9c2c4c5bd6$var$RemoteSwitcherPlugin;

});
parcelRegister("eUBSC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adb3add65ddbc371$export$2e2bcd8739ae039; });
var $adb3add65ddbc371$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $adb3add65ddbc371$var$isEqual(first, second) {
    if (first === second) return true;
    if ($adb3add65ddbc371$var$safeIsNaN(first) && $adb3add65ddbc371$var$safeIsNaN(second)) return true;
    return false;
}
function $adb3add65ddbc371$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$adb3add65ddbc371$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $adb3add65ddbc371$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $adb3add65ddbc371$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("8f17I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $600098884d643bdb$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $e6gyJ = parcelRequire("e6gyJ");

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");

var $145N3 = parcelRequire("145N3");


var $lMNLe = parcelRequire("lMNLe");

var $fD1ai = parcelRequire("fD1ai");
var $600098884d643bdb$var$_excluded = [
    "analyticsChannel",
    "remotePlugin",
    "exportName",
    "children",
    "Fallback"
], $600098884d643bdb$var$_excluded2 = [
    "analyticsChannel",
    "remotePlugin",
    "ErrorFallback"
];
var $600098884d643bdb$var$InternalRemoteComponent = function InternalRemoteComponent(_ref) {
    var analyticsChannel = _ref.analyticsChannel, remotePlugin = _ref.remotePlugin, _ref$exportName = _ref.exportName, exportName = _ref$exportName === void 0 ? "default" : _ref$exportName, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, _ref$Fallback = _ref.Fallback, Fallback = _ref$Fallback === void 0 ? null : _ref$Fallback, componentProps = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref, $600098884d643bdb$var$_excluded);
    var _useState = (0, $1Mpn7.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), setError = _useState2[1];
    var _useAnalyticsEvents = (0, $145N3.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    (0, $1Mpn7.useEffect)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: "rendered",
            actionSubject: "remoteModule",
            actionSubjectId: "remoteComponent",
            attributes: {
                exportName: exportName,
                dimensions: remotePlugin.dimensions,
                plugin: remotePlugin.constructor.name
            }
        });
        analyticsEvent.fire(analyticsChannel);
    }, [
        analyticsChannel,
        createAnalyticsEvent,
        exportName,
        remotePlugin
    ]);
    var onError = function onError(error) {
        // this is a workaround to throw an error from an async function
        setError(function() {
            throw error;
        });
    };
    var remoteFrontendSdk = (0, $fD1ai.default)(remotePlugin, {
        analyticsChannel: analyticsChannel,
        onError: onError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, remoteFrontendSdk.renderComponent(exportName, componentProps, Fallback, children));
};
var $600098884d643bdb$var$RemoteComponent = function RemoteComponent(_ref2) {
    var analyticsChannel = _ref2.analyticsChannel, remotePlugin = _ref2.remotePlugin, _ref2$ErrorFallback = _ref2.ErrorFallback, ErrorFallback = _ref2$ErrorFallback === void 0 ? null : _ref2$ErrorFallback, props = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref2, $600098884d643bdb$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $lMNLe.default), {
        analyticsChannel: analyticsChannel,
        remotePlugin: remotePlugin,
        fallback: ErrorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($600098884d643bdb$var$InternalRemoteComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({
        analyticsChannel: analyticsChannel,
        remotePlugin: remotePlugin
    }, props)));
};
var $600098884d643bdb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1Mpn7.memo)($600098884d643bdb$var$RemoteComponent);

});
parcelRegister("lMNLe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdc4ae25d49ac52a$export$2e2bcd8739ae039; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $1Mpn7 = parcelRequire("1Mpn7");

var $g1gbh = parcelRequire("g1gbh");
function $fdc4ae25d49ac52a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fdc4ae25d49ac52a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $fdc4ae25d49ac52a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $fdc4ae25d49ac52a$var$ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(ErrorBoundary, _React$Component);
    var _super = $fdc4ae25d49ac52a$var$_createSuper(ErrorBoundary);
    function ErrorBoundary(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, ErrorBoundary);
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                var analyticsEvent = this.props.createAnalyticsEvent({
                    action: "handled",
                    actionSubject: "error",
                    actionSubjectId: "remoteModuleErrorBoundary",
                    attributes: {
                        error: error === null || error === void 0 ? void 0 : error.message,
                        errorInfo: errorInfo,
                        dimensions: this.props.remotePlugin.dimensions,
                        plugin: this.props.remotePlugin.constructor.name
                    }
                });
                analyticsEvent.fire(this.props.analyticsChannel);
                this.setState({
                    hasError: true
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, this.props.fallback) : null;
                return this.props.children;
            }
        }
    ]);
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Component);
var $fdc4ae25d49ac52a$export$2e2bcd8739ae039 = (0, $g1gbh.default)()($fdc4ae25d49ac52a$var$ErrorBoundary);

});

parcelRegister("fD1ai", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b60b66eae60db685$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $145N3 = parcelRequire("145N3");

var $S0Njm = parcelRequire("S0Njm");

var $jHxFC = parcelRequire("jHxFC");
var $b60b66eae60db685$var$preloadedModuleMap = new WeakMap();
/**
 * Create an SDK instance for a given plugin aand cache it in the WeakMap so that if a plugin is no longer referenced
 * we clean up the sdk from the cache
 *
 * @param remotePlugin
 */ var $b60b66eae60db685$var$cacheAndGetSdkForPlugin = function cacheAndGetSdkForPlugin(remotePlugin) {
    var cachedSdk = $b60b66eae60db685$var$preloadedModuleMap.get(remotePlugin);
    if (cachedSdk) return cachedSdk;
    var sdk = new (0, $S0Njm.default)(remotePlugin);
    $b60b66eae60db685$var$preloadedModuleMap.set(remotePlugin, sdk);
    return sdk;
};
/**
 * Preload a plugin by instantiating it and firing off the request for the module in the registry
 *
 * @param remotePlugin
 * @param options
 */ var $b60b66eae60db685$var$useRemoteModule = function useRemoteModule(remotePlugin, options) {
    var remoteFrontendSdk = $b60b66eae60db685$var$cacheAndGetSdkForPlugin(remotePlugin);
    (0, $jHxFC.default)(remoteFrontendSdk, options);
    var _useAnalyticsEvents = (0, $145N3.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    (0, $1Mpn7.useEffect)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: "rendered",
            actionSubject: "remoteModule",
            actionSubjectId: "useRemoteModule",
            attributes: {
                dimensions: remotePlugin.dimensions,
                plugin: remotePlugin.constructor.name
            }
        });
        analyticsEvent.fire(options === null || options === void 0 ? void 0 : options.analyticsChannel);
    }, [
        createAnalyticsEvent,
        remotePlugin,
        options === null || options === void 0 ? void 0 : options.analyticsChannel
    ]);
    return remoteFrontendSdk;
};
var $b60b66eae60db685$export$2e2bcd8739ae039 = $b60b66eae60db685$var$useRemoteModule;

});
parcelRegister("S0Njm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a25a9001c441c48$export$2e2bcd8739ae039; });

var $e8dor = parcelRequire("e8dor");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $fGIeY = parcelRequire("fGIeY");

var $1Mpn7 = parcelRequire("1Mpn7");

var $5ZDH2 = parcelRequire("5ZDH2");

var $houh1 = parcelRequire("houh1");

var $dvxry = parcelRequire("dvxry");

var $j5HU8 = parcelRequire("j5HU8");

var $gjSUG = parcelRequire("gjSUG");
function $0a25a9001c441c48$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $0a25a9001c441c48$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $0a25a9001c441c48$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0a25a9001c441c48$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0a25a9001c441c48$var$_arrayLikeToArray(o, minLen);
}
function $0a25a9001c441c48$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $0a25a9001c441c48$var$isRemoteModuleConfig = function isRemoteModuleConfig(config) {
    return (config === null || config === void 0 ? void 0 : config.moduleUri) !== undefined;
};
var $0a25a9001c441c48$var$AtlassianSystemRemoteFrontendSdk = /*#__PURE__*/ function() {
    function AtlassianSystemRemoteFrontendSdk(plugin) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, AtlassianSystemRemoteFrontendSdk);
        // list of remote modules to be imported
        // map of the above modules
        // map of the remote modules that have been fetched
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "resolvedModuleMap", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "storageClient", new (0, $5ZDH2.default)("remote-module-loader-bifrost-override", {
            storageEngine: "sessionStorage"
        }));
        this.plugin = plugin;
        this.importMap = this.findPluginManifest(plugin);
        this.setImportMaps([
            this.importMap
        ]);
    }
    /**
   * Using the dimensions defined in the plugin, search through the manifest and find the most applicable one
   *
   * @param plugin
   * @private
   */ (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(AtlassianSystemRemoteFrontendSdk, [
        {
            key: "findPluginManifest",
            value: function findPluginManifest(plugin) {
                if (plugin) {
                    var manifestMap = plugin.manifestMap, dimensions = plugin.dimensions;
                    var manifestEnv = manifestMap.get(dimensions.env);
                    if (manifestEnv) {
                        // This is not currently allowed in the types but is an escape hatch for not defining any variants
                        if ($0a25a9001c441c48$var$isRemoteModuleConfig(manifestEnv)) return manifestEnv;
                        /**
           * If we request a `latest` dimension, but only have `stable` in our map then we use it.
           * If we request a `stable` dimension, but only have `latest` an error will be thrown due to the variant order.
           */ var variantIndex = (0, $houh1.VARIANT_ORDER).indexOf(dimensions.variant);
                        if (variantIndex > -1) {
                            for(var i = variantIndex; i < (0, $houh1.VARIANT_ORDER).length; i++){
                                var manifestVariant = manifestEnv.get((0, $houh1.VARIANT_ORDER)[i]);
                                if ($0a25a9001c441c48$var$isRemoteModuleConfig(manifestVariant)) {
                                    this.variant = (0, $houh1.VARIANT_ORDER)[i]; // set the variant applied for use later
                                    return manifestVariant;
                                }
                            }
                            throw new Error('No valid "variant" dimensions defined in plugin for ['.concat(dimensions.variant, "]."));
                        }
                        throw new Error('Invalid "variant" dimension defined in plugin for ['.concat(dimensions.variant, "]."));
                    }
                    throw new Error('No "env" dimension defined in plugin for ['.concat(dimensions.env, "]."));
                }
                throw new Error('Invalid "plugin" provided to SDK.');
            }
        },
        {
            key: "getModuleName",
            value: function getModuleName() {
                var importMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.importMap;
                if (importMap) return importMap.moduleName;
                return "";
            }
        },
        {
            key: "loadFromQueryAndSaveToSession",
            value: function loadFromQueryAndSaveToSession(key) {
                try {
                    var params = new URLSearchParams(window.location.search);
                    if (params.has("".concat(key, "-clear"))) {
                        this.storageClient.removeItem(key);
                        return undefined;
                    }
                    if (params.has(key)) {
                        var value = params.get(key);
                        this.storageClient.setItemWithExpiry(key, value, 10800000); // 3 hours
                        return value;
                    } else {
                        var itemStr = this.storageClient.getItem(key);
                        if (!itemStr) return undefined;
                        return itemStr;
                    }
                } catch (error) {
                    console.error("Error loading value from query or sessionStorage: ".concat(error));
                    return undefined;
                }
            }
        },
        {
            key: "addBifrostOverride",
            value: function addBifrostOverride(url) {
                try {
                    var _this$plugin, _this$plugin2;
                    if (!((_this$plugin = this.plugin) !== null && _this$plugin !== void 0 && _this$plugin.bifrostOverrideKey)) return url;
                    var bifrostOverrideValue = this.loadFromQueryAndSaveToSession((_this$plugin2 = this.plugin) === null || _this$plugin2 === void 0 ? void 0 : _this$plugin2.bifrostOverrideKey);
                    if (!bifrostOverrideValue) return url;
                    var urlToUpdate = new URL(url);
                    if (urlToUpdate.protocol === "https:" || urlToUpdate.protocol === "http:") {
                        var inputParams = new URLSearchParams(urlToUpdate.search);
                        inputParams.set("bifrost-override", bifrostOverrideValue);
                        urlToUpdate.search = inputParams.toString();
                    }
                    return urlToUpdate.toString();
                } catch (e) {
                    console.error("Error adding bifrost override to url. Falling back to original url.");
                    return url;
                }
            }
        },
        {
            key: "getModuleUri",
            value: function getModuleUri() {
                var importMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.importMap;
                if (importMap) {
                    var _this$plugin3, _this$plugin4;
                    var moduleUri = importMap.moduleUri;
                    if ((_this$plugin3 = this.plugin) !== null && _this$plugin3 !== void 0 && _this$plugin3.moduleUriMapper) moduleUri = this.plugin.moduleUriMapper(importMap.moduleUri, this.variant, (0, $j5HU8.default));
                    if ((_this$plugin4 = this.plugin) !== null && _this$plugin4 !== void 0 && _this$plugin4.bifrostOverrideKey) moduleUri = this.addBifrostOverride(moduleUri);
                    return moduleUri;
                }
                return "";
            }
        },
        {
            key: "getResolvedModule",
            value: function getResolvedModule() {
                return this.resolvedModuleMap.get(this.getModuleName());
            }
        },
        {
            key: "isModuleRegisteredAndValid",
            value: function isModuleRegisteredAndValid() {
                // a module can appear in the registry as `null` if it fails to load
                return System.has(this.getModuleUri()) && !!System.get(this.getModuleUri()) && !!this.getResolvedModule();
            }
        },
        {
            key: "setImportMaps",
            value: function setImportMaps(importMaps) {
                var _this = this;
                var scopedModules = null;
                try {
                    // Set the external packages into the System registry using the locally resolved (from the Product) packages
                    scopedModules = (0, $gjSUG.setupSystemModules)(importMaps.flatMap(function(item) {
                        return item.externals;
                    }));
                } catch (e) {
                    // TODO add logger
                    console.error(e);
                }
                System.addImportMap(importMaps.reduce(function(acc, item) {
                    var moduleUri = _this.getModuleUri(item);
                    acc.imports[item.moduleName] = moduleUri;
                    if (scopedModules && item.externals.length) {
                        acc.scopes[moduleUri] = {};
                        var _iterator = $0a25a9001c441c48$var$_createForOfIteratorHelper(item.externals), _step;
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                var external = _step.value;
                                acc.scopes[moduleUri][external.name] = scopedModules[external.name];
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                    }
                    return acc;
                }, {
                    imports: {},
                    scopes: {}
                }));
            }
        },
        {
            key: "fetchModule",
            value: function() {
                var _fetchModule = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee() {
                    var moduleName, module;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!this.importMap) {
                                    _context.next = 7;
                                    break;
                                }
                                moduleName = this.importMap.moduleName;
                                _context.next = 4;
                                return (0, $dvxry.remoteImport)(moduleName);
                            case 4:
                                module = _context.sent;
                                this.resolvedModuleMap.set(moduleName, module);
                                return _context.abrupt("return", module);
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function fetchModule() {
                    return _fetchModule.apply(this, arguments);
                }
                return fetchModule;
            }()
        },
        {
            key: "resolveExport",
            value: function resolveExport(exportName) {
                var resolvedModule = this.getResolvedModule();
                if (resolvedModule) {
                    if (exportName) return resolvedModule[exportName];
                    return resolvedModule;
                }
            }
        },
        {
            key: "renderComponent",
            value: function renderComponent() {
                var exportName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
                var props = arguments.length > 1 ? arguments[1] : undefined;
                var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                var component = this.resolveExport(exportName);
                if (component) {
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).isValidElement(component)) {
                        if (props) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).cloneElement(component, props, children);
                        return component;
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement(component, props, children);
                }
                return fallback;
            }
        }
    ]);
    return AtlassianSystemRemoteFrontendSdk;
}();
var $0a25a9001c441c48$export$2e2bcd8739ae039 = $0a25a9001c441c48$var$AtlassianSystemRemoteFrontendSdk;

});
parcelRegister("5ZDH2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45d1708108dae005$export$2e2bcd8739ae039; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $6R3pa = parcelRequire("6R3pa");
var $45d1708108dae005$var$DEFAULT_STORAGE_ENGINE = "localStorage";
var $45d1708108dae005$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function StorageClient(clientKey, options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, StorageClient);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getItem", function(key) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                useExpiredItem: false
            }, useExpiredItem = _ref.useExpiredItem;
            var item = _this.client.getItem(_this.itemKey(key));
            if (item) try {
                var parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
             * Commented out removing this item, as it is a slightly different state
             * to the item not existing that we may want to preserve.
             *  this.client.removeItem(this.itemKey(key));
             */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                _this.captureException(e);
            }
            return undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "removeItem", function(key) {
            try {
                _this.client.removeItem(_this.itemKey(key));
            } catch (e) {
                _this.captureException(e);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setItemWithExpiry", function(key, value, expireInMS) {
            var itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === "number" ? Date.now() + expireInMS : undefined
            };
            try {
                _this.client.setItem(_this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                _this.captureException(e);
            }
        });
        this.clientKey = clientKey;
        this.handlers = options === null || options === void 0 ? void 0 : options.handlers;
        var storageEngine = (options === null || options === void 0 ? void 0 : options.storageEngine) || $45d1708108dae005$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $6R3pa.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(StorageClient, [
        {
            key: "captureException",
            value: function captureException(e, tags) {
                var _this$handlers;
                if ((_this$handlers = this.handlers) !== null && _this$handlers !== void 0 && _this$handlers.captureException) {
                    var _this$handlers2;
                    (_this$handlers2 = this.handlers) === null || _this$handlers2 === void 0 || _this$handlers2.captureException(e, tags);
                }
            }
        },
        {
            key: "itemKey",
            value: function itemKey(key) {
                return "".concat(this.clientKey, "_").concat(key);
            }
        }
    ]);
    return StorageClient;
}();

});
parcelRegister("6R3pa", function(module, exports) {

$parcel$export(module.exports, "mockWindowStorage", function () { return $4fda557acb67a69f$export$efebfe7859cae3c7; });

var $jjExS = parcelRequire("jjExS");
function $4fda557acb67a69f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4fda557acb67a69f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4fda557acb67a69f$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4fda557acb67a69f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4fda557acb67a69f$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $4fda557acb67a69f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $4fda557acb67a69f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4fda557acb67a69f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4fda557acb67a69f$var$_arrayLikeToArray(o, minLen);
}
function $4fda557acb67a69f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $4fda557acb67a69f$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function setItem(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function getItem(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function removeItem(id) {
        return delete this._data[id];
    },
    clear: function clear() {
        return this._data = {};
    },
    key: function key(index) {
        return Object.keys(this._data)[index];
    }
};
var $4fda557acb67a69f$export$efebfe7859cae3c7 = function mockWindowStorage() {
    var storageToMock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
        "localStorage",
        "sessionStorage"
    ];
    var _iterator = $4fda557acb67a69f$var$_createForOfIteratorHelper(storageToMock), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var storageToMockElement = _step.value;
            Object.defineProperty(window, storageToMockElement, {
                value: $4fda557acb67a69f$var$_objectSpread({}, $4fda557acb67a69f$export$c65e688d8b365035),
                configurable: true
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
};

});


parcelRegister("houh1", function(module, exports) {

$parcel$export(module.exports, "VARIANT_ORDER", function () { return $ca9c293c3097ab17$export$5672934650c3eabe; });
$parcel$export(module.exports, "MODULE_NAMESPACE_ALIAS", function () { return $ca9c293c3097ab17$export$f694cbd102849bb9; });
/**
 * If we request a `latest` dimension, but only have `stable` in our map then we use it.
 * If we request a `stable` dimension, but only have `latest` an error will be thrown due to the variant order.
 */ var $ca9c293c3097ab17$export$5672934650c3eabe = [
    "latest",
    "stable"
];
var $ca9c293c3097ab17$export$f694cbd102849bb9 = "app-switcher";

});

parcelRegister("dvxry", function(module, exports) {

$parcel$export(module.exports, "remoteImport", function () { return $9d581cc2a389a215$export$1117267eb6098dcd; });

var $e8dor = parcelRequire("e8dor");

var $fGIeY = parcelRequire("fGIeY");
var $9d581cc2a389a215$export$1117267eb6098dcd = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(moduleName) {
        var res;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return System.import(moduleName);
                case 2:
                    res = _context.sent;
                    return _context.abrupt("return", res);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function remoteImport(_x) {
        return _ref.apply(this, arguments);
    };
}();

});

parcelRegister("j5HU8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de608a6eb464c18f$export$2e2bcd8739ae039; });

var $5dhWj = parcelRequire("5dhWj");
/**
 * We generate a hash from a specified name, and optional list of dependencies
 * to be used for a computed filename.
 *
 * This is done so that a specific bundle can be hashed according to specific dependencies so that when they
 * are updated. We deliver a specific file for that combination.
 *
 * @param name
 * @param dependencyMap
 */ var $de608a6eb464c18f$var$generateHash = function generateHash(name) {
    var dependencyMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var stringToHash = name + JSON.stringify(dependencyMap.sort(function(a, b) {
        return (a.name + a.version).localeCompare(b.name + b.version);
    }));
    return (0, $5dhWj.simpleHash)(stringToHash);
};
var $de608a6eb464c18f$export$2e2bcd8739ae039 = $de608a6eb464c18f$var$generateHash;

});
parcelRegister("5dhWj", function(module, exports) {

$parcel$export(module.exports, "simpleHash", function () { return $3cbc15118a68a7f1$export$b211ce59c0ea1cfb; });
var $3cbc15118a68a7f1$export$b211ce59c0ea1cfb = function simpleHash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("gjSUG", function(module, exports) {

$parcel$export(module.exports, "setupSystemModules", function () { return $be19044c8ba2167b$export$5d60344e1be8d663; });

var $jjExS = parcelRequire("jjExS");

var $houh1 = parcelRequire("houh1");
function $be19044c8ba2167b$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $be19044c8ba2167b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $be19044c8ba2167b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $be19044c8ba2167b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $be19044c8ba2167b$var$_arrayLikeToArray(o, minLen);
}
function $be19044c8ba2167b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $be19044c8ba2167b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $be19044c8ba2167b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $be19044c8ba2167b$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $be19044c8ba2167b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
parcelRequire("d0Pdj");




var $be19044c8ba2167b$export$5d60344e1be8d663 = function setupSystemModules(modulesToLoad) {
    if (modulesToLoad.length > 0) {
        var systemModulesToSet = modulesToLoad.map(function(module) {
            switch(module.name){
                case "react":
                    return {
                        module: module.name,
                        import: (parcelRequire("1Mpn7")),
                        // require cannot be dynamic. It needs to be a known value at build time
                        isDefault: true // it appears that modules with defaults NEED this, and it won't affect modules without defaults
                    };
                case "react-dom":
                    return {
                        module: module.name,
                        import: (parcelRequire("eP3xl")),
                        isDefault: true
                    };
                case "react-intl-next":
                    return {
                        module: module.name,
                        import: (parcelRequire("2ljoN")),
                        isDefault: true
                    };
                case "@emotion/react":
                    return {
                        module: module.name,
                        import: (parcelRequire("fBy54")),
                        isDefault: false
                    };
            }
            console.error("Excluded system module [".concat(module.name, "] must be setup inside '/remote-setup/index.ts'. Modules cannot be excluded and required dynamically."));
            return {
                module: module.name,
                import: undefined,
                isDefault: false
            };
        });
        // set them into the ImportMap scopes to ensure that they aren't available to other modules doing similar things
        var scopedModules = systemModulesToSet.reduce(function(acc, entry) {
            if (!entry.import) return acc;
            return $be19044c8ba2167b$var$_objectSpread($be19044c8ba2167b$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, entry.module, [
                (0, $houh1.MODULE_NAMESPACE_ALIAS),
                entry.module
            ].join(":")));
        }, {});
        var _iterator = $be19044c8ba2167b$var$_createForOfIteratorHelper(systemModulesToSet), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.import) {
                    // add the entry into the SystemJS registry so that it can be shared using a module-map
                    // entry.isDefault could be set to always true, it doesn't appear to impact modules without defaults, but have kept the alternate in case
                    if (entry.isDefault) System.set(scopedModules[entry.module], $be19044c8ba2167b$var$_objectSpread($be19044c8ba2167b$var$_objectSpread({}, entry.import), {}, {
                        default: entry.import,
                        __useDefault: true
                    }));
                    else System.set(scopedModules[entry.module], entry.import);
                } else console.error("Unable to set import for module [".concat(entry.module, "]. Please ensure it has been installed and is available."));
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return scopedModules;
    }
    return null;
};

});
parcelRegister("d0Pdj", function(module, exports) {
/*!
 * SystemJS 6.14.2
 */ (function() {
    function errMsg(errCode, msg) {
        return (msg || "") + " (SystemJS Error#" + errCode + " " + "https://github.com/systemjs/systemjs/blob/main/docs/errors.md#" + errCode + ")";
    }
    var hasSymbol = typeof Symbol !== "undefined";
    var hasSelf = typeof self !== "undefined";
    var hasDocument = typeof document !== "undefined";
    var envGlobal = hasSelf ? self : $parcel$global;
    var baseUrl;
    if (hasDocument) {
        var baseEl = document.querySelector("base[href]");
        if (baseEl) baseUrl = baseEl.href;
    }
    if (!baseUrl && typeof location !== "undefined") {
        baseUrl = location.href.split("#")[0].split("?")[0];
        var lastSepIndex = baseUrl.lastIndexOf("/");
        if (lastSepIndex !== -1) baseUrl = baseUrl.slice(0, lastSepIndex + 1);
    }
    var backslashRegEx = /\\/g;
    function resolveIfNotPlainOrUrl(relUrl, parentUrl) {
        if (relUrl.indexOf("\\") !== -1) relUrl = relUrl.replace(backslashRegEx, "/");
        // protocol-relative
        if (relUrl[0] === "/" && relUrl[1] === "/") return parentUrl.slice(0, parentUrl.indexOf(":") + 1) + relUrl;
        else if (relUrl[0] === "." && (relUrl[1] === "/" || relUrl[1] === "." && (relUrl[2] === "/" || relUrl.length === 2 && (relUrl += "/")) || relUrl.length === 1 && (relUrl += "/")) || relUrl[0] === "/") {
            var parentProtocol = parentUrl.slice(0, parentUrl.indexOf(":") + 1);
            // Disabled, but these cases will give inconsistent results for deep backtracking
            //if (parentUrl[parentProtocol.length] !== '/')
            //  throw Error('Cannot resolve');
            // read pathname from parent URL
            // pathname taken to be part after leading "/"
            var pathname;
            if (parentUrl[parentProtocol.length + 1] === "/") {
                // resolving to a :// so we need to read out the auth and host
                if (parentProtocol !== "file:") {
                    pathname = parentUrl.slice(parentProtocol.length + 2);
                    pathname = pathname.slice(pathname.indexOf("/") + 1);
                } else pathname = parentUrl.slice(8);
            } else // resolving to :/ so pathname is the /... part
            pathname = parentUrl.slice(parentProtocol.length + (parentUrl[parentProtocol.length] === "/"));
            if (relUrl[0] === "/") return parentUrl.slice(0, parentUrl.length - pathname.length - 1) + relUrl;
            // join together and split for removal of .. and . segments
            // looping the string instead of anything fancy for perf reasons
            // '../../../../../z' resolved to 'x/y' is just 'z'
            var segmented = pathname.slice(0, pathname.lastIndexOf("/") + 1) + relUrl;
            var output = [];
            var segmentIndex = -1;
            for(var i = 0; i < segmented.length; i++){
                // busy reading a segment - only terminate on '/'
                if (segmentIndex !== -1) {
                    if (segmented[i] === "/") {
                        output.push(segmented.slice(segmentIndex, i + 1));
                        segmentIndex = -1;
                    }
                } else if (segmented[i] === ".") {
                    // ../ segment
                    if (segmented[i + 1] === "." && (segmented[i + 2] === "/" || i + 2 === segmented.length)) {
                        output.pop();
                        i += 2;
                    } else if (segmented[i + 1] === "/" || i + 1 === segmented.length) i += 1;
                    else // the start of a new segment as below
                    segmentIndex = i;
                } else segmentIndex = i;
            }
            // finish reading out the last segment
            if (segmentIndex !== -1) output.push(segmented.slice(segmentIndex));
            return parentUrl.slice(0, parentUrl.length - pathname.length) + output.join("");
        }
    }
    /*
   * Import maps implementation
   *
   * To make lookups fast we pre-resolve the entire import map
   * and then match based on backtracked hash lookups
   *
   */ function resolveUrl(relUrl, parentUrl) {
        return resolveIfNotPlainOrUrl(relUrl, parentUrl) || (relUrl.indexOf(":") !== -1 ? relUrl : resolveIfNotPlainOrUrl("./" + relUrl, parentUrl));
    }
    function resolveAndComposePackages(packages, outPackages, baseUrl, parentMap, parentUrl) {
        for(var p in packages){
            var resolvedLhs = resolveIfNotPlainOrUrl(p, baseUrl) || p;
            var rhs = packages[p];
            // package fallbacks not currently supported
            if (typeof rhs !== "string") continue;
            var mapped = resolveImportMap(parentMap, resolveIfNotPlainOrUrl(rhs, baseUrl) || rhs, parentUrl);
            if (!mapped) targetWarning("W1", p, rhs, "bare specifier did not resolve");
            else outPackages[resolvedLhs] = mapped;
        }
    }
    function resolveAndComposeImportMap(json, baseUrl, outMap) {
        if (json.imports) resolveAndComposePackages(json.imports, outMap.imports, baseUrl, outMap, null);
        var u;
        for(u in json.scopes || {}){
            var resolvedScope = resolveUrl(u, baseUrl);
            resolveAndComposePackages(json.scopes[u], outMap.scopes[resolvedScope] || (outMap.scopes[resolvedScope] = {}), baseUrl, outMap, resolvedScope);
        }
        for(u in json.depcache || {})outMap.depcache[resolveUrl(u, baseUrl)] = json.depcache[u];
        for(u in json.integrity || {})outMap.integrity[resolveUrl(u, baseUrl)] = json.integrity[u];
    }
    function getMatch(path, matchObj) {
        if (matchObj[path]) return path;
        var sepIndex = path.length;
        do {
            var segment = path.slice(0, sepIndex + 1);
            if (segment in matchObj) return segment;
        }while ((sepIndex = path.lastIndexOf("/", sepIndex - 1)) !== -1);
    }
    function applyPackages(id, packages) {
        var pkgName = getMatch(id, packages);
        if (pkgName) {
            var pkg = packages[pkgName];
            if (pkg === null) return;
            if (id.length > pkgName.length && pkg[pkg.length - 1] !== "/") targetWarning("W2", pkgName, pkg, "should have a trailing '/'");
            else return pkg + id.slice(pkgName.length);
        }
    }
    function targetWarning(code, match, target, msg) {
        console.warn(errMsg(code, "Package target " + msg + ", resolving target '" + target + "' for " + match));
    }
    function resolveImportMap(importMap, resolvedOrPlain, parentUrl) {
        var scopes = importMap.scopes;
        var scopeUrl = parentUrl && getMatch(parentUrl, scopes);
        while(scopeUrl){
            var packageResolution = applyPackages(resolvedOrPlain, scopes[scopeUrl]);
            if (packageResolution) return packageResolution;
            scopeUrl = getMatch(scopeUrl.slice(0, scopeUrl.lastIndexOf("/")), scopes);
        }
        return applyPackages(resolvedOrPlain, importMap.imports) || resolvedOrPlain.indexOf(":") !== -1 && resolvedOrPlain;
    }
    /*
   * SystemJS Core
   *
   * Provides
   * - System.import
   * - System.register support for
   *     live bindings, function hoisting through circular references,
   *     reexports, dynamic import, import.meta.url, top-level await
   * - System.getRegister to get the registration
   * - Symbol.toStringTag support in Module objects
   * - Hookable System.createContext to customize import.meta
   * - System.onload(err, id, deps) handler for tracing / hot-reloading
   *
   * Core comes with no System.prototype.resolve or
   * System.prototype.instantiate implementations
   */ var toStringTag$1 = hasSymbol && Symbol.toStringTag;
    var REGISTRY = hasSymbol ? Symbol() : "@";
    function SystemJS() {
        this[REGISTRY] = {};
    }
    var systemJSPrototype = SystemJS.prototype;
    systemJSPrototype.import = function(id, parentUrl, meta) {
        var loader = this;
        parentUrl && typeof parentUrl === "object" && (meta = parentUrl, parentUrl = undefined);
        return Promise.resolve(loader.prepareImport()).then(function() {
            return loader.resolve(id, parentUrl, meta);
        }).then(function(id) {
            var load = getOrCreateLoad(loader, id, undefined, meta);
            return load.C || topLevelLoad(loader, load);
        });
    };
    // Hookable createContext function -> allowing eg custom import meta
    systemJSPrototype.createContext = function(parentId) {
        var loader = this;
        return {
            url: parentId,
            resolve: function resolve(id, parentUrl) {
                return Promise.resolve(loader.resolve(id, parentUrl || parentId));
            }
        };
    };
    // onLoad(err, id, deps) provided for tracing / hot-reloading
    systemJSPrototype.onload = function() {};
    function loadToId(load) {
        return load.id;
    }
    function triggerOnload(loader, load, err, isErrSource) {
        loader.onload(err, load.id, load.d && load.d.map(loadToId), !!isErrSource);
        if (err) throw err;
    }
    var lastRegister;
    systemJSPrototype.register = function(deps, declare, metas) {
        lastRegister = [
            deps,
            declare,
            metas
        ];
    };
    /*
   * getRegister provides the last anonymous System.register call
   */ systemJSPrototype.getRegister = function() {
        var _lastRegister = lastRegister;
        lastRegister = undefined;
        return _lastRegister;
    };
    function getOrCreateLoad(loader, id, firstParentUrl, meta) {
        var load = loader[REGISTRY][id];
        if (load) return load;
        var importerSetters = [];
        var ns = Object.create(null);
        if (toStringTag$1) Object.defineProperty(ns, toStringTag$1, {
            value: "Module"
        });
        var instantiatePromise = Promise.resolve().then(function() {
            return loader.instantiate(id, firstParentUrl, meta);
        }).then(function(registration) {
            if (!registration) throw Error(errMsg(2, "Module " + id + " did not instantiate"));
            function _export(name, value) {
                // note if we have hoisted exports (including reexports)
                load.h = true;
                var changed = false;
                if (typeof name === "string") {
                    if (!(name in ns) || ns[name] !== value) {
                        ns[name] = value;
                        changed = true;
                    }
                } else {
                    for(var p in name){
                        var value = name[p];
                        if (!(p in ns) || ns[p] !== value) {
                            ns[p] = value;
                            changed = true;
                        }
                    }
                    if (name && name.__esModule) ns.__esModule = name.__esModule;
                }
                if (changed) for(var i = 0; i < importerSetters.length; i++){
                    var setter = importerSetters[i];
                    if (setter) setter(ns);
                }
                return value;
            }
            var declared = registration[1](_export, registration[1].length === 2 ? {
                import: function _import(importId, meta) {
                    return loader.import(importId, id, meta);
                },
                meta: loader.createContext(id)
            } : undefined);
            load.e = declared.execute || function() {};
            return [
                registration[0],
                declared.setters || [],
                registration[2] || []
            ];
        }, function(err) {
            load.e = null;
            load.er = err;
            triggerOnload(loader, load, err, true);
            throw err;
        });
        var linkPromise = instantiatePromise.then(function(instantiation) {
            return Promise.all(instantiation[0].map(function(dep, i) {
                var setter = instantiation[1][i];
                var _$meta = instantiation[2][i];
                return Promise.resolve(loader.resolve(dep, id)).then(function(depId) {
                    var depLoad = getOrCreateLoad(loader, depId, id, _$meta);
                    // depLoad.I may be undefined for already-evaluated
                    return Promise.resolve(depLoad.I).then(function() {
                        if (setter) {
                            depLoad.i.push(setter);
                            // only run early setters when there are hoisted exports of that module
                            // the timing works here as pending hoisted export calls will trigger through importerSetters
                            if (depLoad.h || !depLoad.I) setter(depLoad.n);
                        }
                        return depLoad;
                    });
                });
            })).then(function(depLoads) {
                load.d = depLoads;
            });
        });
        // Capital letter = a promise function
        return load = loader[REGISTRY][id] = {
            id: id,
            // importerSetters, the setters functions registered to this dependency
            // we retain this to add more later
            i: importerSetters,
            // module namespace object
            n: ns,
            // extra module information for import assertion
            // shape like: { assert: { type: 'xyz' } }
            m: meta,
            // instantiate
            I: instantiatePromise,
            // link
            L: linkPromise,
            // whether it has hoisted exports
            h: false,
            // On instantiate completion we have populated:
            // dependency load records
            d: undefined,
            // execution function
            e: undefined,
            // On execution we have populated:
            // the execution error if any
            er: undefined,
            // in the case of TLA, the execution promise
            E: undefined,
            // On execution, L, I, E cleared
            // Promise for top-level completion
            C: undefined,
            // parent instantiator / executor
            p: undefined
        };
    }
    function instantiateAll(loader, load, parent, loaded) {
        if (!loaded[load.id]) {
            loaded[load.id] = true;
            // load.L may be undefined for already-instantiated
            return Promise.resolve(load.L).then(function() {
                if (!load.p || load.p.e === null) load.p = parent;
                return Promise.all(load.d.map(function(dep) {
                    return instantiateAll(loader, dep, parent, loaded);
                }));
            }).catch(function(err) {
                if (load.er) throw err;
                load.e = null;
                triggerOnload(loader, load, err, false);
                throw err;
            });
        }
    }
    function topLevelLoad(loader, load) {
        return load.C = instantiateAll(loader, load, load, {}).then(function() {
            return postOrderExec(loader, load, {});
        }).then(function() {
            return load.n;
        });
    }
    // the closest we can get to call(undefined)
    var nullContext = Object.freeze(Object.create(null));
    // returns a promise if and only if a top-level await subgraph
    // throws on sync errors
    function postOrderExec(loader, load, seen) {
        if (seen[load.id]) return;
        seen[load.id] = true;
        if (!load.e) {
            if (load.er) throw load.er;
            if (load.E) return load.E;
            return;
        }
        // From here we're about to execute the load.
        // Because the execution may be async, we pop the `load.e` first.
        // So `load.e === null` always means the load has been executed or is executing.
        // To inspect the state:
        // - If `load.er` is truthy, the execution has threw or has been rejected;
        // - otherwise, either the `load.E` is a promise, means it's under async execution, or
        // - the `load.E` is null, means the load has completed the execution or has been async resolved.
        var exec = load.e;
        load.e = null;
        // deps execute first, unless circular
        var depLoadPromises;
        load.d.forEach(function(depLoad) {
            try {
                var depLoadPromise = postOrderExec(loader, depLoad, seen);
                if (depLoadPromise) (depLoadPromises = depLoadPromises || []).push(depLoadPromise);
            } catch (err) {
                load.er = err;
                triggerOnload(loader, load, err, false);
                throw err;
            }
        });
        if (depLoadPromises) return Promise.all(depLoadPromises).then(doExec);
        return doExec();
        function doExec() {
            try {
                var execPromise = exec.call(nullContext);
                if (execPromise) {
                    execPromise = execPromise.then(function() {
                        load.C = load.n;
                        load.E = null; // indicates completion
                        triggerOnload(loader, load, null, true);
                    }, function(err) {
                        load.er = err;
                        load.E = null;
                        triggerOnload(loader, load, err, true);
                        throw err;
                    });
                    return load.E = execPromise;
                }
                // (should be a promise, but a minify optimization to leave out Promise.resolve)
                load.C = load.n;
                load.L = load.I = undefined;
            } catch (err) {
                load.er = err;
                throw err;
            } finally{
                triggerOnload(loader, load, load.er, true);
            }
        }
    }
    envGlobal.System = new SystemJS();
    /*
   * SystemJS browser attachments for script and import map processing
   */ var importMapPromise = Promise.resolve();
    var importMap = {
        imports: {},
        scopes: {},
        depcache: {},
        integrity: {}
    };
    // Scripts are processed immediately, on the first System.import, and on DOMReady.
    // Import map scripts are processed only once (by being marked) and in order for each phase.
    // This is to avoid using DOM mutation observers in core, although that would be an alternative.
    var processFirst = hasDocument;
    systemJSPrototype.prepareImport = function(doProcessScripts) {
        if (processFirst || doProcessScripts) {
            processScripts();
            processFirst = false;
        }
        return importMapPromise;
    };
    if (hasDocument) {
        processScripts();
        window.addEventListener("DOMContentLoaded", processScripts);
    }
    systemJSPrototype.addImportMap = function(newMap, mapBase) {
        resolveAndComposeImportMap(newMap, mapBase || baseUrl, importMap);
    };
    function processScripts() {
        [].forEach.call(document.querySelectorAll("script"), function(script) {
            if (script.sp) return;
            // TODO: deprecate systemjs-module in next major now that we have auto import
            if (script.type === "systemjs-module") {
                script.sp = true;
                if (!script.src) return;
                System.import(script.src.slice(0, 7) === "import:" ? script.src.slice(7) : resolveUrl(script.src, baseUrl)).catch(function(e) {
                    // if there is a script load error, dispatch an "error" event
                    // on the script tag.
                    if (e.message.indexOf("https://github.com/systemjs/systemjs/blob/main/docs/errors.md#3") > -1) {
                        var event = document.createEvent("Event");
                        event.initEvent("error", false, false);
                        script.dispatchEvent(event);
                    }
                    return Promise.reject(e);
                });
            } else if (script.type === "systemjs-importmap") {
                script.sp = true;
                // The passThrough property is for letting the module types fetch implementation know that this is not a SystemJS module.
                var fetchPromise = script.src ? (System.fetch || fetch)(script.src, {
                    integrity: script.integrity,
                    passThrough: true
                }).then(function(res) {
                    if (!res.ok) throw Error("Invalid status code: " + res.status);
                    return res.text();
                }).catch(function(err) {
                    err.message = errMsg("W4", "Error fetching systemjs-import map " + script.src) + "\n" + err.message;
                    console.warn(err);
                    if (typeof script.onerror === "function") script.onerror();
                    return "{}";
                }) : script.innerHTML;
                importMapPromise = importMapPromise.then(function() {
                    return fetchPromise;
                }).then(function(text) {
                    extendImportMap(importMap, text, script.src || baseUrl);
                });
            }
        });
    }
    function extendImportMap(importMap, newMapText, newMapUrl) {
        var newMap = {};
        try {
            newMap = JSON.parse(newMapText);
        } catch (err) {
            console.warn(Error(errMsg("W5", "systemjs-importmap contains invalid JSON") + "\n\n" + newMapText + "\n"));
        }
        resolveAndComposeImportMap(newMap, newMapUrl, importMap);
    }
    /*
   * Script instantiation loading
   */ if (hasDocument) {
        window.addEventListener("error", function(evt) {
            lastWindowErrorUrl = evt.filename;
            lastWindowError = evt.error;
        });
        var baseOrigin = location.origin;
    }
    systemJSPrototype.createScript = function(url) {
        var script = document.createElement("script");
        script.async = true;
        // Only add cross origin for actual cross origin
        // this is because Safari triggers for all
        // - https://bugs.webkit.org/show_bug.cgi?id=171566
        if (url.indexOf(baseOrigin + "/")) script.crossOrigin = "anonymous";
        var integrity = importMap.integrity[url];
        if (integrity) script.integrity = integrity;
        script.src = url;
        return script;
    };
    // Auto imports -> script tags can be inlined directly for load phase
    var lastAutoImportDeps, lastAutoImportTimeout;
    var autoImportCandidates = {};
    var systemRegister = systemJSPrototype.register;
    systemJSPrototype.register = function(deps, declare) {
        if (hasDocument && document.readyState === "loading" && typeof deps !== "string") {
            var scripts = document.querySelectorAll("script[src]");
            var lastScript = scripts[scripts.length - 1];
            if (lastScript) {
                lastScript.src;
                lastAutoImportDeps = deps;
                // if this is already a System load, then the instantiate has already begun
                // so this re-import has no consequence
                var loader = this;
                lastAutoImportTimeout = setTimeout(function() {
                    autoImportCandidates[lastScript.src] = [
                        deps,
                        declare
                    ];
                    loader.import(lastScript.src);
                });
            }
        } else lastAutoImportDeps = undefined;
        return systemRegister.call(this, deps, declare);
    };
    var lastWindowErrorUrl, lastWindowError;
    systemJSPrototype.instantiate = function(url, firstParentUrl) {
        var autoImportRegistration = autoImportCandidates[url];
        if (autoImportRegistration) {
            delete autoImportCandidates[url];
            return autoImportRegistration;
        }
        var loader = this;
        return Promise.resolve(systemJSPrototype.createScript(url)).then(function(script) {
            return new Promise(function(resolve, reject) {
                script.addEventListener("error", function() {
                    reject(Error(errMsg(3, "Error loading " + url + (firstParentUrl ? " from " + firstParentUrl : ""))));
                });
                script.addEventListener("load", function() {
                    document.head.removeChild(script);
                    // Note that if an error occurs that isn't caught by this if statement,
                    // that getRegister will return null and a "did not instantiate" error will be thrown.
                    if (lastWindowErrorUrl === url) reject(lastWindowError);
                    else {
                        var register = loader.getRegister(url);
                        // Clear any auto import registration for dynamic import scripts during load
                        if (register && register[0] === lastAutoImportDeps) clearTimeout(lastAutoImportTimeout);
                        resolve(register);
                    }
                });
                document.head.appendChild(script);
            });
        });
    };
    /*
   * Fetch loader, sets up shouldFetch and fetch hooks
   */ systemJSPrototype.shouldFetch = function() {
        return false;
    };
    if (typeof fetch !== "undefined") systemJSPrototype.fetch = fetch;
    var instantiate = systemJSPrototype.instantiate;
    var jsContentTypeRegEx = /^(text|application)\/(x-)?javascript(;|$)/;
    systemJSPrototype.instantiate = function(url, parent, meta) {
        var loader = this;
        if (!this.shouldFetch(url, parent, meta)) return instantiate.apply(this, arguments);
        return this.fetch(url, {
            credentials: "same-origin",
            integrity: importMap.integrity[url],
            meta: meta
        }).then(function(res) {
            if (!res.ok) throw Error(errMsg(7, res.status + " " + res.statusText + ", loading " + url + (parent ? " from " + parent : "")));
            var contentType = res.headers.get("content-type");
            if (!contentType || !jsContentTypeRegEx.test(contentType)) throw Error(errMsg(4, 'Unknown Content-Type "' + contentType + '", loading ' + url + (parent ? " from " + parent : "")));
            return res.text().then(function(source) {
                if (source.indexOf("//# sourceURL=") < 0) source += "\n//# sourceURL=" + url;
                (0, eval)(source);
                return loader.getRegister(url);
            });
        });
    };
    systemJSPrototype.resolve = function(id, parentUrl) {
        parentUrl = parentUrl || false || baseUrl;
        return resolveImportMap(importMap, resolveIfNotPlainOrUrl(id, parentUrl) || id, parentUrl) || throwUnresolved(id, parentUrl);
    };
    function throwUnresolved(id, parentUrl) {
        throw Error(errMsg(8, "Unable to resolve bare specifier '" + id + (parentUrl ? "' from " + parentUrl : "'")));
    }
    var systemInstantiate = systemJSPrototype.instantiate;
    systemJSPrototype.instantiate = function(url, firstParentUrl, meta) {
        var preloads = importMap.depcache[url];
        if (preloads) for(var i = 0; i < preloads.length; i++)getOrCreateLoad(this, this.resolve(preloads[i], url), url);
        return systemInstantiate.call(this, url, firstParentUrl, meta);
    };
    /*
   * Supports loading System.register in workers
   */ if (hasSelf && typeof importScripts === "function") systemJSPrototype.instantiate = function(url) {
        var loader = this;
        return Promise.resolve().then(function() {
            importScripts(url);
            return loader.getRegister(url);
        });
    };
    /*
   * SystemJS global script loading support
   * Extra for the s.js build only
   * (Included by default in system.js build)
   */ (function(global1) {
        var systemJSPrototype = global1.System.constructor.prototype;
        // safari unpredictably lists some new globals first or second in object order
        var firstGlobalProp, secondGlobalProp, lastGlobalProp;
        function getGlobalProp(useFirstGlobalProp) {
            var cnt = 0;
            var foundLastProp, result;
            for(var p in global1){
                // do not check frames cause it could be removed during import
                if (shouldSkipProperty(p)) continue;
                if (cnt === 0 && p !== firstGlobalProp || cnt === 1 && p !== secondGlobalProp) return p;
                if (foundLastProp) {
                    lastGlobalProp = p;
                    result = useFirstGlobalProp && result || p;
                } else foundLastProp = p === lastGlobalProp;
                cnt++;
            }
            return result;
        }
        function noteGlobalProps() {
            // alternatively Object.keys(global).pop()
            // but this may be faster (pending benchmarks)
            firstGlobalProp = secondGlobalProp = undefined;
            for(var p in global1){
                // do not check frames cause it could be removed during import
                if (shouldSkipProperty(p)) continue;
                if (!firstGlobalProp) firstGlobalProp = p;
                else if (!secondGlobalProp) secondGlobalProp = p;
                lastGlobalProp = p;
            }
            return lastGlobalProp;
        }
        var impt = systemJSPrototype.import;
        systemJSPrototype.import = function(id, parentUrl, meta) {
            noteGlobalProps();
            return impt.call(this, id, parentUrl, meta);
        };
        var emptyInstantiation = [
            [],
            function() {
                return {};
            }
        ];
        var getRegister = systemJSPrototype.getRegister;
        systemJSPrototype.getRegister = function() {
            var lastRegister = getRegister.call(this);
            if (lastRegister) return lastRegister;
            // no registration -> attempt a global detection as difference from snapshot
            // when multiple globals, we take the global value to be the last defined new global object property
            // for performance, this will not support multi-version / global collisions as previous SystemJS versions did
            // note in Edge, deleting and re-adding a global does not change its ordering
            var globalProp = getGlobalProp(this.firstGlobalProp);
            if (!globalProp) return emptyInstantiation;
            var globalExport;
            try {
                globalExport = global1[globalProp];
            } catch (e) {
                return emptyInstantiation;
            }
            return [
                [],
                function(_export) {
                    return {
                        execute: function execute() {
                            _export(globalExport);
                            _export({
                                default: globalExport,
                                __useDefault: true
                            });
                        }
                    };
                }
            ];
        };
        var isIE11 = typeof navigator !== "undefined" && navigator.userAgent.indexOf("Trident") !== -1;
        function shouldSkipProperty(p) {
            return !global1.hasOwnProperty(p) || !isNaN(p) && p < global1.length || isIE11 && global1[p] && typeof window !== "undefined" && global1[p].parent === window;
        }
    })(typeof self !== "undefined" ? self : $parcel$global);
    /*
   * Loads JSON, CSS, Wasm module types based on file extension
   * filters and content type verifications
   */ (function(global1) {
        var systemJSPrototype = global1.System.constructor.prototype;
        var moduleTypesRegEx = /^[^#?]+\.(css|html|json|wasm)([?#].*)?$/;
        var _shouldFetch = systemJSPrototype.shouldFetch.bind(systemJSPrototype);
        systemJSPrototype.shouldFetch = function(url) {
            return _shouldFetch(url) || moduleTypesRegEx.test(url);
        };
        var jsonContentType = /^application\/json(;|$)/;
        var cssContentType = /^text\/css(;|$)/;
        var wasmContentType = /^application\/wasm(;|$)/;
        var _$fetch = systemJSPrototype.fetch;
        systemJSPrototype.fetch = function(url, options) {
            return _$fetch(url, options).then(function(res) {
                if (options.passThrough) return res;
                if (!res.ok) return res;
                var contentType = res.headers.get("content-type");
                if (jsonContentType.test(contentType)) return res.json().then(function(json) {
                    return new Response(new Blob([
                        'System.register([],function(e){return{execute:function(){e("default",' + JSON.stringify(json) + ")}}})"
                    ], {
                        type: "application/javascript"
                    }));
                });
                if (cssContentType.test(contentType)) return res.text().then(function(source) {
                    source = source.replace(/url\(\s*(?:(["'])((?:\\.|[^\n\\"'])+)\1|((?:\\.|[^\s,"'()\\])+))\s*\)/g, function(match, quotes, relUrl1, relUrl2) {
                        return [
                            "url(",
                            quotes,
                            resolveUrl(relUrl1 || relUrl2, url),
                            quotes,
                            ")"
                        ].join("");
                    });
                    return new Response(new Blob([
                        "System.register([],function(e){return{execute:function(){var s=new CSSStyleSheet();s.replaceSync(" + JSON.stringify(source) + ');e("default",s)}}})'
                    ], {
                        type: "application/javascript"
                    }));
                });
                if (wasmContentType.test(contentType)) return (WebAssembly.compileStreaming ? WebAssembly.compileStreaming(res) : res.arrayBuffer().then(WebAssembly.compile)).then(function(module) {
                    if (!global1.System.wasmModules) global1.System.wasmModules = Object.create(null);
                    global1.System.wasmModules[url] = module;
                    // we can only set imports if supported (eg early Safari doesnt support)
                    var deps = [];
                    var setterSources = [];
                    if (WebAssembly.Module.imports) WebAssembly.Module.imports(module).forEach(function(impt) {
                        var key = JSON.stringify(impt.module);
                        if (deps.indexOf(key) === -1) {
                            deps.push(key);
                            setterSources.push("function(m){i[" + key + "]=m}");
                        }
                    });
                    return new Response(new Blob([
                        "System.register([" + deps.join(",") + "],function(e){var i={};return{setters:[" + setterSources.join(",") + "],execute:function(){return WebAssembly.instantiate(System.wasmModules[" + JSON.stringify(url) + "],i).then(function(m){e(m.exports)})}}})"
                    ], {
                        type: "application/javascript"
                    }));
                });
                return res;
            });
        };
    })(typeof self !== "undefined" ? self : $parcel$global);
    var toStringTag = typeof Symbol !== "undefined" && Symbol.toStringTag;
    systemJSPrototype.get = function(id) {
        var load = this[REGISTRY][id];
        if (load && load.e === null && !load.E) {
            if (load.er) return null;
            return load.n;
        }
    };
    systemJSPrototype.set = function(id, module) {
        try {
            // No page-relative URLs allowed
            new URL(id);
        } catch (err) {
            console.warn(Error(errMsg("W3", '"' + id + '" is not a valid URL to set in the module registry')));
        }
        var ns;
        if (toStringTag && module[toStringTag] === "Module") ns = module;
        else {
            ns = Object.assign(Object.create(null), module);
            if (toStringTag) Object.defineProperty(ns, toStringTag, {
                value: "Module"
            });
        }
        var done = Promise.resolve(ns);
        var load = this[REGISTRY][id] || (this[REGISTRY][id] = {
            id: id,
            i: [],
            h: false,
            d: [],
            e: null,
            er: undefined,
            E: undefined
        });
        if (load.e || load.E) return false;
        Object.assign(load, {
            n: ns,
            I: undefined,
            L: undefined,
            C: done
        });
        return ns;
    };
    systemJSPrototype.has = function(id) {
        var load = this[REGISTRY][id];
        return !!load;
    };
    // Delete function provided for hot-reloading use cases
    systemJSPrototype.delete = function(id) {
        var registry = this[REGISTRY];
        var load = registry[id];
        // in future we can support load.E case by failing load first
        // but that will require TLA callbacks to be implemented
        if (!load || load.p && load.p.e !== null || load.E) return false;
        var importerSetters = load.i;
        // remove from importerSetters
        // (release for gc)
        if (load.d) load.d.forEach(function(depLoad) {
            var importerIndex = depLoad.i.indexOf(load);
            if (importerIndex !== -1) depLoad.i.splice(importerIndex, 1);
        });
        delete registry[id];
        return function() {
            var load = registry[id];
            if (!load || !importerSetters || load.e !== null || load.E) return false;
            // add back the old setters
            importerSetters.forEach(function(setter) {
                load.i.push(setter);
                setter(load.n);
            });
            importerSetters = null;
        };
    };
    var iterator = typeof Symbol !== "undefined" && Symbol.iterator;
    systemJSPrototype.entries = function() {
        var loader = this, keys = Object.keys(loader[REGISTRY]);
        var index = 0, ns, key;
        var result = {
            next: function next() {
                while((key = keys[index++]) !== undefined && (ns = loader.get(key)) === undefined);
                return {
                    done: key === undefined,
                    value: key !== undefined && [
                        key,
                        ns
                    ]
                };
            }
        };
        result[iterator] = function() {
            return this;
        };
        return result;
    };
})();

});

parcelRegister("2ljoN", function(module, exports) {

$parcel$export(module.exports, "defineMessages", function () { return $1b4c972cec29516b$export$1adfeb024f5185b; });
$parcel$export(module.exports, "defineMessage", function () { return $1b4c972cec29516b$export$747d244ee58120dd; });
$parcel$export(module.exports, "FormattedDate", function () { return $1b4c972cec29516b$export$40ae3194919d16b; });
$parcel$export(module.exports, "FormattedTime", function () { return $1b4c972cec29516b$export$5b390a54f8a846f7; });
$parcel$export(module.exports, "FormattedNumber", function () { return $1b4c972cec29516b$export$db80edc1e6b2f63d; });
$parcel$export(module.exports, "FormattedList", function () { return $1b4c972cec29516b$export$f52b44e459e6e71d; });
$parcel$export(module.exports, "FormattedDisplayName", function () { return $1b4c972cec29516b$export$c2336ea5aaab92fa; });
$parcel$export(module.exports, "FormattedDateParts", function () { return $1b4c972cec29516b$export$7fdc7d2c91ce149b; });
$parcel$export(module.exports, "FormattedTimeParts", function () { return $1b4c972cec29516b$export$ec35873761676c2a; });
$parcel$export(module.exports, "FormattedDateTimeRange", function () { return (parcelRequire("2m817")).default; });
$parcel$export(module.exports, "FormattedMessage", function () { return (parcelRequire("inZyb")).default; });
$parcel$export(module.exports, "FormattedPlural", function () { return (parcelRequire("5gld4")).default; });
$parcel$export(module.exports, "FormattedRelativeTime", function () { return (parcelRequire("dcNFi")).default; });
$parcel$export(module.exports, "IntlContext", function () { return (parcelRequire("hNTqI")).Context; });
$parcel$export(module.exports, "IntlProvider", function () { return (parcelRequire("fLllH")).default; });
$parcel$export(module.exports, "RawIntlProvider", function () { return (parcelRequire("hNTqI")).Provider; });
$parcel$export(module.exports, "createIntl", function () { return (parcelRequire("fLllH")).createIntl; });
$parcel$export(module.exports, "injectIntl", function () { return (parcelRequire("hNTqI")).default; });
$parcel$export(module.exports, "useIntl", function () { return (parcelRequire("i1aW0")).default; });
$parcel$export(module.exports, "createIntlCache", function () { return (parcelRequire("8SB3v")).createIntlCache; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return (parcelRequire("kWXb3")).UnsupportedFormatterError; });
$parcel$export(module.exports, "InvalidConfigError", function () { return (parcelRequire("kWXb3")).InvalidConfigError; });
$parcel$export(module.exports, "MissingDataError", function () { return (parcelRequire("kWXb3")).MissingDataError; });
$parcel$export(module.exports, "MessageFormatError", function () { return (parcelRequire("kWXb3")).MessageFormatError; });
$parcel$export(module.exports, "MissingTranslationError", function () { return (parcelRequire("kWXb3")).MissingTranslationError; });
$parcel$export(module.exports, "ReactIntlErrorCode", function () { return (parcelRequire("kWXb3")).IntlErrorCode; });
$parcel$export(module.exports, "ReactIntlError", function () { return (parcelRequire("kWXb3")).IntlError; });
$parcel$export(module.exports, "FormattedNumberParts", function () { return (parcelRequire("2O5g4")).FormattedNumberParts; });
$parcel$export(module.exports, "FormattedListParts", function () { return (parcelRequire("2O5g4")).FormattedListParts; });

var $2O5g4 = parcelRequire("2O5g4");

var $hNTqI = parcelRequire("hNTqI");

var $i1aW0 = parcelRequire("i1aW0");

var $fLllH = parcelRequire("fLllH");

var $dcNFi = parcelRequire("dcNFi");

var $5gld4 = parcelRequire("5gld4");

var $inZyb = parcelRequire("inZyb");

var $2m817 = parcelRequire("2m817");

var $8SB3v = parcelRequire("8SB3v");
var $kWXb3 = parcelRequire("kWXb3");
function $1b4c972cec29516b$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $1b4c972cec29516b$export$747d244ee58120dd(msg) {
    return msg;
}
var $1b4c972cec29516b$export$40ae3194919d16b = (0, $2O5g4.createFormattedComponent)("formatDate");
var $1b4c972cec29516b$export$5b390a54f8a846f7 = (0, $2O5g4.createFormattedComponent)("formatTime");
var $1b4c972cec29516b$export$db80edc1e6b2f63d = (0, $2O5g4.createFormattedComponent)("formatNumber");
var $1b4c972cec29516b$export$f52b44e459e6e71d = (0, $2O5g4.createFormattedComponent)("formatList");
var $1b4c972cec29516b$export$c2336ea5aaab92fa = (0, $2O5g4.createFormattedComponent)("formatDisplayName");
var $1b4c972cec29516b$export$7fdc7d2c91ce149b = (0, $2O5g4.createFormattedDateTimePartsComponent)("formatDate");
var $1b4c972cec29516b$export$ec35873761676c2a = (0, $2O5g4.createFormattedDateTimePartsComponent)("formatTime");

});
parcelRegister("2O5g4", function(module, exports) {

$parcel$export(module.exports, "FormattedNumberParts", function () { return $20b45475403d9bf7$export$54d4989ed3eea1ea; });
$parcel$export(module.exports, "FormattedListParts", function () { return $20b45475403d9bf7$export$5ac259c7da6d2188; });
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $20b45475403d9bf7$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $20b45475403d9bf7$export$b37e14176d001dec; });

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $i1aW0 = parcelRequire("i1aW0");
var $20b45475403d9bf7$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($20b45475403d9bf7$var$DisplayName || ($20b45475403d9bf7$var$DisplayName = {}));
var $20b45475403d9bf7$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($20b45475403d9bf7$var$DisplayNameParts || ($20b45475403d9bf7$var$DisplayNameParts = {}));
var $20b45475403d9bf7$export$54d4989ed3eea1ea = function FormattedNumberParts(props) {
    var intl = (0, $i1aW0.default)();
    var value = props.value, children = props.children, formatProps = (0, $l29cN.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$20b45475403d9bf7$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
var $20b45475403d9bf7$export$5ac259c7da6d2188 = function FormattedListParts(props) {
    var intl = (0, $i1aW0.default)();
    var value = props.value, children = props.children, formatProps = (0, $l29cN.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$20b45475403d9bf7$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
function $20b45475403d9bf7$export$7448277f6036d2ab(name) {
    var ComponentParts = function ComponentParts(props) {
        var intl = (0, $i1aW0.default)();
        var value = props.value, children = props.children, formatProps = (0, $l29cN.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $20b45475403d9bf7$var$DisplayNameParts[name];
    return ComponentParts;
}
function $20b45475403d9bf7$export$b37e14176d001dec(name) {
    var Component = function Component(props) {
        var intl = (0, $i1aW0.default)();
        var value = props.value, children = props.children, formatProps = (0, $l29cN.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || $1Mpn7.Fragment;
        return $1Mpn7.createElement(Text, null, formattedValue);
    };
    Component.displayName = $20b45475403d9bf7$var$DisplayName[name];
    return Component;
}

});
parcelRegister("i1aW0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e0cd64725983b8$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $hNTqI = parcelRequire("hNTqI");

var $k339d = parcelRequire("k339d");
function $d1e0cd64725983b8$export$2e2bcd8739ae039() {
    var intl = $1Mpn7.useContext((0, $hNTqI.Context));
    (0, $k339d.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("hNTqI", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $cf62027ab5fb244e$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $cf62027ab5fb244e$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $cf62027ab5fb244e$export$2e2bcd8739ae039; });

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $knVHJ = parcelRequire("knVHJ");

var $k339d = parcelRequire("k339d");
function $cf62027ab5fb244e$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// TODO: We should provide initial value here
var $cf62027ab5fb244e$var$IntlContext = $1Mpn7.createContext(null);
var $cf62027ab5fb244e$var$IntlConsumer = $cf62027ab5fb244e$var$IntlContext.Consumer, $cf62027ab5fb244e$var$IntlProvider = $cf62027ab5fb244e$var$IntlContext.Provider;
var $cf62027ab5fb244e$export$2881499e37b75b9a = $cf62027ab5fb244e$var$IntlProvider;
var $cf62027ab5fb244e$export$841858b892ce1f4c = $cf62027ab5fb244e$var$IntlContext;
function $cf62027ab5fb244e$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function WithIntl(props) {
        return $1Mpn7.createElement($cf62027ab5fb244e$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $k339d.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $1Mpn7.createElement(WrappedComponent, (0, $l29cN.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($cf62027ab5fb244e$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($knVHJ)))($1Mpn7.forwardRef(function(props, ref) {
        return $1Mpn7.createElement(WithIntl, (0, $l29cN.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($knVHJ)))(WithIntl, WrappedComponent);
}

});
parcelRegister("k339d", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $e9868788231546a6$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $e9868788231546a6$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $e9868788231546a6$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $e9868788231546a6$export$d36bdfa510afb180; });

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $dO7VW = parcelRequire("dO7VW");

var $8SB3v = parcelRequire("8SB3v");
function $e9868788231546a6$export$45c4bbf6e55bba1f(intl) {
    (0, $dO7VW.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $e9868788231546a6$export$b52f8d6fc0d47415 = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, (0, $8SB3v.DEFAULT_INTL_CONFIG)), {
    textComponent: $1Mpn7.Fragment
});
function $e9868788231546a6$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($1Mpn7.Children.toArray(parts));
    };
}
function $e9868788231546a6$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("dO7VW", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $a0d61952734373b9$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $a0d61952734373b9$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $a0d61952734373b9$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $a0d61952734373b9$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $a0d61952734373b9$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $a0d61952734373b9$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $a0d61952734373b9$export$3fae2929ed23c202(map, pl, field) {
    return $a0d61952734373b9$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $a0d61952734373b9$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $a0d61952734373b9$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $a0d61952734373b9$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $a0d61952734373b9$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $a0d61952734373b9$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("8SB3v", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $67701c5c0cfd9e11$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $67701c5c0cfd9e11$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $67701c5c0cfd9e11$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $67701c5c0cfd9e11$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $67701c5c0cfd9e11$export$4ee1db8ce44a209b; });

var $l29cN = parcelRequire("l29cN");

var $94s3f = parcelRequire("94s3f");

var $6X2WM = parcelRequire("6X2WM");

var $kWXb3 = parcelRequire("kWXb3");
function $67701c5c0cfd9e11$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $67701c5c0cfd9e11$var$defaultErrorHandler = function defaultErrorHandler(error) {};
var $67701c5c0cfd9e11$var$defaultWarnHandler = function defaultWarnHandler(warning) {};
var $67701c5c0cfd9e11$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $67701c5c0cfd9e11$var$defaultErrorHandler,
    onWarn: $67701c5c0cfd9e11$var$defaultWarnHandler
};
function $67701c5c0cfd9e11$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $67701c5c0cfd9e11$var$createFastMemoizeCache(store) {
    return {
        create: function create() {
            return {
                get: function get(key) {
                    return store[key];
                },
                set: function set(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $67701c5c0cfd9e11$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $67701c5c0cfd9e11$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $6X2WM.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $l29cN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $67701c5c0cfd9e11$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $6X2WM.strategies).variadic
    });
    var getNumberFormat = (0, $6X2WM.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $l29cN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $67701c5c0cfd9e11$var$createFastMemoizeCache(cache.number),
        strategy: (0, $6X2WM.strategies).variadic
    });
    var getPluralRules = (0, $6X2WM.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $l29cN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $67701c5c0cfd9e11$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $6X2WM.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $6X2WM.default)(function(message, locales, overrideFormats, opts) {
            return new (0, $94s3f.IntlMessageFormat)(message, locales, overrideFormats, (0, $l29cN.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $67701c5c0cfd9e11$var$createFastMemoizeCache(cache.message),
            strategy: (0, $6X2WM.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $6X2WM.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $67701c5c0cfd9e11$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $6X2WM.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $6X2WM.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $67701c5c0cfd9e11$var$createFastMemoizeCache(cache.list),
            strategy: (0, $6X2WM.strategies).variadic
        }),
        getDisplayNames: (0, $6X2WM.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $67701c5c0cfd9e11$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $6X2WM.strategies).variadic
        })
    };
}
function $67701c5c0cfd9e11$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $kWXb3.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("94s3f", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $69aa3f2e2cd3dad0$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $l29cN = parcelRequire("l29cN");

var $iz7OS = parcelRequire("iz7OS");

var $6X2WM = parcelRequire("6X2WM");

var $6nvLh = parcelRequire("6nvLh");
// -- MessageFormat --------------------------------------------------------
function $69aa3f2e2cd3dad0$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $l29cN.__assign)((0, $l29cN.__assign)((0, $l29cN.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $69aa3f2e2cd3dad0$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $69aa3f2e2cd3dad0$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $l29cN.__assign)({}, defaultConfig));
}
function $69aa3f2e2cd3dad0$var$createFastMemoizeCache(store) {
    return {
        create: function create() {
            return {
                get: function get(key) {
                    return store[key];
                },
                set: function set(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $69aa3f2e2cd3dad0$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $6X2WM.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $69aa3f2e2cd3dad0$var$createFastMemoizeCache(cache.number),
            strategy: (0, $6X2WM.strategies).variadic
        }),
        getDateTimeFormat: (0, $6X2WM.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $69aa3f2e2cd3dad0$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $6X2WM.strategies).variadic
        }),
        getPluralRules: (0, $6X2WM.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $l29cN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $69aa3f2e2cd3dad0$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $6X2WM.strategies).variadic
        })
    };
}
var $69aa3f2e2cd3dad0$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $6nvLh.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $6nvLh.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $69aa3f2e2cd3dad0$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $69aa3f2e2cd3dad0$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function get() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $iz7OS.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("iz7OS", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("ihxhV")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("ihxhV")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("ihxhV")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("ihxhV")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("ihxhV")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("ihxhV")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("ihxhV")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("ihxhV")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("ihxhV")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("ihxhV")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("ihxhV")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("ihxhV")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $d8418fb127f02a9e$export$98e6a39c04603d36; });

var $l29cN = parcelRequire("l29cN");

var $gEJTT = parcelRequire("gEJTT");

var $fU5nf = parcelRequire("fU5nf");

var $ihxhV = parcelRequire("ihxhV");
function $d8418fb127f02a9e$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $ihxhV.isSelectElement)(el) || (0, $ihxhV.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $d8418fb127f02a9e$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $ihxhV.isNumberElement)(el) && (0, $ihxhV.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $ihxhV.isDateElement)(el) || (0, $ihxhV.isTimeElement)(el)) && (0, $ihxhV.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $ihxhV.isTagElement)(el)) $d8418fb127f02a9e$var$pruneLocation(el.children);
    });
}
function $d8418fb127f02a9e$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $l29cN.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $fU5nf.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $gEJTT.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $d8418fb127f02a9e$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("gEJTT", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $c203fca616e5f7b5$export$896afd8541959ee5; });
var $c203fca616e5f7b5$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($c203fca616e5f7b5$export$896afd8541959ee5 || ($c203fca616e5f7b5$export$896afd8541959ee5 = {}));

});

parcelRegister("fU5nf", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $b940412907e68ee6$export$7acfa6ed01010e37; });

var $l29cN = parcelRequire("l29cN");

var $gEJTT = parcelRequire("gEJTT");

var $ihxhV = parcelRequire("ihxhV");

var $FLVm3 = parcelRequire("FLVm3");
parcelRequire("l5mMr");
var $3tHkb = parcelRequire("3tHkb");
var $deGzR = parcelRequire("deGzR");

var $gekZK = parcelRequire("gekZK");
var $b940412907e68ee6$var$_a;
var $b940412907e68ee6$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $FLVm3.SPACE_SEPARATOR_REGEX).source, "*"));
var $b940412907e68ee6$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $FLVm3.SPACE_SEPARATOR_REGEX).source, "*$"));
function $b940412907e68ee6$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $b940412907e68ee6$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $b940412907e68ee6$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $b940412907e68ee6$var$hasNativeFromEntries = !!Object.fromEntries;
var $b940412907e68ee6$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $b940412907e68ee6$var$hasTrimStart = !!String.prototype.trimStart;
var $b940412907e68ee6$var$hasTrimEnd = !!String.prototype.trimEnd;
var $b940412907e68ee6$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $b940412907e68ee6$var$isSafeInteger = $b940412907e68ee6$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function isSafeInteger(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $b940412907e68ee6$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $b940412907e68ee6$var$re = $b940412907e68ee6$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $b940412907e68ee6$var$REGEX_SUPPORTS_U_AND_Y = (($b940412907e68ee6$var$_a = $b940412907e68ee6$var$re.exec("a")) === null || $b940412907e68ee6$var$_a === void 0 ? void 0 : $b940412907e68ee6$var$_a[0]) === "a";
} catch (_) {
    $b940412907e68ee6$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $b940412907e68ee6$var$startsWith = $b940412907e68ee6$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $b940412907e68ee6$var$fromCodePoint = $b940412907e68ee6$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $b940412907e68ee6$var$fromEntries = // native
$b940412907e68ee6$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $b940412907e68ee6$var$codePointAt = $b940412907e68ee6$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $b940412907e68ee6$var$trimStart = $b940412907e68ee6$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($b940412907e68ee6$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $b940412907e68ee6$var$trimEnd = $b940412907e68ee6$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($b940412907e68ee6$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $b940412907e68ee6$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $b940412907e68ee6$var$matchIdentifierAtIndex;
if ($b940412907e68ee6$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $b940412907e68ee6$var$IDENTIFIER_PREFIX_RE_1 = $b940412907e68ee6$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $b940412907e68ee6$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $b940412907e68ee6$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $b940412907e68ee6$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$b940412907e68ee6$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $b940412907e68ee6$var$codePointAt(s, index);
        if (c === undefined || $b940412907e68ee6$var$_isWhiteSpace(c) || $b940412907e68ee6$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $b940412907e68ee6$var$fromCodePoint.apply(void 0, match);
};
var $b940412907e68ee6$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $ihxhV.TYPE).pound,
                    location: $b940412907e68ee6$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $gEJTT.ErrorKind).UNMATCHED_CLOSING_TAG, $b940412907e68ee6$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $b940412907e68ee6$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $ihxhV.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $b940412907e68ee6$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$b940412907e68ee6$var$_isAlpha(this.char())) return this.error((0, $gEJTT.ErrorKind).INVALID_TAG, $b940412907e68ee6$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $gEJTT.ErrorKind).UNMATCHED_CLOSING_TAG, $b940412907e68ee6$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $gEJTT.ErrorKind).INVALID_TAG, $b940412907e68ee6$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $ihxhV.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $b940412907e68ee6$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $gEJTT.ErrorKind).UNCLOSED_TAG, $b940412907e68ee6$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $gEJTT.ErrorKind).INVALID_TAG, $b940412907e68ee6$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $b940412907e68ee6$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $b940412907e68ee6$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $ihxhV.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$b940412907e68ee6$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $b940412907e68ee6$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $b940412907e68ee6$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $gEJTT.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $b940412907e68ee6$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $gEJTT.ErrorKind).EMPTY_ARGUMENT, $b940412907e68ee6$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $gEJTT.ErrorKind).MALFORMED_ARGUMENT, $b940412907e68ee6$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $gEJTT.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $b940412907e68ee6$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $ihxhV.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $b940412907e68ee6$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $gEJTT.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $b940412907e68ee6$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $gEJTT.ErrorKind).MALFORMED_ARGUMENT, $b940412907e68ee6$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $b940412907e68ee6$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $b940412907e68ee6$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $gEJTT.ErrorKind).EXPECT_ARGUMENT_TYPE, $b940412907e68ee6$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $b940412907e68ee6$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $gEJTT.ErrorKind).EXPECT_ARGUMENT_STYLE, $b940412907e68ee6$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $b940412907e68ee6$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $b940412907e68ee6$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $b940412907e68ee6$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $b940412907e68ee6$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $ihxhV.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $gEJTT.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $gekZK.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $ihxhV.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $3tHkb.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $ihxhV.TYPE).date : (0, $ihxhV.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $ihxhV.TYPE).number : argType === "date" ? (0, $ihxhV.TYPE).date : (0, $ihxhV.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $gEJTT.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $b940412907e68ee6$var$createLocation(typeEndPosition_1, (0, $l29cN.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $gEJTT.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $b940412907e68ee6$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $gEJTT.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $gEJTT.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $b940412907e68ee6$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $ihxhV.TYPE).select,
                        value: value,
                        options: $b940412907e68ee6$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $ihxhV.TYPE).plural,
                        value: value,
                        options: $b940412907e68ee6$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $gEJTT.ErrorKind).INVALID_ARGUMENT_TYPE, $b940412907e68ee6$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $gEJTT.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $b940412907e68ee6$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $gEJTT.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $b940412907e68ee6$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $deGzR.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $gEJTT.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $ihxhV.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $deGzR.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $gEJTT.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $gEJTT.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $b940412907e68ee6$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $gEJTT.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $gEJTT.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $gEJTT.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $gEJTT.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $b940412907e68ee6$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $b940412907e68ee6$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $gEJTT.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $gEJTT.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $b940412907e68ee6$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $gEJTT.ErrorKind).MISSING_OTHER_CLAUSE, $b940412907e68ee6$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $b940412907e68ee6$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$b940412907e68ee6$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $b940412907e68ee6$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($b940412907e68ee6$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $b940412907e68ee6$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $b940412907e68ee6$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $b940412907e68ee6$var$_isAlphaOrSlash(codepoint) {
    return $b940412907e68ee6$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $b940412907e68ee6$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $b940412907e68ee6$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $b940412907e68ee6$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("ihxhV", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $d4f3a2dc343f2b12$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $d4f3a2dc343f2b12$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $d4f3a2dc343f2b12$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $d4f3a2dc343f2b12$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $d4f3a2dc343f2b12$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $d4f3a2dc343f2b12$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $d4f3a2dc343f2b12$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $d4f3a2dc343f2b12$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $d4f3a2dc343f2b12$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $d4f3a2dc343f2b12$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $d4f3a2dc343f2b12$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $d4f3a2dc343f2b12$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $d4f3a2dc343f2b12$export$7680c41f1a55f4cf; });
var $d4f3a2dc343f2b12$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($d4f3a2dc343f2b12$export$b87f371cbc396fcf || ($d4f3a2dc343f2b12$export$b87f371cbc396fcf = {}));
var $d4f3a2dc343f2b12$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($d4f3a2dc343f2b12$export$906452485466fa53 || ($d4f3a2dc343f2b12$export$906452485466fa53 = {}));
function $d4f3a2dc343f2b12$export$cfa10c5697238752(el) {
    return el.type === $d4f3a2dc343f2b12$export$b87f371cbc396fcf.literal;
}
function $d4f3a2dc343f2b12$export$4f55724281bdfaf9(el) {
    return el.type === $d4f3a2dc343f2b12$export$b87f371cbc396fcf.argument;
}
function $d4f3a2dc343f2b12$export$e11187b219e191e1(el) {
    return el.type === $d4f3a2dc343f2b12$export$b87f371cbc396fcf.number;
}
function $d4f3a2dc343f2b12$export$32d811605da75f40(el) {
    return el.type === $d4f3a2dc343f2b12$export$b87f371cbc396fcf.date;
}
function $d4f3a2dc343f2b12$export$34ec46f596b1702f(el) {
    return el.type === $d4f3a2dc343f2b12$export$b87f371cbc396fcf.time;
}
function $d4f3a2dc343f2b12$export$dcfe1c11d168b5a1(el) {
    return el.type === $d4f3a2dc343f2b12$export$b87f371cbc396fcf.select;
}
function $d4f3a2dc343f2b12$export$6c796d116f0a4fbc(el) {
    return el.type === $d4f3a2dc343f2b12$export$b87f371cbc396fcf.plural;
}
function $d4f3a2dc343f2b12$export$c0ece297bdd0c082(el) {
    return el.type === $d4f3a2dc343f2b12$export$b87f371cbc396fcf.pound;
}
function $d4f3a2dc343f2b12$export$5c83de34745812b(el) {
    return el.type === $d4f3a2dc343f2b12$export$b87f371cbc396fcf.tag;
}
function $d4f3a2dc343f2b12$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $d4f3a2dc343f2b12$export$906452485466fa53.number);
}
function $d4f3a2dc343f2b12$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $d4f3a2dc343f2b12$export$906452485466fa53.dateTime);
}
function $d4f3a2dc343f2b12$export$f0ac572c1121c662(value) {
    return {
        type: $d4f3a2dc343f2b12$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $d4f3a2dc343f2b12$export$425e864b0ba114f1(value, style) {
    return {
        type: $d4f3a2dc343f2b12$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("FLVm3", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $07d9012c61a9d29c$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $07d9012c61a9d29c$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $07d9012c61a9d29c$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("l5mMr", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("3tHkb")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("deGzR")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("deGzR")).parseNumberSkeletonFromString; });
parcelRequire("3tHkb");
parcelRequire("deGzR");

});
parcelRegister("3tHkb", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $2885afe7c7c0aff3$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $2885afe7c7c0aff3$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $2885afe7c7c0aff3$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($2885afe7c7c0aff3$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("deGzR", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $9a2d9c2bc96984c6$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $9a2d9c2bc96984c6$export$47c6f8480bda3e11; });

var $l29cN = parcelRequire("l29cN");

var $1VJcU = parcelRequire("1VJcU");
function $9a2d9c2bc96984c6$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $1VJcU.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $9a2d9c2bc96984c6$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $9a2d9c2bc96984c6$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $9a2d9c2bc96984c6$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $9a2d9c2bc96984c6$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $9a2d9c2bc96984c6$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $9a2d9c2bc96984c6$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($9a2d9c2bc96984c6$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $9a2d9c2bc96984c6$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $9a2d9c2bc96984c6$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$9a2d9c2bc96984c6$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $9a2d9c2bc96984c6$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $9a2d9c2bc96984c6$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $9a2d9c2bc96984c6$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $9a2d9c2bc96984c6$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $l29cN.__assign)((0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $l29cN.__assign)((0, $l29cN.__assign)({}, all), $9a2d9c2bc96984c6$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $l29cN.__assign)((0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $l29cN.__assign)((0, $l29cN.__assign)({}, all), $9a2d9c2bc96984c6$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($9a2d9c2bc96984c6$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($9a2d9c2bc96984c6$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($9a2d9c2bc96984c6$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($9a2d9c2bc96984c6$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), $9a2d9c2bc96984c6$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($9a2d9c2bc96984c6$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), $9a2d9c2bc96984c6$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $9a2d9c2bc96984c6$var$parseSign(token.stem);
        if (signOpts) result = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $9a2d9c2bc96984c6$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("1VJcU", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $167e2e8c4e0dde8a$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $167e2e8c4e0dde8a$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("gekZK", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $bd0e3d4a51ba52ea$export$29c5368be8904d27; });

var $jngwP = parcelRequire("jngwP");
function $bd0e3d4a51ba52ea$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $bd0e3d4a51ba52ea$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $bd0e3d4a51ba52ea$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $jngwP.timeData)[regionTag || ""] || (0, $jngwP.timeData)[languageTag || ""] || (0, $jngwP.timeData)["".concat(languageTag, "-001")] || (0, $jngwP.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("jngwP", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $e1acfc7ff640b870$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $e1acfc7ff640b870$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("6X2WM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50fa89fd0e520673$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "strategies", function () { return $50fa89fd0e520673$export$c5491a8691a23b9e; });
//
// Main
//
function $50fa89fd0e520673$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $50fa89fd0e520673$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $50fa89fd0e520673$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $50fa89fd0e520673$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $50fa89fd0e520673$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $50fa89fd0e520673$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $50fa89fd0e520673$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $50fa89fd0e520673$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $50fa89fd0e520673$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $50fa89fd0e520673$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $50fa89fd0e520673$var$monadic : $50fa89fd0e520673$var$variadic;
    return $50fa89fd0e520673$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $50fa89fd0e520673$var$strategyVariadic(fn, options) {
    return $50fa89fd0e520673$var$assemble(fn, this, $50fa89fd0e520673$var$variadic, options.cache.create(), options.serializer);
}
function $50fa89fd0e520673$var$strategyMonadic(fn, options) {
    return $50fa89fd0e520673$var$assemble(fn, this, $50fa89fd0e520673$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $50fa89fd0e520673$var$serializerDefault = function serializerDefault() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $50fa89fd0e520673$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$50fa89fd0e520673$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$50fa89fd0e520673$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $50fa89fd0e520673$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $50fa89fd0e520673$var$ObjectWithoutPrototypeCache();
    }
};
var $50fa89fd0e520673$export$c5491a8691a23b9e = {
    variadic: $50fa89fd0e520673$var$strategyVariadic,
    monadic: $50fa89fd0e520673$var$strategyMonadic
};

});

parcelRegister("6nvLh", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $4a4d8739b349f296$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $4a4d8739b349f296$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $4a4d8739b349f296$export$275d4a3bb5f66fda; });
parcelRequire("iz7OS");
var $ihxhV = parcelRequire("ihxhV");

var $6qMyh = parcelRequire("6qMyh");
var $4a4d8739b349f296$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($4a4d8739b349f296$export$49694c2877b44c57 || ($4a4d8739b349f296$export$49694c2877b44c57 = {}));
function $4a4d8739b349f296$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $4a4d8739b349f296$export$49694c2877b44c57.literal || part.type !== $4a4d8739b349f296$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $4a4d8739b349f296$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $4a4d8739b349f296$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $ihxhV.isLiteralElement)(els[0])) return [
        {
            type: $4a4d8739b349f296$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $ihxhV.isLiteralElement)(el)) {
            result.push({
                type: $4a4d8739b349f296$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $ihxhV.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $4a4d8739b349f296$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $6qMyh.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $ihxhV.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $4a4d8739b349f296$export$49694c2877b44c57.literal : $4a4d8739b349f296$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $ihxhV.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $ihxhV.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $4a4d8739b349f296$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $ihxhV.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $ihxhV.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $4a4d8739b349f296$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $ihxhV.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $ihxhV.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $4a4d8739b349f296$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $ihxhV.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$4a4d8739b349f296$export$df0c12a2d414a163(formatFn)) throw new (0, $6qMyh.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $4a4d8739b349f296$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $4a4d8739b349f296$export$49694c2877b44c57.literal : $4a4d8739b349f296$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $ihxhV.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $6qMyh.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $4a4d8739b349f296$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $ihxhV.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $6qMyh.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $6qMyh.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $6qMyh.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $4a4d8739b349f296$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $4a4d8739b349f296$var$mergeLiteral(result);
}

});
parcelRegister("6qMyh", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $4aead52afabd4e8d$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $4aead52afabd4e8d$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $4aead52afabd4e8d$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $4aead52afabd4e8d$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $4aead52afabd4e8d$export$8bfc137e4d23fdf0; });

var $l29cN = parcelRequire("l29cN");
var $4aead52afabd4e8d$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($4aead52afabd4e8d$export$d4e71bc0b80dc0fb || ($4aead52afabd4e8d$export$d4e71bc0b80dc0fb = {}));
var $4aead52afabd4e8d$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $4aead52afabd4e8d$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $4aead52afabd4e8d$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($4aead52afabd4e8d$export$7369836851cc1329);
var $4aead52afabd4e8d$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $4aead52afabd4e8d$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($4aead52afabd4e8d$export$7369836851cc1329);
var $4aead52afabd4e8d$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $4aead52afabd4e8d$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($4aead52afabd4e8d$export$7369836851cc1329);

});



parcelRegister("kWXb3", function(module, exports) {

$parcel$export(module.exports, "IntlErrorCode", function () { return $f40720ca1d41c805$export$557d6acb76e8a244; });
$parcel$export(module.exports, "IntlError", function () { return $f40720ca1d41c805$export$c016d36112f6ddf8; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $f40720ca1d41c805$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $f40720ca1d41c805$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $f40720ca1d41c805$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $f40720ca1d41c805$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $f40720ca1d41c805$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $f40720ca1d41c805$export$2ddcb436d0aa3688; });

var $l29cN = parcelRequire("l29cN");
var $f40720ca1d41c805$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($f40720ca1d41c805$export$557d6acb76e8a244 || ($f40720ca1d41c805$export$557d6acb76e8a244 = {}));
var $f40720ca1d41c805$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $f40720ca1d41c805$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $f40720ca1d41c805$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($f40720ca1d41c805$export$c016d36112f6ddf8);
var $f40720ca1d41c805$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $f40720ca1d41c805$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($f40720ca1d41c805$export$c016d36112f6ddf8);
var $f40720ca1d41c805$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $f40720ca1d41c805$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($f40720ca1d41c805$export$c016d36112f6ddf8);
var $f40720ca1d41c805$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $f40720ca1d41c805$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($f40720ca1d41c805$export$c016d36112f6ddf8);
var $f40720ca1d41c805$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($f40720ca1d41c805$export$e3b7eee1dbc44895);
var $f40720ca1d41c805$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $l29cN.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $f40720ca1d41c805$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message" : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($f40720ca1d41c805$export$c016d36112f6ddf8);

});






parcelRegister("fLllH", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $b79bce444ce12f58$export$7e4cbedfdd7b4c0d; });
$parcel$export(module.exports, "default", function () { return $b79bce444ce12f58$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $hNTqI = parcelRequire("hNTqI");

var $k339d = parcelRequire("k339d");

var $6LyJY = parcelRequire("6LyJY");
var $8SB3v = parcelRequire("8SB3v");
var $grRBh = parcelRequire("grRBh");

var $6nvLh = parcelRequire("6nvLh");
function $b79bce444ce12f58$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $b79bce444ce12f58$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $6nvLh.isFormatXMLElementFn)(v) ? (0, $k339d.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $b79bce444ce12f58$var$formatMessage = function formatMessage(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $b79bce444ce12f58$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $grRBh.formatMessage).apply(void 0, (0, $l29cN.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $1Mpn7.Children.toArray(chunks);
    return chunks;
};
var $b79bce444ce12f58$export$7e4cbedfdd7b4c0d = function createIntl(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $l29cN.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $b79bce444ce12f58$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $6LyJY.createIntl)((0, $l29cN.__assign)((0, $l29cN.__assign)((0, $l29cN.__assign)({}, (0, $k339d.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $l29cN.__assign)((0, $l29cN.__assign)({}, coreIntl), {
        formatMessage: $b79bce444ce12f58$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $b79bce444ce12f58$var$IntlProvider = /** @class */ function(_super) {
    (0, $l29cN.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $8SB3v.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $b79bce444ce12f58$export$7e4cbedfdd7b4c0d($b79bce444ce12f58$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $b79bce444ce12f58$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $b79bce444ce12f58$var$processIntlConfig(props);
        if (!(0, $k339d.shallowEqual)(prevConfig, config)) return {
            intl: $b79bce444ce12f58$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $k339d.invariantIntlContext)(this.state.intl);
        return $1Mpn7.createElement((0, $hNTqI.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $k339d.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($1Mpn7.PureComponent);
var $b79bce444ce12f58$export$2e2bcd8739ae039 = $b79bce444ce12f58$var$IntlProvider;

});
parcelRegister("6LyJY", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $4ed214946d81167c$export$7e4cbedfdd7b4c0d; });

var $l29cN = parcelRequire("l29cN");

var $8SB3v = parcelRequire("8SB3v");

var $kWXb3 = parcelRequire("kWXb3");

var $jjEY6 = parcelRequire("jjEY6");

var $g8w24 = parcelRequire("g8w24");

var $fcDNO = parcelRequire("fcDNO");

var $9chPK = parcelRequire("9chPK");

var $grRBh = parcelRequire("grRBh");

var $dla3D = parcelRequire("dla3D");

var $gx5wD = parcelRequire("gx5wD");
function $4ed214946d81167c$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $4ed214946d81167c$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $4ed214946d81167c$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $4ed214946d81167c$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $8SB3v.createFormatters)(cache);
    var resolvedConfig = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, (0, $8SB3v.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $kWXb3.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $kWXb3.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $kWXb3.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $4ed214946d81167c$var$verifyConfigMessages(resolvedConfig);
    return (0, $l29cN.__assign)((0, $l29cN.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $jjEY6.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $jjEY6.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $g8w24.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $fcDNO.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $fcDNO.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $fcDNO.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $fcDNO.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $fcDNO.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $9chPK.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $grRBh.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $grRBh.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $dla3D.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $dla3D.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $gx5wD.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("jjEY6", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $e0ff9222ce3200aa$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $e0ff9222ce3200aa$export$6871080848f10b2f; });

var $8SB3v = parcelRequire("8SB3v");

var $kWXb3 = parcelRequire("kWXb3");
var $e0ff9222ce3200aa$var$NUMBER_FORMAT_OPTIONS = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $e0ff9222ce3200aa$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $8SB3v.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $8SB3v.filterProps)(options, $e0ff9222ce3200aa$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $e0ff9222ce3200aa$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $e0ff9222ce3200aa$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $kWXb3.IntlError)((0, $kWXb3.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return String(value);
}
function $e0ff9222ce3200aa$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $e0ff9222ce3200aa$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $kWXb3.IntlError)((0, $kWXb3.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return [];
}

});

parcelRegister("g8w24", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $bbf63da8b088380b$export$b4ea3b48dcf921f6; });

var $8SB3v = parcelRequire("8SB3v");

var $6qMyh = parcelRequire("6qMyh");

var $kWXb3 = parcelRequire("kWXb3");
var $bbf63da8b088380b$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $bbf63da8b088380b$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $8SB3v.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $8SB3v.filterProps)(options, $bbf63da8b088380b$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $bbf63da8b088380b$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $6qMyh.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $6qMyh.ErrorCode).MISSING_INTL_API));
    try {
        return $bbf63da8b088380b$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $kWXb3.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

});

parcelRegister("fcDNO", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $02db3510309045be$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $02db3510309045be$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $02db3510309045be$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $02db3510309045be$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $02db3510309045be$export$af6e5d7a5c73edeb; });

var $l29cN = parcelRequire("l29cN");

var $8SB3v = parcelRequire("8SB3v");

var $kWXb3 = parcelRequire("kWXb3");
var $02db3510309045be$var$DATE_TIME_FORMAT_OPTIONS = [
    "localeMatcher",
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem"
];
function $02db3510309045be$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $8SB3v.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $8SB3v.filterProps)(options, $02db3510309045be$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $02db3510309045be$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $02db3510309045be$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $kWXb3.IntlError)((0, $kWXb3.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return String(date);
}
function $02db3510309045be$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $02db3510309045be$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $kWXb3.IntlError)((0, $kWXb3.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return String(date);
}
function $02db3510309045be$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $8SB3v.filterProps)(options, $02db3510309045be$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $kWXb3.IntlError)((0, $kWXb3.IntlErrorCode).FORMAT_ERROR, "Error formatting date time range.", e));
    }
    return String(from);
}
function $02db3510309045be$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $02db3510309045be$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $kWXb3.IntlError)((0, $kWXb3.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return [];
}
function $02db3510309045be$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $02db3510309045be$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $kWXb3.IntlError)((0, $kWXb3.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return [];
}

});

parcelRegister("9chPK", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $6b231171eb3f3ab7$export$bbbd05c900f3568d; });

var $8SB3v = parcelRequire("8SB3v");

var $kWXb3 = parcelRequire("kWXb3");

var $6qMyh = parcelRequire("6qMyh");
var $6b231171eb3f3ab7$var$PLURAL_FORMAT_OPTIONS = [
    "localeMatcher",
    "type"
];
function $6b231171eb3f3ab7$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $6qMyh.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $6qMyh.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8SB3v.filterProps)(options, $6b231171eb3f3ab7$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $kWXb3.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

});

parcelRegister("grRBh", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $bf98bed808ed140e$export$25868d1e8e76735f; });

var $l29cN = parcelRequire("l29cN");

var $dO7VW = parcelRequire("dO7VW");

var $94s3f = parcelRequire("94s3f");

var $kWXb3 = parcelRequire("kWXb3");
parcelRequire("iz7OS");
var $ihxhV = parcelRequire("ihxhV");
function $bf98bed808ed140e$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $l29cN.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $bf98bed808ed140e$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $l29cN.__assign)((0, $l29cN.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $bf98bed808ed140e$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $94s3f.IntlMessageFormat).formats;
    return (0, $l29cN.__assign)((0, $l29cN.__assign)((0, $l29cN.__assign)({}, mfFormats), f1), {
        date: $bf98bed808ed140e$var$deepMergeOptions($bf98bed808ed140e$var$setTimeZoneInOptions(mfFormats.date, timeZone), $bf98bed808ed140e$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $bf98bed808ed140e$var$deepMergeOptions($bf98bed808ed140e$var$setTimeZoneInOptions(mfFormats.time, timeZone), $bf98bed808ed140e$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $bf98bed808ed140e$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $dO7VW.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $ihxhV.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $l29cN.__assign)((0, $l29cN.__assign)({}, defaultRichTextElements), values || {});
    formats = $bf98bed808ed140e$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $bf98bed808ed140e$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $kWXb3.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $kWXb3.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $l29cN.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $kWXb3.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $kWXb3.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
}

});

parcelRegister("dla3D", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $9b6509c44245a303$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $9b6509c44245a303$export$6f284aad1934db69; });

var $l29cN = parcelRequire("l29cN");

var $8SB3v = parcelRequire("8SB3v");

var $6qMyh = parcelRequire("6qMyh");

var $kWXb3 = parcelRequire("kWXb3");
var $9b6509c44245a303$var$LIST_FORMAT_OPTIONS = [
    "localeMatcher",
    "type",
    "style"
];
var $9b6509c44245a303$var$now = Date.now();
function $9b6509c44245a303$var$generateToken(i) {
    return "".concat($9b6509c44245a303$var$now, "_").concat(i, "_").concat($9b6509c44245a303$var$now);
}
function $9b6509c44245a303$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $9b6509c44245a303$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $9b6509c44245a303$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $6qMyh.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $6qMyh.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8SB3v.filterProps)(options, $9b6509c44245a303$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $9b6509c44245a303$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $l29cN.__assign)((0, $l29cN.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $kWXb3.IntlError)((0, $kWXb3.IntlErrorCode).FORMAT_ERROR, "Error formatting list.", e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("gx5wD", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $c094039cd6408180$export$62fe1a4d9e891fa2; });

var $8SB3v = parcelRequire("8SB3v");

var $6qMyh = parcelRequire("6qMyh");

var $kWXb3 = parcelRequire("kWXb3");
var $c094039cd6408180$var$DISPLAY_NAMES_OPTONS = [
    "localeMatcher",
    "style",
    "type",
    "fallback"
];
function $c094039cd6408180$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $6qMyh.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $6qMyh.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8SB3v.filterProps)(options, $c094039cd6408180$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $kWXb3.IntlError)((0, $kWXb3.IntlErrorCode).FORMAT_ERROR, "Error formatting display name.", e));
    }
}

});



parcelRegister("dcNFi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99d2ebcc0c65aaf9$export$2e2bcd8739ae039; });

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $dO7VW = parcelRequire("dO7VW");

var $i1aW0 = parcelRequire("i1aW0");
var $99d2ebcc0c65aaf9$var$MINUTE = 60;
var $99d2ebcc0c65aaf9$var$HOUR = 3600;
var $99d2ebcc0c65aaf9$var$DAY = 86400;
function $99d2ebcc0c65aaf9$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $99d2ebcc0c65aaf9$var$MINUTE) return "second";
    if (absValue < $99d2ebcc0c65aaf9$var$HOUR) return "minute";
    if (absValue < $99d2ebcc0c65aaf9$var$DAY) return "hour";
    return "day";
}
function $99d2ebcc0c65aaf9$var$getDurationInSeconds(unit) {
    switch(unit){
        case "second":
            return 1;
        case "minute":
            return $99d2ebcc0c65aaf9$var$MINUTE;
        case "hour":
            return $99d2ebcc0c65aaf9$var$HOUR;
        default:
            return $99d2ebcc0c65aaf9$var$DAY;
    }
}
function $99d2ebcc0c65aaf9$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case "second":
            return value;
        case "minute":
            return value * $99d2ebcc0c65aaf9$var$MINUTE;
        default:
            return value * $99d2ebcc0c65aaf9$var$HOUR;
    }
}
var $99d2ebcc0c65aaf9$var$INCREMENTABLE_UNITS = [
    "second",
    "minute",
    "hour"
];
function $99d2ebcc0c65aaf9$var$canIncrement(unit) {
    if (unit === void 0) unit = "second";
    return $99d2ebcc0c65aaf9$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $99d2ebcc0c65aaf9$var$SimpleFormattedRelativeTime = function SimpleFormattedRelativeTime(props) {
    var _a = (0, $i1aW0.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $l29cN.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === "function") return children(formattedRelativeTime);
    if (Text) return $1Mpn7.createElement(Text, null, formattedRelativeTime);
    return $1Mpn7.createElement($1Mpn7.Fragment, null, formattedRelativeTime);
};
var $99d2ebcc0c65aaf9$var$FormattedRelativeTime = function FormattedRelativeTime(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $l29cN.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $dO7VW.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $99d2ebcc0c65aaf9$var$canIncrement(unit)), "Cannot schedule update with unit longer than hour");
    var _b = $1Mpn7.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $1Mpn7.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $1Mpn7.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($99d2ebcc0c65aaf9$var$canIncrement(unit) ? $99d2ebcc0c65aaf9$var$valueToSeconds(value, unit) : 0);
    }
    $1Mpn7.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$99d2ebcc0c65aaf9$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $99d2ebcc0c65aaf9$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === "day") return clearUpdateTimer;
        var unitDuration = $99d2ebcc0c65aaf9$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($99d2ebcc0c65aaf9$var$canIncrement(unit) && typeof currentValueInSeconds === "number" && updateIntervalInSeconds) {
        currentUnit = $99d2ebcc0c65aaf9$var$selectUnit(currentValueInSeconds);
        var unitDuration = $99d2ebcc0c65aaf9$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $1Mpn7.createElement($99d2ebcc0c65aaf9$var$SimpleFormattedRelativeTime, (0, $l29cN.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$99d2ebcc0c65aaf9$var$FormattedRelativeTime.displayName = "FormattedRelativeTime";
$99d2ebcc0c65aaf9$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: "second"
};
var $99d2ebcc0c65aaf9$export$2e2bcd8739ae039 = $99d2ebcc0c65aaf9$var$FormattedRelativeTime;

});

parcelRegister("5gld4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d4ee639b346ddbf$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $i1aW0 = parcelRequire("i1aW0");
var $3d4ee639b346ddbf$var$FormattedPlural = function FormattedPlural(props) {
    var _a = (0, $i1aW0.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === "function") return children(formattedPlural);
    if (Text) return $1Mpn7.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$3d4ee639b346ddbf$var$FormattedPlural.defaultProps = {
    type: "cardinal"
};
$3d4ee639b346ddbf$var$FormattedPlural.displayName = "FormattedPlural";
var $3d4ee639b346ddbf$export$2e2bcd8739ae039 = $3d4ee639b346ddbf$var$FormattedPlural;

});

parcelRegister("inZyb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d62a1e96faa6cac8$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $i1aW0 = parcelRequire("i1aW0");

var $k339d = parcelRequire("k339d");
function $d62a1e96faa6cac8$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $l29cN.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $l29cN.__rest)(nextProps, [
        "values"
    ]);
    return (0, $k339d.shallowEqual)(nextValues, values) && (0, $k339d.shallowEqual)(otherProps, nextOtherProps);
}
function $d62a1e96faa6cac8$var$FormattedMessage(props) {
    var intl = (0, $i1aW0.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $1Mpn7.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $1Mpn7.createElement(Component, null, $1Mpn7.Children.toArray(nodes));
    return $1Mpn7.createElement($1Mpn7.Fragment, null, nodes);
}
$d62a1e96faa6cac8$var$FormattedMessage.displayName = "FormattedMessage";
var $d62a1e96faa6cac8$var$MemoizedFormattedMessage = $1Mpn7.memo($d62a1e96faa6cac8$var$FormattedMessage, $d62a1e96faa6cac8$var$areEqual);
$d62a1e96faa6cac8$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $d62a1e96faa6cac8$export$2e2bcd8739ae039 = $d62a1e96faa6cac8$var$MemoizedFormattedMessage;

});

parcelRegister("2m817", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b73dae20f252d5e$export$2e2bcd8739ae039; });

var $l29cN = parcelRequire("l29cN");

var $1Mpn7 = parcelRequire("1Mpn7");

var $i1aW0 = parcelRequire("i1aW0");
var $1b73dae20f252d5e$var$FormattedDateTimeRange = function FormattedDateTimeRange(props) {
    var intl = (0, $i1aW0.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $l29cN.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === "function") return children(formattedValue);
    var Text = intl.textComponent || $1Mpn7.Fragment;
    return $1Mpn7.createElement(Text, null, formattedValue);
};
$1b73dae20f252d5e$var$FormattedDateTimeRange.displayName = "FormattedDateTimeRange";
var $1b73dae20f252d5e$export$2e2bcd8739ae039 = $1b73dae20f252d5e$var$FormattedDateTimeRange;

});




parcelRegister("jHxFC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e57c26ac22a7d97f$export$2e2bcd8739ae039; });

var $e6gyJ = parcelRequire("e6gyJ");

var $1Mpn7 = parcelRequire("1Mpn7");

var $lzTNO = parcelRequire("lzTNO");
var $5GB24 = parcelRequire("5GB24");
var $e57c26ac22a7d97f$var$experience = new (0, $5GB24.UFOExperience)("fetch", {
    type: (0, $lzTNO.ExperienceTypes).Load,
    performanceType: (0, $lzTNO.ExperiencePerformanceTypes).Custom,
    platform: {
        component: "remote-module-loader"
    }
});
/**
 * This hook is responsible for fetching the module from it's remote address.
 * Note it won't reload if it is already in the registry.
 *
 * @param remoteFrontendSdk
 * @param options
 */ var $e57c26ac22a7d97f$var$useRemoteModuleLoader = function useRemoteModuleLoader(remoteFrontendSdk) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _useState = (0, $1Mpn7.useState)({
        status: "initial"
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), state = _useState2[0], setStatus = _useState2[1];
    var status = state.status, error = state.error;
    var onError = options.onError;
    var moduleName = remoteFrontendSdk.getModuleName();
    (0, $1Mpn7.useEffect)(function() {
        return function() {
            $e57c26ac22a7d97f$var$experience.abort({
                metadata: {
                    moduleName: moduleName
                }
            });
        };
    }, [
        moduleName
    ]);
    (0, $1Mpn7.useEffect)(function() {
        if (status === "error" && typeof onError === "function") onError(error);
    }, [
        error,
        status,
        onError
    ]);
    (0, $1Mpn7.useEffect)(function() {
        // we don't want to re-run the experience if the module is already in the registry and has been loaded
        var isModuleInRegistry = remoteFrontendSdk.isModuleRegisteredAndValid();
        if (isModuleInRegistry && status !== "done") setStatus({
            status: "done"
        });
        else if (status === "initial") {
            $e57c26ac22a7d97f$var$experience.start();
            setStatus({
                status: "loading"
            });
            remoteFrontendSdk.fetchModule().then(function() {
                $e57c26ac22a7d97f$var$experience.success({
                    metadata: {
                        moduleName: moduleName
                    }
                });
                setStatus({
                    status: "done"
                });
            }).catch(function(error) {
                $e57c26ac22a7d97f$var$experience.failure({
                    metadata: {
                        error: error,
                        moduleName: moduleName
                    }
                });
                setStatus({
                    error: error,
                    status: "error"
                });
            });
        }
    }, [
        status,
        remoteFrontendSdk,
        onError,
        moduleName
    ]);
    return state;
};
var $e57c26ac22a7d97f$export$2e2bcd8739ae039 = $e57c26ac22a7d97f$var$useRemoteModuleLoader;

});
parcelRegister("lzTNO", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", function () { return $fb58270858eba4a0$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $fb58270858eba4a0$export$cc26007c03242fff; });
var $fb58270858eba4a0$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $fb58270858eba4a0$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("5GB24", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", function () { return $423d99dc0cb97033$export$c00d22927c60484a; });

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $9z8n4 = parcelRequire("9z8n4");
function $423d99dc0cb97033$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $423d99dc0cb97033$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $423d99dc0cb97033$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $423d99dc0cb97033$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(UFOExperience, _UFOAbstractExperienc);
    var _super = $423d99dc0cb97033$var$_createSuper(UFOExperience);
    function UFOExperience() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UFOExperience);
        return _super.apply(this, arguments);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UFOExperience);
}((0, $9z8n4.UFOAbstractExperience));

});
parcelRegister("9z8n4", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", function () { return $6f6de047a8dd6587$export$d31c89db257648c; });

var $eetQ9 = parcelRequire("eetQ9");

var $e8dor = parcelRequire("e8dor");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $fGIeY = parcelRequire("fGIeY");

var $2PF60 = parcelRequire("2PF60");

var $dfyD1 = parcelRequire("dfyD1");

var $3JN3H = parcelRequire("3JN3H");

var $abjmz = parcelRequire("abjmz");

var $3rErr = parcelRequire("3rErr");

var $kz0gL = parcelRequire("kz0gL");

var $nbofQ = parcelRequire("nbofQ");

var $75mwB = parcelRequire("75mwB");

var $6PJsc = parcelRequire("6PJsc");

var $eBfKu = parcelRequire("eBfKu");

var $lzTNO = parcelRequire("lzTNO");
function $6f6de047a8dd6587$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6f6de047a8dd6587$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6f6de047a8dd6587$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6f6de047a8dd6587$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $6f6de047a8dd6587$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $3JN3H.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === "visible" ? (0, $nbofQ.PageVisibleState).VISIBLE : (0, $nbofQ.PageVisibleState).HIDDEN;
};
var $6f6de047a8dd6587$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $75mwB.roundPerfNow)();
};
var $6f6de047a8dd6587$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UFOAbstractExperience);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "state", (0, $6PJsc.UFOExperienceState).NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "instanceId", null);
        // for concurrent
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "parent", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "category", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "metadata", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "onDoneCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "childExperiences", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "isSSROutputAsFMP", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "uuid", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_until", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "performanceConfig", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $nbofQ.PageVisibleState).MIXED;
            (0, $kz0gL.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $6f6de047a8dd6587$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $lzTNO.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $lzTNO.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $3rErr.ufolog)("async transition", this.id, this.state.id, newState.id);
                                if (!(0, $eBfKu.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $3rErr.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $6PJsc.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $6f6de047a8dd6587$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $2PF60.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $6f6de047a8dd6587$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $abjmz.getGlobalEventStream)().push((0, $abjmz.unsubscribeEvent)((0, $nbofQ.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $3rErr.ufolog)("this.parent", this.parent);
                                (0, $abjmz.getGlobalEventStream)().push((0, $abjmz.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $3rErr.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $3rErr.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $6PJsc.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $6f6de047a8dd6587$var$getPageVisibleState();
                                    (0, $kz0gL.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $3rErr.ufolog)("subscribed", this.id);
                                        (0, $abjmz.getGlobalEventStream)().push((0, $abjmz.subscribeEvent)((0, $nbofQ.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $nbofQ.FMP_MARK) && name !== (0, $nbofQ.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $3rErr.ufowarn)("please use markFMP or markInlineResponse for specialised marks");
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $6f6de047a8dd6587$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $6PJsc.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $nbofQ.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $nbofQ.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $3rErr.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $kz0gL.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $6PJsc.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $6PJsc.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $6PJsc.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $3rErr.ufolog)("_handleDoneExperience in", this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $dfyD1.UFO_EXPERIMENTAL_BUILD_VERSION) || "unknown";
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $6f6de047a8dd6587$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $6f6de047a8dd6587$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
    return UFOAbstractExperience;
}();

});
parcelRegister("2PF60", function(module, exports) {

var $fDH7c = parcelRequire("fDH7c");

var $dwCev = parcelRequire("dwCev");
var $210038f4825699f6$var$uuid = $dwCev;
$210038f4825699f6$var$uuid.v1 = $fDH7c;
$210038f4825699f6$var$uuid.v4 = $dwCev;
module.exports = $210038f4825699f6$var$uuid;

});
parcelRegister("fDH7c", function(module, exports) {

var $eIaV9 = parcelRequire("eIaV9");

var $5iOUC = parcelRequire("5iOUC");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $b62bf14b2eb9cb8b$var$_nodeId;
var $b62bf14b2eb9cb8b$var$_clockseq;
// Previous uuid creation time
var $b62bf14b2eb9cb8b$var$_lastMSecs = 0;
var $b62bf14b2eb9cb8b$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $b62bf14b2eb9cb8b$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $b62bf14b2eb9cb8b$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $b62bf14b2eb9cb8b$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $eIaV9();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $b62bf14b2eb9cb8b$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $b62bf14b2eb9cb8b$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $b62bf14b2eb9cb8b$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $b62bf14b2eb9cb8b$var$_lastMSecs + (nsecs - $b62bf14b2eb9cb8b$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $b62bf14b2eb9cb8b$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $b62bf14b2eb9cb8b$var$_lastMSecs = msecs;
    $b62bf14b2eb9cb8b$var$_lastNSecs = nsecs;
    $b62bf14b2eb9cb8b$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $5iOUC(b);
}
module.exports = $b62bf14b2eb9cb8b$var$v1;

});
parcelRegister("eIaV9", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $ab5da56422c5c9a3$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($ab5da56422c5c9a3$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $ab5da56422c5c9a3$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $ab5da56422c5c9a3$var$getRandomValues($ab5da56422c5c9a3$var$rnds8);
        return $ab5da56422c5c9a3$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $ab5da56422c5c9a3$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $ab5da56422c5c9a3$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $ab5da56422c5c9a3$var$rnds;
    };
}

});

parcelRegister("5iOUC", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $3dc6204d1046f94f$var$byteToHex = [];
for(var $3dc6204d1046f94f$var$i = 0; $3dc6204d1046f94f$var$i < 256; ++$3dc6204d1046f94f$var$i)$3dc6204d1046f94f$var$byteToHex[$3dc6204d1046f94f$var$i] = ($3dc6204d1046f94f$var$i + 0x100).toString(16).substr(1);
function $3dc6204d1046f94f$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $3dc6204d1046f94f$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $3dc6204d1046f94f$var$bytesToUuid;

});


parcelRegister("dwCev", function(module, exports) {

var $eIaV9 = parcelRequire("eIaV9");

var $5iOUC = parcelRequire("5iOUC");
function $9d8bebcf24d4409c$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $eIaV9)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $5iOUC(rnds);
}
module.exports = $9d8bebcf24d4409c$var$v4;

});


parcelRegister("dfyD1", function(module, exports) {

$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $9a578992bb2e636a$export$2295b861f318254a; });
// temp solution until we can get it automated
var $9a578992bb2e636a$export$2295b861f318254a = "0.1.5";

});

parcelRegister("3JN3H", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $2b8ba11ca0c72291$export$15e172712955e18f; });
var $2b8ba11ca0c72291$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== "undefined";
};

});

parcelRegister("abjmz", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", function () { return $7699f389ea2ec784$export$6123a44dc2384540; });
$parcel$export(module.exports, "subscribeEvent", function () { return $7699f389ea2ec784$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $7699f389ea2ec784$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $7699f389ea2ec784$export$7c957416596ca127; });

var $3rErr = parcelRequire("3rErr");

var $nbofQ = parcelRequire("nbofQ");
var $7699f389ea2ec784$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $7699f389ea2ec784$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $7699f389ea2ec784$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $7699f389ea2ec784$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $3rErr.ufowarn)("Global Event Stream already initialised. Ignoring new event stream setup");
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $7699f389ea2ec784$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $nbofQ.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $7699f389ea2ec784$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $nbofQ.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $7699f389ea2ec784$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $nbofQ.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("3rErr", function(module, exports) {

$parcel$export(module.exports, "ufolog", function () { return $2823438e316eca29$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $2823438e316eca29$export$d53d07b6034c4560; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");
var $2823438e316eca29$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UFOLogger);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "enabled", false);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
    return UFOLogger;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($2823438e316eca29$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $2823438e316eca29$export$4ab84f6f04f6566d = new $2823438e316eca29$var$UFOLogger();
var $2823438e316eca29$export$b4958caff08a0960 = function ufolog() {
    $2823438e316eca29$export$4ab84f6f04f6566d.log.apply($2823438e316eca29$export$4ab84f6f04f6566d, arguments);
};
var $2823438e316eca29$export$d53d07b6034c4560 = function ufowarn() {
    $2823438e316eca29$export$4ab84f6f04f6566d.warn.apply($2823438e316eca29$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("nbofQ", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $045afbf44e3e454c$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $045afbf44e3e454c$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $045afbf44e3e454c$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $045afbf44e3e454c$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $045afbf44e3e454c$export$837e0f79a8056912; });

var $045afbf44e3e454c$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $045afbf44e3e454c$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $045afbf44e3e454c$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $045afbf44e3e454c$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $045afbf44e3e454c$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $045afbf44e3e454c$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $045afbf44e3e454c$export$79bf131685ad41d7 = "__SUBSCRIBE_ALL__";
var $045afbf44e3e454c$export$9f2bf58999404c75 = "fmp";
var $045afbf44e3e454c$export$837e0f79a8056912 = "inline-response";

});


parcelRegister("kz0gL", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $ef874908a4c369fe$export$13e680397ec8f3eb; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $jjExS = parcelRequire("jjExS");

var $3JN3H = parcelRequire("3JN3H");
var $ef874908a4c369fe$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "started", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener("visibilitychange", this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $3JN3H.isWindowObjectAvailable)()) window.addEventListener("pagehide", this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $ef874908a4c369fe$export$13e680397ec8f3eb = new $ef874908a4c369fe$var$VisibilityChangeObserver();

});

parcelRegister("75mwB", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", function () { return $528a78fcdbaf6553$export$5f490af6b2b115cf; });
var $528a78fcdbaf6553$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("6PJsc", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", function () { return $4f9ac3acbf213fa2$export$81b70111112841a0; });
var $4f9ac3acbf213fa2$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: "NOT_STARTED",
        final: true
    },
    STARTED: {
        id: "STARTED"
    },
    IN_PROGRESS: {
        id: "IN_PROGRESS"
    },
    BLOCKED: {
        id: "BLOCKED"
    },
    RECOVERED: {
        id: "RECOVERED"
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: "SUCCEEDED",
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: "SUCCEEDED_WAITING_FOR_DEPS"
    },
    FAILED: {
        id: "FAILED",
        final: true
    },
    ABORTED: {
        id: "ABORTED",
        final: true
    }
};

});

parcelRegister("eBfKu", function(module, exports) {

$parcel$export(module.exports, "canTransition", function () { return $aa10bcc7716068d8$export$178881f329fdb81f; });

var $jjExS = parcelRequire("jjExS");

var $6PJsc = parcelRequire("6PJsc");
var $aa10bcc7716068d8$var$_UFOStateAvailableTra;
var $aa10bcc7716068d8$var$UFOStateAvailableTransitions = ($aa10bcc7716068d8$var$_UFOStateAvailableTra = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($aa10bcc7716068d8$var$_UFOStateAvailableTra, (0, $6PJsc.UFOExperienceState).NOT_STARTED.id, [
    (0, $6PJsc.UFOExperienceState).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($aa10bcc7716068d8$var$_UFOStateAvailableTra, (0, $6PJsc.UFOExperienceState).STARTED.id, [
    (0, $6PJsc.UFOExperienceState).IN_PROGRESS.id,
    (0, $6PJsc.UFOExperienceState).BLOCKED.id,
    (0, $6PJsc.UFOExperienceState).SUCCEEDED.id,
    (0, $6PJsc.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $6PJsc.UFOExperienceState).FAILED.id,
    (0, $6PJsc.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($aa10bcc7716068d8$var$_UFOStateAvailableTra, (0, $6PJsc.UFOExperienceState).IN_PROGRESS.id, [
    (0, $6PJsc.UFOExperienceState).BLOCKED.id,
    (0, $6PJsc.UFOExperienceState).SUCCEEDED.id,
    (0, $6PJsc.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $6PJsc.UFOExperienceState).FAILED.id,
    (0, $6PJsc.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($aa10bcc7716068d8$var$_UFOStateAvailableTra, (0, $6PJsc.UFOExperienceState).BLOCKED.id, [
    (0, $6PJsc.UFOExperienceState).RECOVERED.id,
    (0, $6PJsc.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($aa10bcc7716068d8$var$_UFOStateAvailableTra, (0, $6PJsc.UFOExperienceState).RECOVERED.id, [
    (0, $6PJsc.UFOExperienceState).STARTED.id,
    (0, $6PJsc.UFOExperienceState).SUCCEEDED.id,
    (0, $6PJsc.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $6PJsc.UFOExperienceState).FAILED.id,
    (0, $6PJsc.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($aa10bcc7716068d8$var$_UFOStateAvailableTra, (0, $6PJsc.UFOExperienceState).SUCCEEDED.id, [
    (0, $6PJsc.UFOExperienceState).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($aa10bcc7716068d8$var$_UFOStateAvailableTra, (0, $6PJsc.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $6PJsc.UFOExperienceState).SUCCEEDED.id,
    (0, $6PJsc.UFOExperienceState).FAILED.id,
    (0, $6PJsc.UFOExperienceState).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($aa10bcc7716068d8$var$_UFOStateAvailableTra, (0, $6PJsc.UFOExperienceState).FAILED.id, [
    (0, $6PJsc.UFOExperienceState).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($aa10bcc7716068d8$var$_UFOStateAvailableTra, (0, $6PJsc.UFOExperienceState).ABORTED.id, [
    (0, $6PJsc.UFOExperienceState).STARTED.id
]), $aa10bcc7716068d8$var$_UFOStateAvailableTra);
var $aa10bcc7716068d8$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $aa10bcc7716068d8$var$UFOStateAvailableTransitions[state1.id] && $aa10bcc7716068d8$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});






parcelRegister("bIYG9", function(module, exports) {

$parcel$export(module.exports, "AtlassianSwitcherLoader", function () { return $8892df4f7cc34a0c$export$25f16f9fee84a840; });
$parcel$export(module.exports, "JiraSwitcherLoader", function () { return $8892df4f7cc34a0c$export$10767845f9f42bd; });
$parcel$export(module.exports, "ConfluenceSwitcherLoader", function () { return $8892df4f7cc34a0c$export$71f961c620294b68; });
$parcel$export(module.exports, "GenericSwitcherLoader", function () { return $8892df4f7cc34a0c$export$8c21d1a0c59fc17e; });
$parcel$export(module.exports, "TrelloSwitcherLoader", function () { return $8892df4f7cc34a0c$export$21b8192b12701f9e; });

var $bNP0H = parcelRequire("bNP0H");

var $1Mpn7 = parcelRequire("1Mpn7");

var $6HTDA = parcelRequire("6HTDA");

var $8892df4f7cc34a0c$export$6c6894dd831bfacb = function loadAtlassianSwitcher() {
    return (parcelRequire("8FWI1"));
};

var $8892df4f7cc34a0c$export$52c59c5b477673fb = function loadJiraSwitcher() {
    return (parcelRequire("4TcDf"));
};

var $8892df4f7cc34a0c$export$2d2945898d9ee55f = function loadConfluenceSwitcher() {
    return (parcelRequire("5DvyD"));
};

var $8892df4f7cc34a0c$export$64191a36345a6b2b = function loadGenericSwitcher() {
    return (parcelRequire("55wt6"));
};

var $8892df4f7cc34a0c$export$b1037658b0b9e49e = function loadTrelloSwitcher() {
    return (parcelRequire("c8OI7"));
};
var $8892df4f7cc34a0c$export$25f16f9fee84a840 = (0, (/*@__PURE__*/$parcel$interopDefault($bNP0H)))({
    loader: $8892df4f7cc34a0c$export$6c6894dd831bfacb,
    loading: function loading() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $6HTDA.default), null);
    }
});
var $8892df4f7cc34a0c$export$10767845f9f42bd = (0, (/*@__PURE__*/$parcel$interopDefault($bNP0H)))({
    loader: $8892df4f7cc34a0c$export$52c59c5b477673fb,
    loading: function loading() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $6HTDA.default), null);
    }
});
var $8892df4f7cc34a0c$export$71f961c620294b68 = (0, (/*@__PURE__*/$parcel$interopDefault($bNP0H)))({
    loader: $8892df4f7cc34a0c$export$2d2945898d9ee55f,
    loading: function loading() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $6HTDA.default), null);
    }
});
var $8892df4f7cc34a0c$export$8c21d1a0c59fc17e = (0, (/*@__PURE__*/$parcel$interopDefault($bNP0H)))({
    loader: $8892df4f7cc34a0c$export$64191a36345a6b2b,
    loading: function loading() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $6HTDA.default), null);
    }
});
var $8892df4f7cc34a0c$export$21b8192b12701f9e = (0, (/*@__PURE__*/$parcel$interopDefault($bNP0H)))({
    loader: $8892df4f7cc34a0c$export$b1037658b0b9e49e,
    loading: function loading() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $6HTDA.default), null);
    }
});

});
parcelRegister("bNP0H", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
var $897bd6e4723cef4e$var$_typeof = typeof Symbol === "function" && (0, $l0HdX._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
    return typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
};
function $897bd6e4723cef4e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $897bd6e4723cef4e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $897bd6e4723cef4e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $l0HdX._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $1Mpn7 = parcelRequire("1Mpn7");

var $3shKn = parcelRequire("3shKn");
var $897bd6e4723cef4e$var$ALL_INITIALIZERS = [];
var $897bd6e4723cef4e$var$READY_INITIALIZERS = [];
function $897bd6e4723cef4e$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $897bd6e4723cef4e$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $897bd6e4723cef4e$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $897bd6e4723cef4e$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $897bd6e4723cef4e$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $897bd6e4723cef4e$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $897bd6e4723cef4e$var$render(loaded, props) {
    return $1Mpn7.createElement($897bd6e4723cef4e$var$resolve(loaded), props);
}
function $897bd6e4723cef4e$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $897bd6e4723cef4e$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $897bd6e4723cef4e$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $897bd6e4723cef4e$var$READY_INITIALIZERS.push(function() {
        if ($897bd6e4723cef4e$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $897bd6e4723cef4e$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $897bd6e4723cef4e$var$_classCallCheck(this, LoadableComponent);
            var _this = $897bd6e4723cef4e$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $1Mpn7.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($1Mpn7.Component), _class.contextTypes = {
        loadable: $3shKn.shape({
            report: $3shKn.func.isRequired
        })
    }, _temp;
}
function $897bd6e4723cef4e$var$Loadable(opts) {
    return $897bd6e4723cef4e$var$createLoadableComponent($897bd6e4723cef4e$var$load, opts);
}
function $897bd6e4723cef4e$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $897bd6e4723cef4e$var$createLoadableComponent($897bd6e4723cef4e$var$loadMap, opts);
}
$897bd6e4723cef4e$var$Loadable.Map = $897bd6e4723cef4e$var$LoadableMap;
var $897bd6e4723cef4e$var$Capture = function(_React$Component2) {
    $897bd6e4723cef4e$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $897bd6e4723cef4e$var$_classCallCheck(this, Capture);
        return $897bd6e4723cef4e$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $1Mpn7.Children.only(this.props.children);
    };
    return Capture;
}($1Mpn7.Component);
$897bd6e4723cef4e$var$Capture.propTypes = {
    report: $3shKn.func.isRequired
};
$897bd6e4723cef4e$var$Capture.childContextTypes = {
    loadable: $3shKn.shape({
        report: $3shKn.func.isRequired
    }).isRequired
};
$897bd6e4723cef4e$var$Loadable.Capture = $897bd6e4723cef4e$var$Capture;
function $897bd6e4723cef4e$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $897bd6e4723cef4e$var$flushInitializers(initializers);
    });
}
$897bd6e4723cef4e$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $897bd6e4723cef4e$var$flushInitializers($897bd6e4723cef4e$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$897bd6e4723cef4e$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $897bd6e4723cef4e$var$flushInitializers($897bd6e4723cef4e$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $897bd6e4723cef4e$var$Loadable;

});

parcelRegister("6HTDA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e21eaab0a2c1552$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $fBy54 = parcelRequire("fBy54");

var $efQav = parcelRequire("efQav");

var $e66bO = parcelRequire("e66bO");

var $18w8f = parcelRequire("18w8f");

var $aaABR = parcelRequire("aaABR");
var $jVPTG = parcelRequire("jVPTG");
var $4e21eaab0a2c1552$var$iconSkeletonStyles = (0, $fBy54.css)({
    display: "inline-block",
    width: 32,
    height: 32,
    backgroundColor: "var(--ds-skeleton, ".concat($efQav.N20, ")"),
    borderRadius: "var(--ds-border-radius-200, 8px)"
});
var $4e21eaab0a2c1552$var$lineSkeletonStyles = (0, $fBy54.css)({
    display: "inline-block",
    width: 98,
    height: 10,
    backgroundColor: "var(--ds-skeleton, ".concat($efQav.N20, ")"),
    borderRadius: "var(--ds-border-radius, 3px)"
});
var $4e21eaab0a2c1552$var$iconSkeleton = (0, $fBy54.jsx)("div", {
    css: $4e21eaab0a2c1552$var$iconSkeletonStyles
});
var $4e21eaab0a2c1552$var$lineSkeleton = (0, $fBy54.jsx)("div", {
    css: $4e21eaab0a2c1552$var$lineSkeletonStyles
});
var $4e21eaab0a2c1552$export$2e2bcd8739ae039 = function() {
    (0, $jVPTG.useExperienceRenderAndMountMark)((0, $aaABR.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    return (0, $fBy54.jsx)((0, $e66bO.SectionContainer), {
        sectionId: "skeleton",
        title: $4e21eaab0a2c1552$var$lineSkeleton
    }, (0, $fBy54.jsx)((0, $18w8f.default), {
        icon: $4e21eaab0a2c1552$var$iconSkeleton,
        isDisabled: true
    }, $4e21eaab0a2c1552$var$lineSkeleton), (0, $fBy54.jsx)((0, $18w8f.default), {
        icon: $4e21eaab0a2c1552$var$iconSkeleton,
        isDisabled: true
    }, $4e21eaab0a2c1552$var$lineSkeleton), (0, $fBy54.jsx)((0, $18w8f.default), {
        icon: $4e21eaab0a2c1552$var$iconSkeleton,
        isDisabled: true
    }, $4e21eaab0a2c1552$var$lineSkeleton));
};

});
parcelRegister("efQav", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $a60aeef8f96486b3$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $a60aeef8f96486b3$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $a60aeef8f96486b3$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $a60aeef8f96486b3$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $a60aeef8f96486b3$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $a60aeef8f96486b3$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $a60aeef8f96486b3$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N50", function () { return $a60aeef8f96486b3$export$8754fc7e6d8b3000; });
$parcel$export(module.exports, "N100", function () { return $a60aeef8f96486b3$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $a60aeef8f96486b3$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $a60aeef8f96486b3$export$eece5f492e429f08; });
$parcel$export(module.exports, "N600", function () { return $a60aeef8f96486b3$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $a60aeef8f96486b3$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N900", function () { return $a60aeef8f96486b3$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N20A", function () { return $a60aeef8f96486b3$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $a60aeef8f96486b3$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN600", function () { return $a60aeef8f96486b3$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN90", function () { return $a60aeef8f96486b3$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN70", function () { return $a60aeef8f96486b3$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "heading", function () { return $a60aeef8f96486b3$export$46e4a324ac90507f; });
$parcel$export(module.exports, "subtleHeading", function () { return $a60aeef8f96486b3$export$79f3f2b82beb0d36; });
$parcel$export(module.exports, "skeleton", function () { return $a60aeef8f96486b3$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $doqdx = parcelRequire("doqdx");
var $a60aeef8f96486b3$export$4b84fd0e2c617bd = "#FFEBE6";
var $a60aeef8f96486b3$export$b34b069eff244586 = "#FFBDAD";
var $a60aeef8f96486b3$export$be802dd0d8b57f35 = "#FF8F73";
var $a60aeef8f96486b3$export$60847d42f9da92a6 = "#FF7452";
var $a60aeef8f96486b3$export$4a7404f376229999 = "#FF5630";
var $a60aeef8f96486b3$export$2010d0fb4295b346 = "#DE350B";
var $a60aeef8f96486b3$export$2837b5a1a71d5c02 = "#BF2600";
var $a60aeef8f96486b3$export$8d9596b529bbb9cf = "#FFFAE6";
var $a60aeef8f96486b3$export$41060a744ab0b7ae = "#FFF0B3";
var $a60aeef8f96486b3$export$1cc05bbbf340e559 = "#FFE380";
var $a60aeef8f96486b3$export$5aae31392d72caaa = "#FFC400";
var $a60aeef8f96486b3$export$c6930421db9fa514 = "#FFAB00";
var $a60aeef8f96486b3$export$59619663aa6500fb = "#FF991F";
var $a60aeef8f96486b3$export$874739ea9e379ab6 = "#FF8B00";
var $a60aeef8f96486b3$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $a60aeef8f96486b3$export$69a3bf21b9686c2b = "#ABF5D1";
var $a60aeef8f96486b3$export$afbce1382ec95f73 = "#79F2C0";
var $a60aeef8f96486b3$export$747d86715d4175de = "#57D9A3";
var $a60aeef8f96486b3$export$940e1f69e873f202 = "#36B37E";
var $a60aeef8f96486b3$export$a49394138f7b8e85 = "#00875A";
var $a60aeef8f96486b3$export$6fa04827ac68a4fb = "#006644";
var $a60aeef8f96486b3$export$226de0355ed012f8 = "#DEEBFF";
var $a60aeef8f96486b3$export$8c13c2ee36917869 = "#B3D4FF";
var $a60aeef8f96486b3$export$ecfc1dff386a3e7a = "#4C9AFF";
var $a60aeef8f96486b3$export$215b7063051591f1 = "#2684FF";
var $a60aeef8f96486b3$export$e62e8919cca44969 = "#0065FF";
var $a60aeef8f96486b3$export$b3de0ae08da2ce64 = "#0052CC";
var $a60aeef8f96486b3$export$a6ee3d71bc067634 = "#0747A6";
var $a60aeef8f96486b3$export$363e4475840015bb = "#EAE6FF";
var $a60aeef8f96486b3$export$4b0a4417ed59760f = "#C0B6F2";
var $a60aeef8f96486b3$export$6011520a64d9a187 = "#998DD9";
var $a60aeef8f96486b3$export$a7175d4e9206bc80 = "#8777D9";
var $a60aeef8f96486b3$export$b48405b95304b5a1 = "#6554C0";
var $a60aeef8f96486b3$export$c71e4279dd54a18d = "#5243AA";
var $a60aeef8f96486b3$export$147899de772240ec = "#403294";
var $a60aeef8f96486b3$export$2cf711fe14c66f06 = "#E6FCFF";
var $a60aeef8f96486b3$export$7a8f4d33f6f9772c = "#B3F5FF";
var $a60aeef8f96486b3$export$776c9c497ef08533 = "#79E2F2";
var $a60aeef8f96486b3$export$69cb3ca10c1e330e = "#00C7E6";
var $a60aeef8f96486b3$export$9dc1ef0f3f48059b = "#00B8D9";
var $a60aeef8f96486b3$export$7c835c78b6fcdef8 = "#00A3BF";
var $a60aeef8f96486b3$export$6036577f95c3877e = "#008DA6";
var $a60aeef8f96486b3$export$29a4f05edc054374 = "#FFFFFF";
var $a60aeef8f96486b3$export$e655ef011c4aa1a2 = "#FAFBFC";
var $a60aeef8f96486b3$export$9fdfb749e33cdf97 = "#F4F5F7";
var $a60aeef8f96486b3$export$3e51e8f1440314ba = "#EBECF0";
var $a60aeef8f96486b3$export$1ce2d1575d444ceb = "#DFE1E6";
var $a60aeef8f96486b3$export$8754fc7e6d8b3000 = "#C1C7D0";
var $a60aeef8f96486b3$export$c2e91cbeada39b8b = "#B3BAC5";
var $a60aeef8f96486b3$export$5f71e19f3a7ad9de = "#A5ADBA";
var $a60aeef8f96486b3$export$eaa8c8a70ac22806 = "#97A0AF";
var $a60aeef8f96486b3$export$7c87d337fb91a97d = "#8993A4";
var $a60aeef8f96486b3$export$d6447c357493214f = "#7A869A";
var $a60aeef8f96486b3$export$f563ee71e9ee74cd = "#6B778C";
var $a60aeef8f96486b3$export$e2ef2124cf4024b1 = "#5E6C84";
var $a60aeef8f96486b3$export$eece5f492e429f08 = "#505F79";
var $a60aeef8f96486b3$export$c39c0fe0f26207ae = "#42526E";
var $a60aeef8f96486b3$export$7090862dc3038a9f = "#344563";
var $a60aeef8f96486b3$export$ad0bacf983b7ddaa = "#253858";
var $a60aeef8f96486b3$export$7d61b15e0da132af = "#172B4D";
var $a60aeef8f96486b3$export$fbda843f0a27fe96 = "#091E42";
var $a60aeef8f96486b3$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $a60aeef8f96486b3$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $a60aeef8f96486b3$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $a60aeef8f96486b3$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $a60aeef8f96486b3$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $a60aeef8f96486b3$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $a60aeef8f96486b3$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $a60aeef8f96486b3$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $a60aeef8f96486b3$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $a60aeef8f96486b3$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $a60aeef8f96486b3$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $a60aeef8f96486b3$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $a60aeef8f96486b3$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $a60aeef8f96486b3$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $a60aeef8f96486b3$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $a60aeef8f96486b3$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $a60aeef8f96486b3$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $a60aeef8f96486b3$export$2f6319cf7d736c2a = "#E6EDFA";
var $a60aeef8f96486b3$export$95126bc8884d6634 = "#DCE5F5";
var $a60aeef8f96486b3$export$8338d8c35d44ff1 = "#CED9EB";
var $a60aeef8f96486b3$export$5368d76ae4fbbda7 = "#B8C7E0";
var $a60aeef8f96486b3$export$9f0a771d16ec8d36 = "#ABBBD6";
var $a60aeef8f96486b3$export$abcf8c38338b4aa5 = "#9FB0CC";
var $a60aeef8f96486b3$export$97e81faa16a182c7 = "#8C9CB8";
var $a60aeef8f96486b3$export$bfe21c59123ecf33 = "#7988A3";
var $a60aeef8f96486b3$export$ee82aa2ea6a1558 = "#67758F";
var $a60aeef8f96486b3$export$682927c6ed76be02 = "#56637A";
var $a60aeef8f96486b3$export$91fd9994c5be9757 = "#455166";
var $a60aeef8f96486b3$export$d281fbfe3cff2df6 = "#3B475C";
var $a60aeef8f96486b3$export$3902c91d8b98a753 = "#313D52";
var $a60aeef8f96486b3$export$8e8133c1ba5845b5 = "#283447";
var $a60aeef8f96486b3$export$33ff357f6620b39 = "#202B3D";
var $a60aeef8f96486b3$export$633847cf062b69e0 = "#1B2638";
var $a60aeef8f96486b3$export$9776a6e503bdbf76 = "#121A29";
var $a60aeef8f96486b3$export$6c813d5160dff5db = "#0E1624";
var $a60aeef8f96486b3$export$3d4f271a500072a = "#0D1424";
var $a60aeef8f96486b3$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $a60aeef8f96486b3$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $a60aeef8f96486b3$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $a60aeef8f96486b3$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $a60aeef8f96486b3$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $a60aeef8f96486b3$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $a60aeef8f96486b3$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $a60aeef8f96486b3$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $a60aeef8f96486b3$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $a60aeef8f96486b3$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $a60aeef8f96486b3$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $a60aeef8f96486b3$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $a60aeef8f96486b3$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $a60aeef8f96486b3$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $a60aeef8f96486b3$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $a60aeef8f96486b3$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $a60aeef8f96486b3$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $a60aeef8f96486b3$export$8ce1fd94bee2f412 = (0, $doqdx.default)({
    light: "var(--ds-surface, ".concat($a60aeef8f96486b3$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($a60aeef8f96486b3$export$633847cf062b69e0, ")")
});
var $a60aeef8f96486b3$export$b861914ea877b580 = (0, $doqdx.default)({
    light: "var(--ds-background-selected, ".concat($a60aeef8f96486b3$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($a60aeef8f96486b3$export$8c13c2ee36917869, ")")
});
var $a60aeef8f96486b3$export$3f1b020df94387af = (0, $doqdx.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($a60aeef8f96486b3$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($a60aeef8f96486b3$export$d281fbfe3cff2df6, ")")
});
var $a60aeef8f96486b3$export$c0183dbab98ca63e = (0, $doqdx.default)({
    light: "var(--ds-surface-overlay, ".concat($a60aeef8f96486b3$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($a60aeef8f96486b3$export$8e8133c1ba5845b5, ")")
});
var $a60aeef8f96486b3$export$6f093cfa640b7166 = (0, $doqdx.default)({
    light: "var(--ds-text, ".concat($a60aeef8f96486b3$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($a60aeef8f96486b3$export$5368d76ae4fbbda7, ")")
});
var $a60aeef8f96486b3$export$42f8e9c698766e7a = (0, $doqdx.default)({
    light: "var(--ds-text, ".concat($a60aeef8f96486b3$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($a60aeef8f96486b3$export$5368d76ae4fbbda7, ")")
});
var $a60aeef8f96486b3$export$c2d157ca1c34b6e3 = (0, $doqdx.default)({
    light: "var(--ds-text-selected, ".concat($a60aeef8f96486b3$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($a60aeef8f96486b3$export$b3de0ae08da2ce64, ")")
});
var $a60aeef8f96486b3$export$1905ba28d7cf066f = (0, $doqdx.default)({
    light: "var(--ds-text-subtlest, ".concat($a60aeef8f96486b3$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($a60aeef8f96486b3$export$97e81faa16a182c7, ")")
});
var $a60aeef8f96486b3$export$bd9002130d306d39 = (0, $doqdx.default)({
    light: "var(--ds-text-subtlest, ".concat($a60aeef8f96486b3$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($a60aeef8f96486b3$export$bfe21c59123ecf33, ")")
});
var $a60aeef8f96486b3$export$46e4a324ac90507f = (0, $doqdx.default)({
    light: "var(--ds-text, ".concat($a60aeef8f96486b3$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($a60aeef8f96486b3$export$5368d76ae4fbbda7, ")")
});
var $a60aeef8f96486b3$export$79f3f2b82beb0d36 = (0, $doqdx.default)({
    light: "var(--ds-text-subtlest, ".concat($a60aeef8f96486b3$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($a60aeef8f96486b3$export$97e81faa16a182c7, ")")
});
var $a60aeef8f96486b3$export$7bb0d5c671655cc4 = (0, $doqdx.default)({
    light: $a60aeef8f96486b3$export$9fdfb749e33cdf97,
    dark: $a60aeef8f96486b3$export$8e8133c1ba5845b5
});
var $a60aeef8f96486b3$export$9c30223ca0a664fb = (0, $doqdx.default)({
    light: "var(--ds-link, ".concat($a60aeef8f96486b3$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($a60aeef8f96486b3$export$ecfc1dff386a3e7a, ")")
});
var $a60aeef8f96486b3$export$7ed258b0728b004b = (0, $doqdx.default)({
    light: "var(--ds-link-pressed, ".concat($a60aeef8f96486b3$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($a60aeef8f96486b3$export$215b7063051591f1, ")")
});
var $a60aeef8f96486b3$export$dfa920d8decc8a59 = (0, $doqdx.default)({
    light: "var(--ds-link-pressed, ".concat($a60aeef8f96486b3$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($a60aeef8f96486b3$export$ecfc1dff386a3e7a, ")")
});
var $a60aeef8f96486b3$export$6069e6ad5c78f632 = (0, $doqdx.default)({
    light: "var(--ds-border-focused, ".concat($a60aeef8f96486b3$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($a60aeef8f96486b3$export$215b7063051591f1, ")")
});
var $a60aeef8f96486b3$export$9ad721cf3b3debe0 = (0, $doqdx.default)({
    light: "var(--ds-background-brand-bold, ".concat($a60aeef8f96486b3$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($a60aeef8f96486b3$export$ecfc1dff386a3e7a, ")")
});
var $a60aeef8f96486b3$export$2aa0182783e7e9de = (0, $doqdx.default)({
    light: $a60aeef8f96486b3$export$b3de0ae08da2ce64,
    dark: $a60aeef8f96486b3$export$ecfc1dff386a3e7a
});
var $a60aeef8f96486b3$export$8bf7dff220b82b4a = (0, $doqdx.default)({
    light: $a60aeef8f96486b3$export$9dc1ef0f3f48059b,
    dark: $a60aeef8f96486b3$export$69cb3ca10c1e330e
});
var $a60aeef8f96486b3$export$e13cce2a2d16a9d4 = (0, $doqdx.default)({
    light: $a60aeef8f96486b3$export$b48405b95304b5a1,
    dark: $a60aeef8f96486b3$export$6011520a64d9a187
});
var $a60aeef8f96486b3$export$a90204d1394caf30 = (0, $doqdx.default)({
    light: $a60aeef8f96486b3$export$4a7404f376229999,
    dark: $a60aeef8f96486b3$export$4a7404f376229999
});
var $a60aeef8f96486b3$export$594c5a8758200c32 = (0, $doqdx.default)({
    light: $a60aeef8f96486b3$export$c6930421db9fa514,
    dark: $a60aeef8f96486b3$export$c6930421db9fa514
});
var $a60aeef8f96486b3$export$955a2ebd2fb142ae = (0, $doqdx.default)({
    light: $a60aeef8f96486b3$export$940e1f69e873f202,
    dark: $a60aeef8f96486b3$export$940e1f69e873f202
});
var $a60aeef8f96486b3$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($a60aeef8f96486b3$export$8d43898f60b96a82, ")");
};

});
parcelRegister("doqdx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c01da7736b898e0$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $eiXw1 = parcelRequire("eiXw1");
// Unpack custom variants, and get correct value for the current theme
function $9c01da7736b898e0$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $eiXw1.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $9c01da7736b898e0$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $9c01da7736b898e0$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $eiXw1.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("eiXw1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6a0e9a7340f82e9$export$2e2bcd8739ae039; });

var $bE2Ax = parcelRequire("bE2Ax");
function $a6a0e9a7340f82e9$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $bE2Ax.CHANNEL) in props.theme) return props.theme[0, $bE2Ax.CHANNEL];
        else if ("mode" in props.theme && (0, $bE2Ax.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $bE2Ax.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("bE2Ax", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $87a5702344c4c4a4$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $87a5702344c4c4a4$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $87a5702344c4c4a4$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $87a5702344c4c4a4$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $87a5702344c4c4a4$export$85e3c3ca0c6fb93; });

var $2Eqc7 = parcelRequire("2Eqc7");

var $efQav = parcelRequire("efQav");
var $87a5702344c4c4a4$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $87a5702344c4c4a4$export$c93026a968943f95 = "light";
var $87a5702344c4c4a4$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $87a5702344c4c4a4$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $87a5702344c4c4a4$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $87a5702344c4c4a4$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $87a5702344c4c4a4$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $87a5702344c4c4a4$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $87a5702344c4c4a4$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $87a5702344c4c4a4$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $efQav.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $87a5702344c4c4a4$export$6d8204c2cb2e06b8() / 4;
    (0, $2Eqc7.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $87a5702344c4c4a4$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $87a5702344c4c4a4$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $87a5702344c4c4a4$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $2Eqc7.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $87a5702344c4c4a4$export$ba1d834b86d72a09 = $87a5702344c4c4a4$export$a1b3edb637fb4f35;
var $87a5702344c4c4a4$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $efQav.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $efQav.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $efQav.N30A), ")")
            }
        }
    };
};

});




parcelRegister("e66bO", function(module, exports) {

$parcel$export(module.exports, "SectionContainerTitle", function () { return $a4366d5797b51f27$export$7bb82566a1f2a4f5; });
$parcel$export(module.exports, "SwitchToSectionContainer", function () { return $a4366d5797b51f27$export$78cd5e57bb37fdec; });
$parcel$export(module.exports, "SectionContainer", function () { return $a4366d5797b51f27$export$be4c8679ebfd988; });
/** @jsx jsx */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $4mcLN = parcelRequire("4mcLN");

var $8bxNX = parcelRequire("8bxNX");

var $fBy54 = parcelRequire("fBy54");
parcelRequire("l9sEk");
var $5E5nn = parcelRequire("5E5nn");
var $l9sEk = parcelRequire("l9sEk");

var $9HItF = parcelRequire("9HItF");

var $jOXnc = parcelRequire("jOXnc");

var $k8M01 = parcelRequire("k8M01");

var $9RPR6 = parcelRequire("9RPR6");

var $cWK60 = parcelRequire("cWK60");
var $a4366d5797b51f27$var$switchToSectionContainerStyles = (0, $fBy54.css)({
    padding: "var(--ds-space-100, 8px)".concat(" 0")
});
var $a4366d5797b51f27$var$sectionContainerStyles = (0, $fBy54.css)({
    padding: "var(--ds-space-100, 8px)".concat(" ", (0, $cWK60.getBooleanFF)("platform.navigation.atlassian-switcher.design-refresh.m2.enabled") ? "var(--ds-space-100, 8px)" : 0)
});
var $a4366d5797b51f27$var$titleSectionFadeInStyles = (0, $fBy54.css)({
    display: "flex",
    marginLeft: "var(--ds-space-100, 8px)",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "flex-end",
    flexWrap: "nowrap"
});
var $a4366d5797b51f27$var$titleSectionFadeInNoMarginStyles = (0, $fBy54.css)({
    margin: 0
});
var $a4366d5797b51f27$var$titleSectionFadeInStandaloneStyles = (0, $fBy54.css)({
    marginBottom: "var(--ds-space-100, 8px)"
});
var $a4366d5797b51f27$var$titleSectionFadeInDrawerStyles = (0, $fBy54.css)({
    marginBottom: "var(--ds-space-200, 16px)"
});
var $a4366d5797b51f27$var$switchToSectionTitleStyles = (0, $fBy54.css)({
    marginTop: 0,
    marginBottom: 0,
    flex: "1 1 0%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $a4366d5797b51f27$var$switchToSectionContainerTitleStyles = (0, $fBy54.css)({
    textTransform: "uppercase",
    marginLeft: "var(--ds-space-100, 8px)"
});
var $a4366d5797b51f27$var$secondarySectionTitleBaseStyles = (0, $fBy54.css)({
    marginLeft: "var(--ds-space-100, 8px)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textTransform: "uppercase",
    whiteSpace: "nowrap"
});
var $a4366d5797b51f27$var$secondarySectionTitleStandaloneStyles = (0, $fBy54.css)({
    marginBottom: "var(--ds-space-050, 4px)"
});
var $a4366d5797b51f27$var$secondarySectionTitleDrawerStyles = (0, $fBy54.css)({
    marginBottom: "var(--ds-space-100, 8px)"
});
var $a4366d5797b51f27$export$7bb82566a1f2a4f5 = function SectionContainerTitle(_ref) {
    var appearance = _ref.appearance, title = _ref.title;
    return (0, $fBy54.jsx)("div", {
        css: [
            $a4366d5797b51f27$var$secondarySectionTitleBaseStyles,
            appearance === "standalone" ? $a4366d5797b51f27$var$secondarySectionTitleStandaloneStyles : $a4366d5797b51f27$var$secondarySectionTitleDrawerStyles
        ]
    }, (0, $fBy54.jsx)((0, $9RPR6.default), {
        level: "h100"
    }, title));
};
var $a4366d5797b51f27$var$SectionContainerComponent = function SectionContainerComponent(props) {
    var title = props.title, titleLink = props.titleLink, children = props.children, appearance = props.appearance, actionSubject = props.actionSubject, sectionId = props.sectionId;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Children.toArray(children).some(Boolean) ? (0, $fBy54.jsx)("section", {
        css: $a4366d5797b51f27$var$sectionContainerStyles,
        "data-testid": "".concat(sectionId, "__section")
    }, (0, $fBy54.jsx)((0, $9HItF.FadeIn), null, title && (0, $fBy54.jsx)($a4366d5797b51f27$export$7bb82566a1f2a4f5, {
        appearance: appearance,
        title: title
    }), titleLink && (0, $fBy54.jsx)($a4366d5797b51f27$var$TitleLink, {
        titleLink: titleLink,
        actionSubject: actionSubject
    })), children) : null;
};
var $a4366d5797b51f27$var$SwitchToSectionContainerComponent = function SwitchToSectionContainerComponent(props) {
    var title = props.title, titleLink = props.titleLink, children = props.children, appearance = props.appearance, actionSubject = props.actionSubject, sectionId = props.sectionId;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Children.toArray(children).some(Boolean) ? (0, $fBy54.jsx)("section", {
        css: $a4366d5797b51f27$var$switchToSectionContainerStyles,
        "data-testid": "".concat(sectionId, "__section")
    }, (0, $fBy54.jsx)((0, $9HItF.FadeIn), {
        css: [
            $a4366d5797b51f27$var$titleSectionFadeInStyles,
            (0, $cWK60.getBooleanFF)("platform.navigation.atlassian-switcher.design-refresh.m2.enabled") && $a4366d5797b51f27$var$titleSectionFadeInNoMarginStyles,
            appearance === "standalone" ? $a4366d5797b51f27$var$titleSectionFadeInStandaloneStyles : $a4366d5797b51f27$var$titleSectionFadeInDrawerStyles
        ]
    }, title && ((0, $cWK60.getBooleanFF)("platform.navigation.atlassian-switcher.design-refresh.m2.enabled") ? (0, $fBy54.jsx)("div", {
        css: [
            $a4366d5797b51f27$var$switchToSectionContainerTitleStyles,
            $a4366d5797b51f27$var$switchToSectionTitleStyles
        ]
    }, (0, $fBy54.jsx)((0, $9RPR6.default), {
        level: "h300"
    }, title)) : (0, $fBy54.jsx)("h1", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $fBy54.css)($4mcLN.h500()),
            $a4366d5797b51f27$var$switchToSectionTitleStyles
        ]
    }, title)), titleLink && (0, $fBy54.jsx)($a4366d5797b51f27$var$TitleLink, {
        titleLink: titleLink,
        actionSubject: actionSubject
    })), children) : null;
};
var $a4366d5797b51f27$var$TitleLink = function TitleLink(_ref2) {
    var titleLink = _ref2.titleLink, actionSubject = _ref2.actionSubject;
    return (0, $fBy54.jsx)((0, $5E5nn.NavigationAnalyticsContext), {
        key: titleLink.key,
        data: (0, $l9sEk.getItemAnalyticsContext)(0, titleLink.key, (0, $k8M01.AnalyticsItemType).PRODUCT, titleLink.productType)
    }, (0, $fBy54.jsx)((0, $jOXnc.default), {
        href: titleLink.href,
        iconAfter: (0, $fBy54.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8bxNX))), {
            size: "small",
            label: ""
        }),
        label: titleLink.label,
        testId: "section-title__link",
        actionSubject: actionSubject
    }));
};
var $a4366d5797b51f27$export$78cd5e57bb37fdec = (0, $l9sEk.withAnalyticsContextData)(function(props) {
    return (0, $l9sEk.analyticsAttributes)({
        group: props.sectionId,
        groupItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Children.count(props.children)
    });
})($a4366d5797b51f27$var$SwitchToSectionContainerComponent);
var $a4366d5797b51f27$export$be4c8679ebfd988 = (0, $l9sEk.withAnalyticsContextData)(function(props) {
    return (0, $l9sEk.analyticsAttributes)({
        group: props.sectionId,
        groupItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Children.count(props.children)
    });
})($a4366d5797b51f27$var$SectionContainerComponent);

});
parcelRegister("4mcLN", function(module, exports) {

$parcel$export(module.exports, "h500", function () { return $32c31f52e1925781$export$85aa43a9b9f06707; });

var $jjExS = parcelRequire("jjExS");

var $efQav = parcelRequire("efQav");

var $bE2Ax = parcelRequire("bE2Ax");
function $32c31f52e1925781$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32c31f52e1925781$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32c31f52e1925781$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32c31f52e1925781$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $32c31f52e1925781$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / (0, $bE2Ax.fontSize)(), "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $32c31f52e1925781$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $32c31f52e1925781$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $32c31f52e1925781$var$_objectSpread($32c31f52e1925781$var$_objectSpread({}, $32c31f52e1925781$var$baseHeading($32c31f52e1925781$export$bc02e067df412c3b.h900.size, $32c31f52e1925781$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $efQav.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $bE2Ax.gridSize)() * 6.5, "px")
    });
};
var $32c31f52e1925781$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $32c31f52e1925781$var$_objectSpread($32c31f52e1925781$var$_objectSpread({}, $32c31f52e1925781$var$baseHeading($32c31f52e1925781$export$bc02e067df412c3b.h800.size, $32c31f52e1925781$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $efQav.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $bE2Ax.gridSize)() * 5, "px")
    });
};
var $32c31f52e1925781$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $32c31f52e1925781$var$_objectSpread($32c31f52e1925781$var$_objectSpread({}, $32c31f52e1925781$var$baseHeading($32c31f52e1925781$export$bc02e067df412c3b.h700.size, $32c31f52e1925781$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $efQav.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $bE2Ax.gridSize)() * 5, "px")
    });
};
var $32c31f52e1925781$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $32c31f52e1925781$var$_objectSpread($32c31f52e1925781$var$_objectSpread({}, $32c31f52e1925781$var$baseHeading($32c31f52e1925781$export$bc02e067df412c3b.h600.size, $32c31f52e1925781$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $efQav.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $bE2Ax.gridSize)() * 3.5, "px")
    });
};
var $32c31f52e1925781$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $32c31f52e1925781$var$_objectSpread($32c31f52e1925781$var$_objectSpread({}, $32c31f52e1925781$var$baseHeading($32c31f52e1925781$export$bc02e067df412c3b.h500.size, $32c31f52e1925781$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $efQav.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $bE2Ax.gridSize)() * 3, "px")
    });
};
var $32c31f52e1925781$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $32c31f52e1925781$var$_objectSpread($32c31f52e1925781$var$_objectSpread({}, $32c31f52e1925781$var$baseHeading($32c31f52e1925781$export$bc02e067df412c3b.h400.size, $32c31f52e1925781$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $efQav.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $bE2Ax.gridSize)() * 2, "px")
    });
};
var $32c31f52e1925781$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $32c31f52e1925781$var$_objectSpread($32c31f52e1925781$var$_objectSpread({}, $32c31f52e1925781$var$baseHeading($32c31f52e1925781$export$bc02e067df412c3b.h300.size, $32c31f52e1925781$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $efQav.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $bE2Ax.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $32c31f52e1925781$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $32c31f52e1925781$var$_objectSpread($32c31f52e1925781$var$_objectSpread({}, $32c31f52e1925781$var$baseHeading($32c31f52e1925781$export$bc02e067df412c3b.h200.size, $32c31f52e1925781$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $efQav.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $bE2Ax.gridSize)() * 2, "px")
    });
};
var $32c31f52e1925781$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $32c31f52e1925781$var$_objectSpread($32c31f52e1925781$var$_objectSpread({}, $32c31f52e1925781$var$baseHeading($32c31f52e1925781$export$bc02e067df412c3b.h100.size, $32c31f52e1925781$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $efQav.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $bE2Ax.gridSize)() * 2, "px")
    });
};

});

parcelRegister("8bxNX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f5992b6de3eb295$var$_react = $5f5992b6de3eb295$var$_interopRequireDefault((parcelRequire("1Mpn7")));

var $cotNw = parcelRequire("cotNw");
function $5f5992b6de3eb295$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5f5992b6de3eb295$var$ShortcutIcon = function(props) {
    return /*#__PURE__*/ $5f5992b6de3eb295$var$_react.default.createElement($cotNw.Icon, Object.assign({
        dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M19.005 19c-.003 0-.005.002-.005.002l.005-.002zM5 19.006c0-.004-.002-.006-.005-.006H5v.006zM5 4.994V5v-.006zM19 19v-6h2v6.002A1.996 1.996 0 0119.005 21H4.995A1.996 1.996 0 013 19.006V4.994C3 3.893 3.896 3 4.997 3H11v2H5v14h14zM5 4.994V5v-.006zm0 14.012c0-.004-.002-.006-.005-.006H5v.006zM11 5H5v14h14v-6h2v6.002A1.996 1.996 0 0119.005 21H4.995A1.996 1.996 0 013 19.006V4.994C3 3.893 3.896 3 4.997 3H11v2zm8 0v3a1 1 0 002 0V4a1 1 0 00-1-1h-4a1 1 0 000 2h3z"/><path d="M12.707 12.707l8-8a1 1 0 10-1.414-1.414l-8 8a1 1 0 001.414 1.414z"/></g></svg>'
    }, props));
};
$5f5992b6de3eb295$var$ShortcutIcon.displayName = "ShortcutIcon";
var $5f5992b6de3eb295$var$_default = $5f5992b6de3eb295$var$ShortcutIcon;
module.exports.default = $5f5992b6de3eb295$var$_default;

});

parcelRegister("l9sEk", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CHANNEL", function () { return $f660a968b6003029$export$515664faa1398f37; });
$parcel$export(module.exports, "SWITCHER_SUBJECT", function () { return $f660a968b6003029$export$17ff9c46e41eb585; });
$parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", function () { return $f660a968b6003029$export$7598b001981cfda5; });
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", function () { return $f660a968b6003029$export$c3c93e13b09d3ad9; });
$parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", function () { return $f660a968b6003029$export$7d4d527df0e3789c; });
$parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", function () { return $f660a968b6003029$export$16cf10618135eb24; });
$parcel$export(module.exports, "SWITCHER_COMPONENT", function () { return $f660a968b6003029$export$2b570fc112cbca; });
$parcel$export(module.exports, "SWITCHER_SOURCE", function () { return $f660a968b6003029$export$5ed36c4d23de5568; });
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", function () { return $f660a968b6003029$export$4649adbfda1b6a66; });
$parcel$export(module.exports, "SWITCHER_ORG_ITEM", function () { return $f660a968b6003029$export$6dd696c9ad636a67; });
$parcel$export(module.exports, "SWITCHER_FOOTER_LEAVE_FEEDBACK", function () { return $f660a968b6003029$export$af0b3e734498c53c; });
$parcel$export(module.exports, "SWITCHER_CURRENT_ORG", function () { return $f660a968b6003029$export$44c7ac3fdc1d62b8; });
$parcel$export(module.exports, "SWITCHER_ORG_LIST", function () { return $f660a968b6003029$export$d9d2f872f3b91169; });
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", function () { return $f660a968b6003029$export$5724539c9b1a3a5d; });
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", function () { return $f660a968b6003029$export$22f5f827d9934254; });
$parcel$export(module.exports, "createAndFireNavigationEvent", function () { return $f660a968b6003029$export$884b1a4c7ac9dd14; });
$parcel$export(module.exports, "analyticsAttributes", function () { return $f660a968b6003029$export$a305f130b289b818; });
$parcel$export(module.exports, "withAnalyticsContextData", function () { return $f660a968b6003029$export$97ebdd8e7274f18a; });
$parcel$export(module.exports, "RenderTracker", function () { return $f660a968b6003029$export$e09ad93c2b74b853; });
$parcel$export(module.exports, "NotRenderedTracker", function () { return $f660a968b6003029$export$95b1f1a72cad0dcb; });
$parcel$export(module.exports, "ViewedTracker", function () { return $f660a968b6003029$export$b3fd6624b6a6d057; });
$parcel$export(module.exports, "ImageLoadedTracker", function () { return $f660a968b6003029$export$7609fab79cf145a0; });
$parcel$export(module.exports, "getJoinableSitesRenderTracker", function () { return $f660a968b6003029$export$e823e937102b322b; });
$parcel$export(module.exports, "getDiscoverSectionRenderTracker", function () { return $f660a968b6003029$export$eff0211e47c4d541; });
$parcel$export(module.exports, "getRecentContainersRenderTracker", function () { return $f660a968b6003029$export$92f66a8a67c9c3ce; });
$parcel$export(module.exports, "getCustomLinksRenderTracker", function () { return $f660a968b6003029$export$d75a4f56d85f67ea; });
$parcel$export(module.exports, "getItemAnalyticsContext", function () { return $f660a968b6003029$export$6489efba2ca85102; });
$parcel$export(module.exports, "withAnalyticsEvents", function () { return (parcelRequire("g1gbh")).default; });
$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return (parcelRequire("5E5nn")).NavigationAnalyticsContext; });
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", function () { return (parcelRequire("5p8VA")).OPERATIONAL_EVENT_TYPE; });
$parcel$export(module.exports, "UI_EVENT_TYPE", function () { return (parcelRequire("5p8VA")).UI_EVENT_TYPE; });

var $fjkYW = parcelRequire("fjkYW");

var $04Kcc = parcelRequire("04Kcc");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("9YK2q");
var $5E5nn = parcelRequire("5E5nn");

var $4j9Ig = parcelRequire("4j9Ig");
var $145N3 = parcelRequire("145N3");
var $g1gbh = parcelRequire("g1gbh");

var $5p8VA = parcelRequire("5p8VA");

var $5a4MH = parcelRequire("5a4MH");

var $hCulG = parcelRequire("hCulG");

var $7Ym0l = parcelRequire("7Ym0l");

var $f6bvG = parcelRequire("f6bvG");
var $f660a968b6003029$var$_excluded = [
    "onLoad",
    "onError"
];
function $f660a968b6003029$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f660a968b6003029$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $f660a968b6003029$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f660a968b6003029$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f660a968b6003029$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f660a968b6003029$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f660a968b6003029$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f660a968b6003029$export$515664faa1398f37 = "navigation";
var $f660a968b6003029$export$17ff9c46e41eb585 = "atlassianSwitcher";
var $f660a968b6003029$export$7598b001981cfda5 = "atlassianSwitcherItem";
var $f660a968b6003029$export$c3c93e13b09d3ad9 = "atlassianSwitcherItemLozenges";
var $f660a968b6003029$export$7d4d527df0e3789c = "atlassianSwitcherChildItem";
var $f660a968b6003029$export$16cf10618135eb24 = "atlassianSwitcherItemExpand";
var $f660a968b6003029$export$2b570fc112cbca = "atlassianSwitcher";
var $f660a968b6003029$export$5ed36c4d23de5568 = "atlassianSwitcher";
var $f660a968b6003029$export$8d2f933bbd9e4f09 = "atlassianSwitcherPrefetch";
var $f660a968b6003029$export$d7029a5dc66b0736 = "atlassianSwitcherPrefetch";
var $f660a968b6003029$export$4649adbfda1b6a66 = "atlassianSwitcherPartialResultError";
var $f660a968b6003029$export$6dd696c9ad636a67 = "atlassianSwitcherOrgItem";
var $f660a968b6003029$export$af0b3e734498c53c = "atlassianSwitcherFooterLeaveFeedback";
var $f660a968b6003029$export$44c7ac3fdc1d62b8 = "atlassianSwitcherCurrentOrg";
var $f660a968b6003029$export$d9d2f872f3b91169 = "atlassianSwitcherOrganisationsList";
var $f660a968b6003029$export$5724539c9b1a3a5d = "atlassianSwitcherJoinableSites";
var $f660a968b6003029$export$22f5f827d9934254 = "atlassianSwitcherAvailableProducts";
var $f660a968b6003029$var$SWITCHER_DISCOVER_SECTION = "atlassianSwitcherDiscoverMore";
var $f660a968b6003029$var$SWITCHER_RECENT_CONTAINERS = "atlassianSwitcherRecentContainers";
var $f660a968b6003029$var$SWITCHER_CUSTOM_LINKS = "atlassianSwitcherCustomLinks";
var $f660a968b6003029$var$SWITCHER_REMOTE_ICON = "atlassianSwitcherRemoteIcon";
var $f660a968b6003029$var$RENDERED_ACTION = "rendered";
var $f660a968b6003029$var$NOT_RENDERED_ACTION = "not_rendered";
var $f660a968b6003029$var$VIEWED_ACTION = "viewed";
var $f660a968b6003029$var$LOADED_ACTION = "loaded";
var $f660a968b6003029$var$NOT_LOADED_ACTION = "not_loaded";
var $f660a968b6003029$export$884b1a4c7ac9dd14 = (0, $4j9Ig.default)($f660a968b6003029$export$515664faa1398f37);
var $f660a968b6003029$export$a305f130b289b818 = function analyticsAttributes(attributes) {
    return {
        attributes: attributes
    };
};
var $f660a968b6003029$export$97ebdd8e7274f18a = function withAnalyticsContextData(mapPropsToContext) {
    return function(WrappedComponent) {
        return function(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $5E5nn.NavigationAnalyticsContext), {
                data: mapPropsToContext(props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement(WrappedComponent, props));
        };
    };
};
var $f660a968b6003029$var$isValidDuration = function isValidDuration(duration) {
    return duration !== null && duration !== undefined && duration >= 0;
};
var $f660a968b6003029$export$e09ad93c2b74b853 = (0, $g1gbh.default)({
    onRender: function onRender(createAnalyticsEvent, props) {
        var _props$data;
        var duration = (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.duration;
        return createAnalyticsEvent({
            eventType: (0, $5p8VA.OPERATIONAL_EVENT_TYPE),
            action: $f660a968b6003029$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: $f660a968b6003029$var$_objectSpread($f660a968b6003029$var$_objectSpread({}, props.data), $f660a968b6003029$var$isValidDuration(duration) && {
                bucket: (0, $7Ym0l.getMetricBucket)(duration, (0, $7Ym0l.RenderTrackerBuckets))
            })
        }).fire($f660a968b6003029$export$515664faa1398f37);
    }
})(/*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(_class, _React$Component);
    var _super = $f660a968b6003029$var$_createSuper(_class);
    function _class() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, _class);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(_class, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.onRender();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return _class;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Component));
var $f660a968b6003029$export$95b1f1a72cad0dcb = (0, $g1gbh.default)({
    onRender: function onRender(createAnalyticsEvent, props) {
        return createAnalyticsEvent({
            eventType: (0, $5p8VA.OPERATIONAL_EVENT_TYPE),
            action: $f660a968b6003029$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($f660a968b6003029$export$515664faa1398f37);
    }
})(/*#__PURE__*/ function(_React$Component2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(_class2, _React$Component2);
    var _super2 = $f660a968b6003029$var$_createSuper(_class2);
    function _class2() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, _class2);
        return _super2.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(_class2, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.onRender();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return _class2;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Component));
var $f660a968b6003029$export$b3fd6624b6a6d057 = (0, $g1gbh.default)({
    onRender: function onRender(createAnalyticsEvent, props) {
        return createAnalyticsEvent({
            eventType: (0, $5p8VA.UI_EVENT_TYPE),
            action: $f660a968b6003029$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($f660a968b6003029$export$515664faa1398f37);
    }
})(/*#__PURE__*/ function(_React$Component3) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(_class3, _React$Component3);
    var _super3 = $f660a968b6003029$var$_createSuper(_class3);
    function _class3() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, _class3);
        return _super3.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(_class3, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.onRender();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return _class3;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Component));
var $f660a968b6003029$export$7609fab79cf145a0 = function ImageLoadedTracker(props) {
    var onLoad = props.onLoad, onError = props.onError, imgProps = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(props, $f660a968b6003029$var$_excluded);
    var _useAnalyticsEvents = (0, $145N3.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var imageMountedAt = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useRef((0, $f6bvG.performanceNow)());
    var analyticsHandler = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useCallback(function(actionType, event, action) {
        var duration = (0, $f6bvG.performanceNow)() - imageMountedAt.current;
        createAnalyticsEvent({
            action: actionType,
            actionSubject: $f660a968b6003029$var$SWITCHER_REMOTE_ICON,
            attributes: $f660a968b6003029$var$_objectSpread($f660a968b6003029$var$_objectSpread({}, $f660a968b6003029$var$isValidDuration(duration) && {
                bucket: (0, $7Ym0l.getMetricBucket)(duration, (0, $7Ym0l.ImageLoadTrackerBuckets)),
                duration: duration
            }), {}, {
                src: imgProps.src
            }),
            eventType: (0, $5p8VA.OPERATIONAL_EVENT_TYPE)
        }).fire($f660a968b6003029$export$515664faa1398f37);
        if (action) action(event);
    }, [
        createAnalyticsEvent,
        imageMountedAt,
        imgProps.src
    ]);
    var onErrorAnalyticsHandler = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useCallback(function(errorEvent) {
        analyticsHandler($f660a968b6003029$var$NOT_LOADED_ACTION, errorEvent, onError);
    }, [
        analyticsHandler,
        onError
    ]);
    var onLoadAnalyticsHandler = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useCallback(function(loadEvent) {
        analyticsHandler($f660a968b6003029$var$LOADED_ACTION, loadEvent, onLoad);
    }, [
        analyticsHandler,
        onLoad
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("img", (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({}, imgProps, {
        onError: onErrorAnalyticsHandler,
        onLoad: onLoadAnalyticsHandler
    }));
};
var $f660a968b6003029$var$renderTrackerWithReason = function renderTrackerWithReason(_ref) {
    var subject = _ref.subject, notRenderedReason = _ref.notRenderedReason, emptyRenderExpected = _ref.emptyRenderExpected, data = _ref.data;
    if (notRenderedReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($f660a968b6003029$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: $f660a968b6003029$var$_objectSpread($f660a968b6003029$var$_objectSpread({}, data), {}, {
            notRenderedReason: notRenderedReason
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($f660a968b6003029$export$e09ad93c2b74b853, {
        subject: subject,
        data: $f660a968b6003029$var$_objectSpread($f660a968b6003029$var$_objectSpread({}, data), {}, {
            emptyRender: emptyRenderExpected
        })
    });
};
var $f660a968b6003029$var$renderTracker = function renderTracker(_ref2) {
    var subject = _ref2.subject, providerFailed = _ref2.providerFailed, emptyRenderExpected = _ref2.emptyRenderExpected, linksRendered = _ref2.linksRendered, data = _ref2.data;
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($f660a968b6003029$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: $f660a968b6003029$var$_objectSpread($f660a968b6003029$var$_objectSpread({}, data), {}, {
            providerFailed: providerFailed
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($f660a968b6003029$export$e09ad93c2b74b853, {
        subject: subject,
        data: $f660a968b6003029$var$_objectSpread($f660a968b6003029$var$_objectSpread({}, data), {}, {
            emptyRender: emptyRenderExpected
        })
    });
};
var $f660a968b6003029$export$e823e937102b322b = function getJoinableSitesRenderTracker(providerResult, joinableSiteLinks, data) {
    if (!(0, $5a4MH.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    var emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $f660a968b6003029$var$renderTracker({
        subject: $f660a968b6003029$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
var $f660a968b6003029$export$eff0211e47c4d541 = function getDiscoverSectionRenderTracker(xflowProviderResult, provisionedProductsProviderResult, joinableSitesProviderResult, productRecommendationsProviderResult, suggestedProductLinks, data) {
    var hasProviderNotReturnedExpectedData = function hasProviderNotReturnedExpectedData(provider) {
        return provider.data === null || provider.status === (0, $5a4MH.Status).ERROR;
    };
    var collectResults = function collectResults(provider) {
        return {
            failed: hasProviderNotReturnedExpectedData(provider),
            loaded: (0, $5a4MH.hasLoaded)(provider)
        };
    };
    var emptyRenderExpected = suggestedProductLinks.length === 0;
    var results = {
        xflow: collectResults(xflowProviderResult),
        provisionedProducts: collectResults(provisionedProductsProviderResult),
        joinableSites: collectResults(joinableSitesProviderResult),
        productRecommendations: collectResults(productRecommendationsProviderResult)
    };
    var providersLoaded = results.joinableSites.loaded && results.provisionedProducts.loaded && results.xflow.loaded && results.productRecommendations.loaded;
    if (!providersLoaded) return null;
    var didProviderFail = results.joinableSites.failed || results.provisionedProducts.failed || results.xflow.failed || results.productRecommendations.failed;
    /**
   * Stop tracking the SLO the moment one of the providers fail.
   */ if (didProviderFail) return $f660a968b6003029$var$renderTracker({
        subject: $f660a968b6003029$var$SWITCHER_DISCOVER_SECTION,
        providerFailed: true,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: suggestedProductLinks,
        data: $f660a968b6003029$var$_objectSpread($f660a968b6003029$var$_objectSpread({}, data), {}, {
            providerResults: {
                joinableSites: joinableSitesProviderResult.status,
                joinableSitesFailed: results.joinableSites.failed,
                provisionedProducts: provisionedProductsProviderResult.status,
                provisionedProductsFailed: results.provisionedProducts.failed,
                xflow: xflowProviderResult.status,
                xflowFailed: results.xflow.failed,
                productRecommendations: productRecommendationsProviderResult.status,
                productRecommendationsFailed: results.productRecommendations.failed
            }
        })
    });
    return $f660a968b6003029$var$renderTracker({
        subject: $f660a968b6003029$var$SWITCHER_DISCOVER_SECTION,
        providerFailed: false,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: suggestedProductLinks,
        data: data
    });
};
var $f660a968b6003029$export$92f66a8a67c9c3ce = function getRecentContainersRenderTracker(isEnabled, cgRecentContainersProviderResult, userSiteDataProviderResult, recentLinks, data) {
    if (!isEnabled) return null;
    var providerFailed = cgRecentContainersProviderResult.data === null || userSiteDataProviderResult.data === null;
    var emptyRenderExpected = Boolean(cgRecentContainersProviderResult.data && cgRecentContainersProviderResult.data.collaborationGraphEntities && cgRecentContainersProviderResult.data.collaborationGraphEntities.length === 0);
    return $f660a968b6003029$var$renderTracker({
        subject: $f660a968b6003029$var$SWITCHER_RECENT_CONTAINERS,
        providerFailed: providerFailed,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: recentLinks,
        data: data
    });
};
var $f660a968b6003029$export$d75a4f56d85f67ea = function getCustomLinksRenderTracker(customLinksProviderResult, userSiteDataProviderResult, customLinks, data) {
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    var emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if ((customLinksProviderResult === null || customLinksProviderResult === void 0 ? void 0 : customLinksProviderResult.status) === (0, $5a4MH.Status).ERROR) return "custom_links_api_error";
        var error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $hCulG.UserSiteDataError)) return error.reason;
        else return "usd_unknown";
    }
    var notRenderedReason = getNotRenderedReason();
    return $f660a968b6003029$var$renderTrackerWithReason({
        subject: $f660a968b6003029$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
var $f660a968b6003029$export$6489efba2ca85102 = function getItemAnalyticsContext(groupIndex, id, type, productType, extraAttributes) {
    return $f660a968b6003029$var$_objectSpread({}, $f660a968b6003029$export$a305f130b289b818($f660a968b6003029$var$_objectSpread({
        groupIndex: groupIndex,
        itemId: id,
        itemType: type,
        productType: productType
    }, extraAttributes)));
};

});
parcelRegister("9YK2q", function(module, exports) {

$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return (parcelRequire("5E5nn")).NavigationAnalyticsContext; });

var $03sp1 = parcelRequire("03sp1");

var $5E5nn = parcelRequire("5E5nn");

var $7YiiV = parcelRequire("7YiiV");

var $64fdX = parcelRequire("64fdX");

var $fHaZQ = parcelRequire("fHaZQ");

var $7GYTA = parcelRequire("7GYTA");

var $8bvlO = parcelRequire("8bvlO");

var $cCtaH = parcelRequire("cCtaH");

var $bSYTB = parcelRequire("bSYTB");

});
parcelRegister("03sp1", function(module, exports) {

var $3UDmL = parcelRequire("3UDmL");
var $00a650166e891828$export$80450e0a84a5ede9 = "fabricElementsCtx";
var $00a650166e891828$export$3fe25500478a635c = (0, $3UDmL.default)($00a650166e891828$export$80450e0a84a5ede9, "FabricElementsAnalyticsContext");

});
parcelRegister("3UDmL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d952356a03329ff$export$2e2bcd8739ae039; });

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $h9UE0 = parcelRequire("h9UE0");
var $2d952356a03329ff$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "NamespacedContext";
    var Component = function Component(props) {
        var newData = (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $h9UE0.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $2d952356a03329ff$export$2e2bcd8739ae039 = $2d952356a03329ff$var$createNamespaceContext;

});
parcelRegister("h9UE0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7df3747031decf9$export$2e2bcd8739ae039; });

var $a6f9h = parcelRequire("a6f9h");

var $a0AXg = parcelRequire("a0AXg");

var $3qWgZ = parcelRequire("3qWgZ");
var $c7df3747031decf9$var$_process$env;
var $c7df3747031decf9$var$ExportedAnalyticsContext;
if (typeof $3qWgZ !== "undefined" && $3qWgZ !== null && ($c7df3747031decf9$var$_process$env = {}, true) && $c7df3747031decf9$var$_process$env !== void 0 && $c7df3747031decf9$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]) $c7df3747031decf9$var$ExportedAnalyticsContext = (0, $a0AXg.default);
else $c7df3747031decf9$var$ExportedAnalyticsContext = (0, $a6f9h.default);
var $c7df3747031decf9$export$2e2bcd8739ae039 = $c7df3747031decf9$var$ExportedAnalyticsContext;

});
parcelRegister("a6f9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75a63728423923c4$export$2e2bcd8739ae039; });

var $eetQ9 = parcelRequire("eetQ9");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $hgJzq = parcelRequire("hgJzq");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $3shKn = parcelRequire("3shKn");

var $3z3zk = parcelRequire("3z3zk");
function $75a63728423923c4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $75a63728423923c4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $75a63728423923c4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $75a63728423923c4$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($3shKn))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($3shKn))).func
};
var $75a63728423923c4$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $75a63728423923c4$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(AnalyticsContext, _Component);
    var _super = $75a63728423923c4$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $75a63728423923c4$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $75a63728423923c4$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $3z3zk.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $1Mpn7.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($75a63728423923c4$var$AnalyticsContext, "contextTypes", $75a63728423923c4$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($75a63728423923c4$var$AnalyticsContext, "childContextTypes", $75a63728423923c4$var$ContextTypes);
var $75a63728423923c4$export$2e2bcd8739ae039 = $75a63728423923c4$var$AnalyticsContext;

});

parcelRegister("a0AXg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $749691ec99332b8e$export$2e2bcd8739ae039; });

var $eetQ9 = parcelRequire("eetQ9");

var $1Mpn7 = parcelRequire("1Mpn7");

var $3z3zk = parcelRequire("3z3zk");

var $gVJ1N = parcelRequire("gVJ1N");

var $8JCSe = parcelRequire("8JCSe");
var $749691ec99332b8e$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $8JCSe.useTrackedRef)(data);
    var analyticsContext = (0, $gVJ1N.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $1Mpn7.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $1Mpn7.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $3z3zk.default).Provider, {
        value: value
    }, children);
};
var $749691ec99332b8e$export$2e2bcd8739ae039 = $749691ec99332b8e$var$AnalyticsContext;

});




parcelRegister("5E5nn", function(module, exports) {

$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return $41c4dbbcd258f217$export$d0a82da1a0b94929; });

var $3UDmL = parcelRequire("3UDmL");
var $41c4dbbcd258f217$export$1fd3aad76a7c6788 = "navigationCtx";
var $41c4dbbcd258f217$export$d0a82da1a0b94929 = (0, $3UDmL.default)($41c4dbbcd258f217$export$1fd3aad76a7c6788, "NavigationAnalyticsContext");

});

parcelRegister("7YiiV", function(module, exports) {

var $3UDmL = parcelRequire("3UDmL");
var $5cdc55d9f7f765b5$export$8c8f6d8f1fa796f0 = "fabricEditorCtx";
var $5cdc55d9f7f765b5$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $5cdc55d9f7f765b5$export$629cada6c5e621e1 = (0, $3UDmL.default)($5cdc55d9f7f765b5$export$8c8f6d8f1fa796f0, "FabricEditorAnalyticsContext");

});

parcelRegister("64fdX", function(module, exports) {
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var $46aeed000fa6adb8$export$70df29c238ba7306 = "mediaCtx"; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});

parcelRegister("fHaZQ", function(module, exports) {

var $3UDmL = parcelRequire("3UDmL");
var $b6d366d31a05c913$export$b326383bee6cb993 = "peopleTeamsCtx";
var $b6d366d31a05c913$export$4119ddb38ccbfb87 = (0, $3UDmL.default)($b6d366d31a05c913$export$b326383bee6cb993, "PeopleTeamsAnalyticsContext");

});

parcelRegister("7GYTA", function(module, exports) {

var $3UDmL = parcelRequire("3UDmL");
var $599bb13d64467aa6$export$da1befb791e93c7e = "NotificationsCtx";
var $599bb13d64467aa6$export$6f8e7ff1e3feafd7 = (0, $3UDmL.default)($599bb13d64467aa6$export$da1befb791e93c7e, "NotificationsAnalyticsContext");

});

parcelRegister("8bvlO", function(module, exports) {

var $3UDmL = parcelRequire("3UDmL");
var $5f57ab68596bdde7$export$fc7a65795610cb71 = "RecentWorkCtx";
var $5f57ab68596bdde7$export$745926731087ebe2 = (0, $3UDmL.default)($5f57ab68596bdde7$export$fc7a65795610cb71, "RecentWorkAnalyticsContext");

});

parcelRegister("cCtaH", function(module, exports) {

var $3UDmL = parcelRequire("3UDmL");
var $92ffa98165d14e8a$export$4906017439f33fc0 = "atlasCtx";
var $92ffa98165d14e8a$export$43ebbe41370d4543 = (0, $3UDmL.default)($92ffa98165d14e8a$export$4906017439f33fc0, "AtlasAnalyticsContext");

});

parcelRegister("bSYTB", function(module, exports) {

var $3UDmL = parcelRequire("3UDmL");
var $8a73f97c7b4b3b55$export$3240443bf2b83834 = "linkingPlatformCtx";
var $8a73f97c7b4b3b55$export$6d568da622ce0a08 = (0, $3UDmL.default)($8a73f97c7b4b3b55$export$3240443bf2b83834, "LinkingPlatformAnalyticsContext");

});


parcelRegister("5p8VA", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", function () { return $3ef6366b99e1c6bb$export$a1562d08625f5d7e; });
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", function () { return $3ef6366b99e1c6bb$export$12346a674644c156; });
// same types defined in analytics-web-client but avoid creating dependency with that
var $3ef6366b99e1c6bb$export$a1562d08625f5d7e = "ui";
var $3ef6366b99e1c6bb$export$947dac6c72b26f81 = "track";
var $3ef6366b99e1c6bb$export$f1d537d508d2945a = "screen";
var $3ef6366b99e1c6bb$export$12346a674644c156 = "operational";
var $3ef6366b99e1c6bb$export$b055de0e665cb20c = "unknown";

});

parcelRegister("5a4MH", function(module, exports) {

$parcel$export(module.exports, "Status", function () { return $3c2199029e6b2105$export$96e9906d6d93a972; });
$parcel$export(module.exports, "createResultComplete", function () { return $3c2199029e6b2105$export$947ceca65da0e7a6; });
$parcel$export(module.exports, "isComplete", function () { return $3c2199029e6b2105$export$9569565a7ac14e8e; });
$parcel$export(module.exports, "isError", function () { return $3c2199029e6b2105$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "hasLoaded", function () { return $3c2199029e6b2105$export$5fce62f50756dbf; });
$parcel$export(module.exports, "default", function () { return $3c2199029e6b2105$export$2e2bcd8739ae039; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $hgJzq = parcelRequire("hgJzq");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");
parcelRequire("l9sEk");
var $5p8VA = parcelRequire("5p8VA");
var $l9sEk = parcelRequire("l9sEk");
var $g1gbh = parcelRequire("g1gbh");

var $ariLb = parcelRequire("ariLb");

var $cWqUY = parcelRequire("cWqUY");

var $4xpt7 = parcelRequire("4xpt7");
function $3c2199029e6b2105$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c2199029e6b2105$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c2199029e6b2105$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c2199029e6b2105$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3c2199029e6b2105$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3c2199029e6b2105$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $3c2199029e6b2105$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $3c2199029e6b2105$var$DATA_PROVIDER_SUBJECT = "atlassianSwitcherDataProvider";
var $3c2199029e6b2105$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
var $3c2199029e6b2105$export$947ceca65da0e7a6 = function createResultComplete(data) {
    return {
        status: $3c2199029e6b2105$export$96e9906d6d93a972.COMPLETE,
        data: data
    };
};
var $3c2199029e6b2105$export$9569565a7ac14e8e = function isComplete(result) {
    return result.status === $3c2199029e6b2105$export$96e9906d6d93a972.COMPLETE;
};
var $3c2199029e6b2105$export$e6127cc7fe7395c3 = function isError(result) {
    return result.status === $3c2199029e6b2105$export$96e9906d6d93a972.ERROR;
};
var $3c2199029e6b2105$export$20bb0d907fbbe433 = function isLoading(result) {
    return result.status === $3c2199029e6b2105$export$96e9906d6d93a972.LOADING;
};
var $3c2199029e6b2105$export$5fce62f50756dbf = function hasLoaded(result) {
    return result.status !== $3c2199029e6b2105$export$96e9906d6d93a972.LOADING;
};
function $3c2199029e6b2105$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    var getInitialState = function getInitialState(props) {
        if (mapPropsToInitialValue) {
            var initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: $3c2199029e6b2105$export$96e9906d6d93a972.COMPLETE,
                data: initialValue
            };
        }
        return {
            status: $3c2199029e6b2105$export$96e9906d6d93a972.LOADING,
            data: null
        };
    };
    var DataProvider = /*#__PURE__*/ function(_React$Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(DataProvider, _React$Component);
        var _super = $3c2199029e6b2105$var$_createSuper(DataProvider);
        function DataProvider() {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, DataProvider);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "acceptResults", true);
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "state", getInitialState(_this.props));
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "fireOperationalEvent", function(payload) {
                if (_this.props.createAnalyticsEvent) _this.props.createAnalyticsEvent($3c2199029e6b2105$var$_objectSpread($3c2199029e6b2105$var$_objectSpread({
                    eventType: (0, $5p8VA.OPERATIONAL_EVENT_TYPE),
                    actionSubject: $3c2199029e6b2105$var$DATA_PROVIDER_SUBJECT
                }, payload), {}, {
                    attributes: $3c2199029e6b2105$var$_objectSpread($3c2199029e6b2105$var$_objectSpread({}, payload.attributes), {}, {
                        outdated: !_this.acceptResults
                    })
                })).fire((0, $l9sEk.NAVIGATION_CHANNEL));
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(DataProvider, [
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    /**
         * Promise resolved after component is unmounted to be ignored
         */ this.acceptResults = false;
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.props.experienceTracker.markStart(experienceMark);
                    this.fetchData();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (shouldUpdate !== null && shouldUpdate !== void 0 && shouldUpdate(prevProps, this.props)) this.fetchData();
                }
            },
            {
                key: "fetchData",
                value: function fetchData() {
                    var _this2 = this;
                    (0, $cWqUY.retryOnException)(function() {
                        return mapPropsToPromise(_this2.props);
                    }, {
                        intervalsMS: (retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS) || [],
                        shouldRetryOnException: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.shouldRetryOnException,
                        onRetry: function onRetry(previousException, retryCount) {
                            _this2.onRetry(previousException, retryCount);
                        }
                    }).then(function(result) {
                        _this2.onResult(result);
                    }).catch(function(error) {
                        _this2.onError(error);
                    });
                }
            },
            {
                key: "onResult",
                value: function onResult(value) {
                    if (this.acceptResults) this.setState({
                        data: value,
                        status: $3c2199029e6b2105$export$96e9906d6d93a972.COMPLETE
                    });
                    this.props.experienceTracker.markEnd(experienceMark);
                    this.fireOperationalEvent({
                        action: "receivedResult",
                        actionSubjectId: name,
                        attributes: {
                            provider: name
                        }
                    });
                }
            },
            {
                key: "onRetry",
                value: function onRetry(error, retryCount) {
                    this.fireOperationalEvent({
                        action: "retried",
                        actionSubjectId: name,
                        attributes: {
                            provider: name,
                            reason: retryConfig !== null && retryConfig !== void 0 && retryConfig.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $ariLb.errorToReason)(error),
                            retryCount: retryCount
                        }
                    });
                }
            },
            {
                key: "onError",
                value: function onError(error) {
                    /**
         * Do not transition from "complete" state to "error"
         */ if (this.acceptResults && !$3c2199029e6b2105$export$9569565a7ac14e8e(this.state)) this.setState({
                        error: error,
                        status: $3c2199029e6b2105$export$96e9906d6d93a972.ERROR,
                        data: null
                    });
                    this.fireOperationalEvent({
                        action: "failed",
                        actionSubjectId: name,
                        attributes: {
                            provider: name,
                            reason: (0, $ariLb.errorToReason)(error)
                        }
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    return this.props.children(this.state);
                }
            }
        ]);
        return DataProvider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Component);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(DataProvider, "displayName", "DataProvider(".concat(name, ")"));
    return (0, $g1gbh.default)()((0, $4xpt7.withExperienceTracker)(DataProvider));
}

});
parcelRegister("ariLb", function(module, exports) {

$parcel$export(module.exports, "errorToReason", function () { return $799afa5abab373be$export$a3e288208721751b; });
function $799afa5abab373be$export$a3e288208721751b(error) {
    var _ref = error || {}, _ref$name = _ref.name, name = _ref$name === void 0 ? "Unknown" : _ref$name, _ref$status = _ref.status, status = _ref$status === void 0 ? undefined : _ref$status;
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("cWqUY", function(module, exports) {

$parcel$export(module.exports, "retryOnException", function () { return $96bfc827f6a5817a$export$1d94629c94e7a17f; });

var $e8dor = parcelRequire("e8dor");

var $fGIeY = parcelRequire("fGIeY");
var $96bfc827f6a5817a$export$5c069c93d2b7493f = function wait(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $96bfc827f6a5817a$export$1d94629c94e7a17f = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee(invokeOperation, config) {
        var nextMSInterval, error, retries;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    nextMSInterval = 0;
                    error = new Error("No calls made");
                    retries = config.intervalsMS.length;
                case 3:
                    if (!(nextMSInterval !== undefined)) {
                        _context.next = 22;
                        break;
                    }
                    _context.prev = 4;
                    if (!(nextMSInterval > 0)) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 8;
                    return $96bfc827f6a5817a$export$5c069c93d2b7493f(nextMSInterval);
                case 8:
                    if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
                case 9:
                    _context.next = 11;
                    return invokeOperation();
                case 11:
                    return _context.abrupt("return", _context.sent);
                case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](4);
                    error = _context.t0;
                    if (!(config.shouldRetryOnException && !config.shouldRetryOnException(error))) {
                        _context.next = 19;
                        break;
                    }
                    throw error;
                case 19:
                    nextMSInterval = config.intervalsMS.shift();
                case 20:
                    _context.next = 3;
                    break;
                case 22:
                    throw error;
                case 23:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                14
            ]
        ]);
    }));
    return function retryOnException(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});

parcelRegister("4xpt7", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperienceTrackerContext", function () { return $34de00071992931c$export$3f3eebb4b8116461; });
$parcel$export(module.exports, "useExperienceTracker", function () { return $34de00071992931c$export$cdefb2a8b53f879f; });
$parcel$export(module.exports, "withExperienceTracker", function () { return $34de00071992931c$export$f88dde183f4d31cb; });

var $fjkYW = parcelRequire("fjkYW");

var $1Mpn7 = parcelRequire("1Mpn7");
var $34de00071992931c$var$noop = function noop() {};
var $34de00071992931c$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $1Mpn7.createContext)({
    start: $34de00071992931c$var$noop,
    success: $34de00071992931c$var$noop,
    failure: $34de00071992931c$var$noop,
    failureAll: $34de00071992931c$var$noop,
    abort: $34de00071992931c$var$noop,
    abortAll: $34de00071992931c$var$noop,
    markStart: $34de00071992931c$var$noop,
    markEnd: $34de00071992931c$var$noop
});
var $34de00071992931c$export$cdefb2a8b53f879f = function useExperienceTracker() {
    return (0, $1Mpn7.useContext)($34de00071992931c$export$3f3eebb4b8116461);
};
var $34de00071992931c$export$f88dde183f4d31cb = function withExperienceTracker(Component) {
    var WithExperienceTracker = function WithExperienceTracker(props) {
        var experienceTracker = $34de00071992931c$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({}, props, {
            experienceTracker: experienceTracker
        }));
    };
    WithExperienceTracker.displayName = "WithExperienceTracker(".concat(Component.displayName, ")");
    return WithExperienceTracker;
};

});


parcelRegister("hCulG", function(module, exports) {

$parcel$export(module.exports, "UserSiteDataErrorReason", function () { return $cd3d86e13825739d$export$b08600051ba52198; });
$parcel$export(module.exports, "UserSiteDataError", function () { return $cd3d86e13825739d$export$c460344055e97b1; });

var $2Yk1N = parcelRequire("2Yk1N");

var $6QU8A = parcelRequire("6QU8A");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $8B3ag = parcelRequire("8B3ag");
function $cd3d86e13825739d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cd3d86e13825739d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $cd3d86e13825739d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $cd3d86e13825739d$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
var $cd3d86e13825739d$export$c460344055e97b1 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(UserSiteDataError, _Error);
    var _super = $cd3d86e13825739d$var$_createSuper(UserSiteDataError);
    function UserSiteDataError(reason, message) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, UserSiteDataError);
        _this = _super.call(this, message);
        _this.name = "UserSiteDataError";
        _this.reason = reason;
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(UserSiteDataError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8B3ag)))(Error));

});

parcelRegister("7Ym0l", function(module, exports) {

$parcel$export(module.exports, "ImageLoadTrackerBuckets", function () { return $5cdf34a8c2de6fc8$export$5fbf68affeca91cd; });
$parcel$export(module.exports, "RenderTrackerBuckets", function () { return $5cdf34a8c2de6fc8$export$e59c24bc0768d568; });
$parcel$export(module.exports, "getMetricBucket", function () { return $5cdf34a8c2de6fc8$export$b59492d26971ae92; });
var $5cdf34a8c2de6fc8$var$INFINITY = "+Inf";
var $5cdf34a8c2de6fc8$export$5fbf68affeca91cd = [
    4000,
    2000,
    1000,
    500,
    100,
    50
];
var $5cdf34a8c2de6fc8$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
var $5cdf34a8c2de6fc8$export$b59492d26971ae92 = function getMetricBucket(metricValue, buckets) {
    return metricValue >= 0 ? buckets.reduce(function(lowestBucket, currentBucket) {
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $5cdf34a8c2de6fc8$var$INFINITY) : null;
};

});

parcelRegister("f6bvG", function(module, exports) {

$parcel$export(module.exports, "performanceNow", function () { return $afe0582f9fb36ddb$export$fb4230f160368c88; });
var $afe0582f9fb36ddb$export$fb4230f160368c88 = typeof window !== "undefined" && window.performance && window.performance.now.bind(performance) || Date.now;

});


parcelRegister("9HItF", function(module, exports) {

$parcel$export(module.exports, "FadeIn", function () { return $710aa17ed90c66eb$export$bd7370ffb2917ab7; });
/** @jsx jsx */ parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");
var $710aa17ed90c66eb$var$fadeIn = (0, $fBy54.keyframes)({
    to: {
        opacity: 1
    }
});
var $710aa17ed90c66eb$var$fadeInStyles = (0, $fBy54.css)({
    animation: "".concat($710aa17ed90c66eb$var$fadeIn, " 500ms ease forwards"),
    opacity: 0
});
var $710aa17ed90c66eb$export$bd7370ffb2917ab7 = function FadeIn(props) {
    return (0, $fBy54.jsx)("div", {
        css: $710aa17ed90c66eb$var$fadeInStyles,
        className: props.className
    }, props.children);
};

});

parcelRegister("jOXnc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6e0be1a17a9e67b$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $7Xcnn = parcelRequire("7Xcnn");

var $8bxNX = parcelRequire("8bxNX");

var $g1gbh = parcelRequire("g1gbh");

var $5p8VA = parcelRequire("5p8VA");

var $l9sEk = parcelRequire("l9sEk");
var $e6e0be1a17a9e67b$var$ItemLink = function ItemLink(_ref) {
    var label = _ref.label, href = _ref.href, testId = _ref.testId, onClick = _ref.onClick;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $7Xcnn.default), {
        appearance: "link",
        href: href,
        className: "section-link",
        target: "_blank",
        rel: "noopener noreferrer",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8bxNX))), {
            size: "small",
            label: ""
        }),
        onClick: onClick ? function(e, a) {
            return onClick(e, a);
        } : undefined,
        testId: testId
    }, label);
};
var $e6e0be1a17a9e67b$export$2e2bcd8739ae039 = (0, $g1gbh.default)({
    onClick: (0, $l9sEk.createAndFireNavigationEvent)({
        eventType: (0, $5p8VA.UI_EVENT_TYPE),
        action: "clicked",
        actionSubject: (0, $l9sEk.SWITCHER_ITEM_SUBJECT)
    })
})($e6e0be1a17a9e67b$var$ItemLink);

});

parcelRegister("k8M01", function(module, exports) {

$parcel$export(module.exports, "CollaborationGraphRecentContainerType", function () { return $ea99c9a63e7b3f8a$export$405e7bccf91c0dd6; });
$parcel$export(module.exports, "Permissions", function () { return $ea99c9a63e7b3f8a$export$2d41982586bbb6be; });
$parcel$export(module.exports, "Product", function () { return $ea99c9a63e7b3f8a$export$264ad599d7cef668; });
$parcel$export(module.exports, "Feature", function () { return $ea99c9a63e7b3f8a$export$6e91cf7616333d5; });
$parcel$export(module.exports, "AnalyticsItemType", function () { return $ea99c9a63e7b3f8a$export$77f267162e8983fb; });
$parcel$export(module.exports, "ProductKey", function () { return $ea99c9a63e7b3f8a$export$f3a53bd43617a593; });
$parcel$export(module.exports, "DiscoverLinkItemKeys", function () { return $ea99c9a63e7b3f8a$export$b5f05566ea758e86; });
var $ea99c9a63e7b3f8a$export$32bb98a9a0fbbcb0 = /*#__PURE__*/ function(RecentContainerType) {
    RecentContainerType["JIRA_PROJECT"] = "jira-project";
    RecentContainerType["CONFLUENCE_SPACE"] = "confluence-space";
    return RecentContainerType;
}({});
var $ea99c9a63e7b3f8a$export$405e7bccf91c0dd6 = /*#__PURE__*/ function(CollaborationGraphRecentContainerType) {
    CollaborationGraphRecentContainerType["JIRA_PROJECT"] = "jiraProject";
    CollaborationGraphRecentContainerType["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CollaborationGraphRecentContainerType;
}({});
var $ea99c9a63e7b3f8a$export$2d41982586bbb6be = /*#__PURE__*/ function(Permissions) {
    Permissions["MANAGE"] = "manage";
    Permissions["CAN_INVITE_USERS"] = "invite-users";
    return Permissions;
}({});
var $ea99c9a63e7b3f8a$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["BITBUCKET"] = "bitbucket";
    Product["CONFLUENCE"] = "confluence";
    Product["HOME"] = "home";
    Product["JIRA"] = "jira";
    Product["SITE_ADMIN"] = "site-admin";
    Product["TRELLO"] = "trello";
    Product["START"] = "start";
    return Product;
}({});
var $ea99c9a63e7b3f8a$export$6e91cf7616333d5 = /*#__PURE__*/ function(Feature) {
    Feature["disableCustomLinks"] = "disableCustomLinks";
    Feature["enableRecentContainers"] = "enableRecentContainers";
    Feature["xflow"] = "xflow";
    Feature["isProductStoreInTrelloJSWFirstEnabled"] = "isProductStoreInTrelloJSWFirstEnabled";
    Feature["isProductStoreInTrelloConfluenceFirstEnabled"] = "isProductStoreInTrelloConfluenceFirstEnabled";
    Feature["isSlackDiscoveryEnabled"] = "isSlackDiscoveryEnabled";
    Feature["isUFOEnabled"] = "isUFOEnabled";
    Feature["isHighlightJwmInSwitcherExtendedAudienceEnabled"] = "isHighlightJwmInSwitcherExtendedAudienceEnabled";
    Feature["isSuggestAtlasInSwitcherEnabled"] = "isSuggestAtlasInSwitcherEnabled";
    return Feature;
}({});
var $ea99c9a63e7b3f8a$export$77f267162e8983fb = /*#__PURE__*/ function(AnalyticsItemType) {
    AnalyticsItemType["PRODUCT"] = "product";
    AnalyticsItemType["ADMIN"] = "admin";
    AnalyticsItemType["TRY"] = "try";
    AnalyticsItemType["JOIN"] = "join";
    AnalyticsItemType["CUSTOM_LINK"] = "customLink";
    AnalyticsItemType["DISCOVER_FIXED_LINKS"] = "discover-fixed-links";
    AnalyticsItemType["RECENT"] = "recent";
    AnalyticsItemType["EMPTY_STATE_EXPLORE_PRODUCTS"] = "empty-state-explore-products";
    return AnalyticsItemType;
}({});
var $ea99c9a63e7b3f8a$export$f3a53bd43617a593 = /*#__PURE__*/ function(ProductKey) {
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKey["BITBUCKET"] = "bitbucket";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["TRELLO"] = "trello";
    ProductKey["COMPASS"] = "compass";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
    return ProductKey;
}({});
var $ea99c9a63e7b3f8a$export$b5f05566ea758e86 = /*#__PURE__*/ function(DiscoverLinkItemKeys) {
    DiscoverLinkItemKeys["DISCOVER_MORE"] = "discover-more";
    DiscoverLinkItemKeys["SLACK_INTEGRATION"] = "slack-integration";
    return DiscoverLinkItemKeys;
}({}); //

});

parcelRegister("9RPR6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72f149bc67edae5e$export$2e2bcd8739ae039; });

var $l0HdX = parcelRequire("l0HdX");

var $fjkYW = parcelRequire("fjkYW");

var $04Kcc = parcelRequire("04Kcc");

var $e6gyJ = parcelRequire("e6gyJ");

var $fBy54 = parcelRequire("fBy54");

var $avC2F = parcelRequire("avC2F");

var $eZdbf = parcelRequire("eZdbf");

var $3qWgZ = parcelRequire("3qWgZ");
var $72f149bc67edae5e$var$_excluded = [
    "level",
    "variant"
];
// https://atlassian.design/foundations/typography
var $72f149bc67edae5e$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $72f149bc67edae5e$var$headingResetStyles = (0, $fBy54.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $72f149bc67edae5e$var$h900Styles = (0, $fBy54.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $72f149bc67edae5e$var$h800Styles = (0, $fBy54.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $72f149bc67edae5e$var$h700Styles = (0, $fBy54.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $72f149bc67edae5e$var$h600Styles = (0, $fBy54.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $72f149bc67edae5e$var$h500Styles = (0, $fBy54.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $72f149bc67edae5e$var$h400Styles = (0, $fBy54.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $72f149bc67edae5e$var$h300Styles = (0, $fBy54.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $72f149bc67edae5e$var$h200Styles = (0, $fBy54.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $72f149bc67edae5e$var$h100Styles = (0, $fBy54.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $72f149bc67edae5e$var$inverseStyles = (0, $fBy54.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $72f149bc67edae5e$var$subtlestStyles = (0, $fBy54.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $72f149bc67edae5e$var$Heading = function Heading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $3qWgZ === "undefined" ? "undefined" : (0, $l0HdX._)($3qWgZ);
    var _useHeading = (0, $avC2F.useHeading)($72f149bc67edae5e$var$levelMap[level]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $fBy54.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $72f149bc67edae5e$var$headingResetStyles,
            level === "h100" && $72f149bc67edae5e$var$h100Styles,
            level === "h200" && $72f149bc67edae5e$var$h200Styles,
            level === "h300" && $72f149bc67edae5e$var$h300Styles,
            level === "h400" && $72f149bc67edae5e$var$h400Styles,
            level === "h500" && $72f149bc67edae5e$var$h500Styles,
            level === "h600" && $72f149bc67edae5e$var$h600Styles,
            level === "h700" && $72f149bc67edae5e$var$h700Styles,
            level === "h800" && $72f149bc67edae5e$var$h800Styles,
            level === "h900" && $72f149bc67edae5e$var$h900Styles,
            color === "inverse" && $72f149bc67edae5e$var$inverseStyles,
            color === "default" && isSubtleHeading && $72f149bc67edae5e$var$subtlestStyles
        ]
    }, children);
};
var $72f149bc67edae5e$export$2e2bcd8739ae039 = function(_ref2) {
    var level = _ref2.level, variant = _ref2.variant, props = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref2, $72f149bc67edae5e$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $fBy54.jsx)($72f149bc67edae5e$var$Heading, (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $fBy54.jsx)((0, $eZdbf.default), (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({
        variant: variant
    }, props));
};

});
parcelRegister("avC2F", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $7a6a4efe466521ff$export$97a37b1befbbf9b1; });

var $1Mpn7 = parcelRequire("1Mpn7");
// Allows support for heading levels 1-9 via aria-level
var $7a6a4efe466521ff$var$HeadingLevelContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(0);
var $7a6a4efe466521ff$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $1Mpn7.useContext)($7a6a4efe466521ff$var$HeadingLevelContext);
};
var $7a6a4efe466521ff$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $7a6a4efe466521ff$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injectes the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $7a6a4efe466521ff$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $7a6a4efe466521ff$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($7a6a4efe466521ff$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $7a6a4efe466521ff$export$2e2bcd8739ae039 = $7a6a4efe466521ff$var$HeadingLevelContextProvider;

});

parcelRegister("eZdbf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae90fc8f31e7bcae$export$2e2bcd8739ae039; });

var $l0HdX = parcelRequire("l0HdX");

var $e6gyJ = parcelRequire("e6gyJ");

var $fBy54 = parcelRequire("fBy54");

var $avC2F = parcelRequire("avC2F");

var $3qWgZ = parcelRequire("3qWgZ");
// https://atlassian.design/foundations/typography
var $ae90fc8f31e7bcae$var$levelMap = {
    xxlarge: "h1",
    xlarge: "h2",
    large: "h3",
    medium: "h4",
    small: "h5",
    xsmall: "h6",
    xxsmall: "div"
};
var $ae90fc8f31e7bcae$var$headingResetStyles = (0, $fBy54.css)({
    color: "var(--ds-text, #172B4D)",
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $ae90fc8f31e7bcae$var$inverseStyles = (0, $fBy54.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const HeadingXXL = () => (
 *   <Heading level="xxlarge">XXL</Heading>
 * );
 * ```
 */ var $ae90fc8f31e7bcae$var$Heading = function Heading(_ref) {
    var children = _ref.children, variant = _ref.variant, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $3qWgZ === "undefined" ? "undefined" : (0, $l0HdX._)($3qWgZ);
    var _useHeading = (0, $avC2F.useHeading)($ae90fc8f31e7bcae$var$levelMap[variant]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $fBy54.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $ae90fc8f31e7bcae$var$headingResetStyles,
            variant && $ae90fc8f31e7bcae$var$headingVariantStylesMap[variant],
            color === "inverse" && $ae90fc8f31e7bcae$var$inverseStyles
        ]
    }, children);
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cabcd4e0313e10dd81733a6ffcdbc90f>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $ae90fc8f31e7bcae$var$headingVariantStylesMap = {
    large: (0, $fBy54.css)({
        font: "var(--ds-font-heading-large, normal 500 24px/28px var(--ds-font-family-heading))"
    }),
    medium: (0, $fBy54.css)({
        font: "var(--ds-font-heading-medium, normal 500 20px/24px var(--ds-font-family-heading))"
    }),
    small: (0, $fBy54.css)({
        font: "var(--ds-font-heading-small, normal 600 16px/20px var(--ds-font-family-heading))"
    }),
    xlarge: (0, $fBy54.css)({
        font: "var(--ds-font-heading-xlarge, normal 600 29px/32px var(--ds-font-family-heading))"
    }),
    xsmall: (0, $fBy54.css)({
        font: "var(--ds-font-heading-xsmall, normal 600 14px/16px var(--ds-font-family-heading))"
    }),
    xxlarge: (0, $fBy54.css)({
        font: "var(--ds-font-heading-xxlarge, normal 500 35px/40px var(--ds-font-family-heading))"
    }),
    xxsmall: (0, $fBy54.css)({
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px var(--ds-font-family-heading))"
    })
};
var /**
 * @codegenEnd
 */ $ae90fc8f31e7bcae$export$2e2bcd8739ae039 = $ae90fc8f31e7bcae$var$Heading;

});



parcelRegister("18w8f", function(module, exports) {

$parcel$export(module.exports, "LozengeType", function () { return $0d3f768aab25e01b$export$b95b532653e2b7f6; });
$parcel$export(module.exports, "default", function () { return $0d3f768aab25e01b$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $04Kcc = parcelRequire("04Kcc");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $cnXlK = parcelRequire("cnXlK");

var $l9sEk = parcelRequire("l9sEk");

var $9HItF = parcelRequire("9HItF");

var $fBy54 = parcelRequire("fBy54");

var $2ZTAv = parcelRequire("2ZTAv");

var $inZyb = parcelRequire("inZyb");

var $cWK60 = parcelRequire("cWK60");

var $8RcaX = parcelRequire("8RcaX");

var $UCi4b = parcelRequire("UCi4b");

var $efQav = parcelRequire("efQav");
var $0d3f768aab25e01b$var$_excluded = [
    "icon",
    "description",
    "elemAfter",
    "shouldAllowMultiline",
    "onClick",
    "children",
    "lozenges",
    "product",
    "createAnalyticsEvent"
];
var $0d3f768aab25e01b$export$b95b532653e2b7f6 = /*#__PURE__*/ function(LozengeType) {
    LozengeType["New"] = "new";
    return LozengeType;
}({});
var $0d3f768aab25e01b$var$lozengeData = (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, $0d3f768aab25e01b$export$b95b532653e2b7f6.New, {
    label: (0, $8RcaX.default).newLozenge,
    componentProps: {
        appearance: "new"
    }
});
var $0d3f768aab25e01b$var$fadeInStyles = (0, $fBy54.css)({
    width: "100%"
});
var $0d3f768aab25e01b$var$itemDescriptionStyles = (0, $fBy54.css)({
    color: "var(--ds-text-subtlest, ".concat($efQav.N200, ")"),
    fontSize: 11,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $0d3f768aab25e01b$var$SwitcherItem = function SwitcherItem(_ref) {
    var icon = _ref.icon, description = _ref.description, elemAfter = _ref.elemAfter, shouldAllowMultiline = _ref.shouldAllowMultiline, _onClick = _ref.onClick, children = _ref.children, lozenges = _ref.lozenges, product = _ref.product, createAnalyticsEvent = _ref.createAnalyticsEvent, rest = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref, $0d3f768aab25e01b$var$_excluded);
    var itemDescription = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useMemo(function() {
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).isValidElement(description) || typeof description === "string") return (0, $fBy54.jsx)("div", {
            css: $0d3f768aab25e01b$var$itemDescriptionStyles
        }, description);
        return undefined;
    }, [
        description
    ]);
    var renderLozenges = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).useMemo(function() {
        if (!(lozenges !== null && lozenges !== void 0 && lozenges.length)) return null;
        return (0, $fBy54.jsx)((0, $UCi4b.default), {
            product: product,
            triggerSubject: "switcherItemLozengeErrorBoundary",
            hideFallbackUI: true
        }, (0, $fBy54.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, lozenges.map(function(lozenge) {
            var _lozengeData$lozenge = $0d3f768aab25e01b$var$lozengeData[lozenge], componentProps = _lozengeData$lozenge.componentProps, label = _lozengeData$lozenge.label;
            return (0, $fBy54.jsx)("span", {
                style: {
                    marginLeft: "var(--ds-space-100, 8px)"
                }
            }, (0, $fBy54.jsx)((0, $2ZTAv.default), (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({}, componentProps, {
                "data-testid": "switcher-item-lozenge"
            }), (0, $fBy54.jsx)((0, $inZyb.default), label)));
        }), (0, $fBy54.jsx)((0, $l9sEk.RenderTracker), {
            subject: (0, $l9sEk.SWITCHER_ITEM_LOZENGES_SUBJECT),
            data: {
                product: product,
                lozenges: lozenges,
                children: children,
                description: description
            }
        })));
    }, [
        lozenges,
        product,
        children,
        description
    ]);
    return (0, $fBy54.jsx)((0, $9HItF.FadeIn), {
        css: $0d3f768aab25e01b$var$fadeInStyles
    }, (0, $fBy54.jsx)((0, $cnXlK.default), (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({
        testId: "switcher-base-item",
        description: itemDescription,
        iconBefore: icon,
        iconAfter: elemAfter,
        target: (0, $cWK60.getBooleanFF)("platform.navigation.atlassian-switcher.design-refresh.m2.enabled") ? "_blank" : undefined,
        onClick: function onClick(event) {
            if (_onClick) _onClick(event);
        }
    }, rest), children, renderLozenges));
};
var $0d3f768aab25e01b$export$2e2bcd8739ae039 = $0d3f768aab25e01b$var$SwitcherItem;

});
parcelRegister("cnXlK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9045aba26f0965b8$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $2Eqc7 = parcelRequire("2Eqc7");

var $x0QfA = parcelRequire("x0QfA");

var $cWK60 = parcelRequire("cWK60");

var $juSyB = parcelRequire("juSyB");
var $9045aba26f0965b8$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className"
];
var $9045aba26f0965b8$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $9045aba26f0965b8$var$LinkItem = /*#__PURE__*/ (0, $1Mpn7.memo)(/*#__PURE__*/ (0, $1Mpn7.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $x0QfA.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(props, $9045aba26f0965b8$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    if (!children) return null;
    (0, $2Eqc7.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $x0QfA.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $fBy54.jsx)((0, $juSyB.default), (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({}, rest, {
        className: (0, $cWK60.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $fBy54.jsx)("a", (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({
            "data-testid": testId
        }, rest, {
            className: className,
            href: isDisabled ? undefined : href,
            draggable: false,
            onDragStart: $9045aba26f0965b8$var$preventEvent,
            onMouseDown: isDisabled ? $9045aba26f0965b8$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $9045aba26f0965b8$var$preventEvent : onClick,
            "aria-current": isSelected ? "page" : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $9045aba26f0965b8$export$2e2bcd8739ae039 = $9045aba26f0965b8$var$LinkItem;

});
parcelRegister("juSyB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e31b238bed554038$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $2Eqc7 = parcelRequire("2Eqc7");

var $imeJC = parcelRequire("imeJC");

var $cWK60 = parcelRequire("cWK60");

var $3dRkO = parcelRequire("3dRkO");

var $9ZwXq = parcelRequire("9ZwXq");

var $lYgFP = parcelRequire("lYgFP");
var $e31b238bed554038$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $fBy54.jsx)(Component, props));
};
var $e31b238bed554038$var$beforeAfterElementStyles = (0, $fBy54.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $e31b238bed554038$var$contentStyles = (0, $fBy54.css)({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    flexGrow: 1,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    outline: "none",
    overflow: "hidden",
    textAlign: "left"
});
var $e31b238bed554038$var$truncateStyles = (0, $fBy54.css)({
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $e31b238bed554038$var$wordBreakStyles = (0, $fBy54.css)({
    wordBreak: "break-word"
});
var $e31b238bed554038$var$descriptionStyles = (0, $fBy54.css)({
    marginTop: "var(--ds-space-050, 4px)",
    color: "var(--ds-text-subtlest, ".concat((0, $9ZwXq.N200), ")"),
    fontSize: "var(--ds-font-size-075, 12px)"
});
var $e31b238bed554038$var$disabledDescriptionStyles = (0, $fBy54.css)({
    color: "var(--ds-text-disabled, ".concat((0, $9ZwXq.N200), ")")
});
var $e31b238bed554038$var$positionRelativeStyles = (0, $fBy54.css)({
    position: "relative"
});
var $e31b238bed554038$var$primitiveStyles = (0, $fBy54.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: "center",
    border: 0,
    fontSize: "var(--ds-font-size-100, 14px)",
    outline: 0,
    textDecoration: "none",
    userSelect: "none",
    "::-moz-focus-inner": {
        border: 0
    },
    ":hover": {
        textDecoration: "none"
    }
});
var $e31b238bed554038$var$spacingMapStyles = {
    cozy: (0, $fBy54.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $fBy54.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $e31b238bed554038$var$interactiveStyles = (0, $fBy54.css)({
    cursor: "pointer"
});
var $e31b238bed554038$var$unselectedStyles = (0, $fBy54.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: "currentColor",
    ":visited": {
        color: "currentColor"
    },
    ":hover": {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $9ZwXq.N20), ")"),
        color: "currentColor"
    },
    ":active": {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $9ZwXq.N30), ")"),
        boxShadow: "none",
        color: "currentColor"
    }
});
var $e31b238bed554038$var$disabledStyles = (0, $fBy54.css)({
    cursor: "not-allowed",
    "&, :hover, :active": {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $9ZwXq.N200), ")")
    }
});
var $e31b238bed554038$var$selectedBorderStyles = (0, $fBy54.css)({
    "&::before": {
        width: 2,
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        background: "var(--ds-border-selected, transparent)",
        content: '""'
    }
});
var $e31b238bed554038$var$selectedNotchStyles = (0, $fBy54.css)({
    "&::before": {
        width: 4,
        position: "absolute",
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)",
        left: 0,
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""'
    }
});
var $e31b238bed554038$var$selectedStyles = (0, $fBy54.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $9ZwXq.N20), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    ":visited": {
        color: "var(--ds-text-selected, currentColor)"
    },
    ":hover": {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $9ZwXq.N20), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    ":active": {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $9ZwXq.N30), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $e31b238bed554038$var$gapMap = {
    compact: "space.100",
    cozy: "space.150"
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $e31b238bed554038$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $2Eqc7.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $1Mpn7.useContext)((0, $lYgFP.SpacingContext));
    var selectionStyle = (0, $1Mpn7.useContext)((0, $lYgFP.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $e31b238bed554038$var$defaultRender;
    var UNSAFE_className = (0, $cWK60.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_externalClassName;
    return (0, $fBy54.jsx)((0, $fBy54.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $fBy54.jsx)((0, $imeJC.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $e31b238bed554038$var$positionRelativeStyles,
                    $e31b238bed554038$var$primitiveStyles,
                    $e31b238bed554038$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $e31b238bed554038$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $e31b238bed554038$var$selectedStyles,
                        [
                            selectionStyle === "border" && $e31b238bed554038$var$selectedBorderStyles,
                            selectionStyle === "notch" && $e31b238bed554038$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $e31b238bed554038$var$disabledStyles : $e31b238bed554038$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $fBy54.jsx)((0, $3dRkO.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $e31b238bed554038$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $fBy54.jsx)("span", {
                "data-item-elem-before": true,
                css: $e31b238bed554038$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $fBy54.jsx)("span", {
                css: $e31b238bed554038$var$contentStyles
            }, renderTitle("span", {
                children: title,
                className: cn(shouldTitleWrap ? $e31b238bed554038$var$wordBreakStyles : $e31b238bed554038$var$truncateStyles),
                "data-item-title": true
            }), description && (0, $fBy54.jsx)("span", {
                "data-item-description": true,
                css: [
                    $e31b238bed554038$var$descriptionStyles,
                    isDisabled && $e31b238bed554038$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $e31b238bed554038$var$wordBreakStyles : $e31b238bed554038$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $fBy54.jsx)("span", {
                "data-item-elem-after": true,
                css: $e31b238bed554038$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $e31b238bed554038$export$2e2bcd8739ae039 = $e31b238bed554038$var$MenuItemPrimitive;

});
parcelRegister("3dRkO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $258bf529d3a70dc0$export$2e2bcd8739ae039; });

var $eetQ9 = parcelRequire("eetQ9");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $alxB5 = parcelRequire("alxB5");

var $aZ7gg = parcelRequire("aZ7gg");
var $258bf529d3a70dc0$var$flexGrowMap = {
    hug: (0, $alxB5.xcss)({
        flexGrow: 0
    }),
    fill: (0, $alxB5.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $258bf529d3a70dc0$var$separatorStyles = (0, $fBy54.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $258bf529d3a70dc0$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $fBy54.jsx)("span", {
        css: $258bf529d3a70dc0$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $258bf529d3a70dc0$var$Inline = /*#__PURE__*/ (0, $1Mpn7.memo)(/*#__PURE__*/ (0, $1Mpn7.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, _$xcss = _ref2.xcss, testId = _ref2.testId, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $fBy54.jsx)($258bf529d3a70dc0$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1Mpn7.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $fBy54.jsx)((0, $1Mpn7.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    return (0, $fBy54.jsx)((0, $aZ7gg.default), {
        as: as,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: grow ? [
            $258bf529d3a70dc0$var$flexGrowMap[grow]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($eetQ9)))(Array.isArray(_$xcss) ? _$xcss : [
            _$xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        _$xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$258bf529d3a70dc0$var$Inline.displayName = "Inline";
var $258bf529d3a70dc0$export$2e2bcd8739ae039 = $258bf529d3a70dc0$var$Inline;

});
parcelRegister("alxB5", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $7885ed45b5439f36$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $7885ed45b5439f36$export$f6c783d06584602c; });

var $jjExS = parcelRequire("jjExS");

var $e6gyJ = parcelRequire("e6gyJ");

var $2nffd = parcelRequire("2nffd");

var $fBy54 = parcelRequire("fBy54");

var $a1e9W = parcelRequire("a1e9W");

var $3qWgZ = parcelRequire("3qWgZ");
var $7885ed45b5439f36$var$tokensMap = {
    backgroundColor: (0, $a1e9W.backgroundColorMap),
    blockSize: (0, $a1e9W.dimensionMap),
    borderColor: (0, $a1e9W.borderColorMap),
    borderRadius: (0, $a1e9W.borderRadiusMap),
    borderWidth: (0, $a1e9W.borderWidthMap),
    bottom: (0, $a1e9W.spaceMap),
    boxShadow: (0, $a1e9W.shadowMap),
    color: (0, $a1e9W.textColorMap),
    columnGap: (0, $a1e9W.spaceMap),
    gap: (0, $a1e9W.spaceMap),
    height: (0, $a1e9W.dimensionMap),
    inlineSize: (0, $a1e9W.dimensionMap),
    inset: (0, $a1e9W.spaceMap),
    insetBlock: (0, $a1e9W.spaceMap),
    insetBlockEnd: (0, $a1e9W.spaceMap),
    insetBlockStart: (0, $a1e9W.spaceMap),
    insetInline: (0, $a1e9W.spaceMap),
    insetInlineEnd: (0, $a1e9W.spaceMap),
    insetInlineStart: (0, $a1e9W.spaceMap),
    margin: (0, $a1e9W.spaceMap),
    marginBlock: (0, $a1e9W.spaceMap),
    marginBlockEnd: (0, $a1e9W.spaceMap),
    marginBlockStart: (0, $a1e9W.spaceMap),
    marginBottom: (0, $a1e9W.spaceMap),
    marginInline: (0, $a1e9W.spaceMap),
    marginInlineEnd: (0, $a1e9W.spaceMap),
    marginInlineStart: (0, $a1e9W.spaceMap),
    marginLeft: (0, $a1e9W.spaceMap),
    marginRight: (0, $a1e9W.spaceMap),
    marginTop: (0, $a1e9W.spaceMap),
    left: (0, $a1e9W.spaceMap),
    maxBlockSize: (0, $a1e9W.dimensionMap),
    maxHeight: (0, $a1e9W.dimensionMap),
    maxInlineSize: (0, $a1e9W.dimensionMap),
    maxWidth: (0, $a1e9W.dimensionMap),
    minBlockSize: (0, $a1e9W.dimensionMap),
    minHeight: (0, $a1e9W.dimensionMap),
    minInlineSize: (0, $a1e9W.dimensionMap),
    minWidth: (0, $a1e9W.dimensionMap),
    outlineOffset: (0, $a1e9W.spaceMap),
    outlineWidth: (0, $a1e9W.borderWidthMap),
    outlineColor: (0, $a1e9W.borderColorMap),
    padding: (0, $a1e9W.spaceMap),
    paddingBlock: (0, $a1e9W.spaceMap),
    paddingBlockEnd: (0, $a1e9W.spaceMap),
    paddingBlockStart: (0, $a1e9W.spaceMap),
    paddingBottom: (0, $a1e9W.spaceMap),
    paddingInline: (0, $a1e9W.spaceMap),
    paddingInlineEnd: (0, $a1e9W.spaceMap),
    paddingInlineStart: (0, $a1e9W.spaceMap),
    paddingLeft: (0, $a1e9W.spaceMap),
    paddingRight: (0, $a1e9W.spaceMap),
    paddingTop: (0, $a1e9W.spaceMap),
    right: (0, $a1e9W.spaceMap),
    rowGap: (0, $a1e9W.spaceMap),
    top: (0, $a1e9W.spaceMap),
    width: (0, $a1e9W.dimensionMap),
    zIndex: (0, $a1e9W.layerMap)
};
var $7885ed45b5439f36$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $7885ed45b5439f36$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3qWgZ === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))($3qWgZ)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))($3qWgZ.env) === "object" && false;
};
var $7885ed45b5439f36$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $7885ed45b5439f36$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $7885ed45b5439f36$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(value) === "object" && $7885ed45b5439f36$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($7885ed45b5439f36$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($7885ed45b5439f36$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $7885ed45b5439f36$var$tokensMap)) return;
        var tokenValue = $7885ed45b5439f36$var$tokensMap[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $7885ed45b5439f36$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $7885ed45b5439f36$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, $7885ed45b5439f36$var$uniqueSymbol, (0, $fBy54.css)(transformedStyles));
};
var $7885ed45b5439f36$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$7885ed45b5439f36$var$uniqueSymbol];
    typeof $3qWgZ === "undefined" || (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))($3qWgZ);
    return styles;
};
function $7885ed45b5439f36$export$f6c783d06584602c(style) {
    return $7885ed45b5439f36$var$baseXcss(style);
}

});
parcelRegister("a1e9W", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $74b4fb1e807c4e11$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "spaceMap", function () { return $74b4fb1e807c4e11$export$1f52408f03b1c9b4; });
$parcel$export(module.exports, "borderColorMap", function () { return $74b4fb1e807c4e11$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $74b4fb1e807c4e11$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "shadowMap", function () { return $74b4fb1e807c4e11$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "textColorMap", function () { return $74b4fb1e807c4e11$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $74b4fb1e807c4e11$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $74b4fb1e807c4e11$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $74b4fb1e807c4e11$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $74b4fb1e807c4e11$export$bf46c3f9eeafc71f; });

var $jjExS = parcelRequire("jjExS");

var $fBy54 = parcelRequire("fBy54");

var $lyNF8 = parcelRequire("lyNF8");
var $74b4fb1e807c4e11$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $74b4fb1e807c4e11$export$1f52408f03b1c9b4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $74b4fb1e807c4e11$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $74b4fb1e807c4e11$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $74b4fb1e807c4e11$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $74b4fb1e807c4e11$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $74b4fb1e807c4e11$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $74b4fb1e807c4e11$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)"
};
var $74b4fb1e807c4e11$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $74b4fb1e807c4e11$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $74b4fb1e807c4e11$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $74b4fb1e807c4e11$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $74b4fb1e807c4e11$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $74b4fb1e807c4e11$export$6cc560b4dedf3816 = {
    "font.size.050": "var(--ds-font-size-050, 11px)",
    "font.size.075": "var(--ds-font-size-075, 12px)",
    "font.size.100": "var(--ds-font-size-100, 14px)",
    "font.size.200": "var(--ds-font-size-200, 16px)",
    "font.size.300": "var(--ds-font-size-300, 20px)",
    "font.size.400": "var(--ds-font-size-400, 24px)",
    "font.size.500": "var(--ds-font-size-500, 29px)",
    "font.size.600": "var(--ds-font-size-600, 35px)"
};
var $74b4fb1e807c4e11$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $74b4fb1e807c4e11$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand": "var(--ds-font-family-brand, Charlie Sans)",
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.monospace": 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.sans": 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
};
var $74b4fb1e807c4e11$export$360c29a380c1a34 = {
    "font.lineHeight.1": "var(--ds-font-lineHeight-1, 1)",
    "font.lineHeight.100": "var(--ds-font-lineHeight-100, 16px)",
    "font.lineHeight.200": "var(--ds-font-lineHeight-200, 20px)",
    "font.lineHeight.300": "var(--ds-font-lineHeight-300, 24px)",
    "font.lineHeight.400": "var(--ds-font-lineHeight-400, 28px)",
    "font.lineHeight.500": "var(--ds-font-lineHeight-500, 32px)",
    "font.lineHeight.600": "var(--ds-font-lineHeight-600, 40px)"
};
var $74b4fb1e807c4e11$export$b5bac06d7d8fd0d1 = {
    body: "var(--ds-font-body, normal 400 14px/20px var(--ds-font-family-body))",
    "body.large": "var(--ds-font-body-large, normal 400 16px/24px var(--ds-font-family-body))",
    "body.small": "var(--ds-font-body-small, normal 400 11px/20px var(--ds-font-family-body))"
};
var $74b4fb1e807c4e11$export$b27166c9cf2c9f74 = {
    ui: "var(--ds-font-ui, normal 400 14px/1 var(--ds-font-family-body))",
    "ui.small": "var(--ds-font-ui-small, normal 400 11px/1 var(--ds-font-family-body))"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $74b4fb1e807c4e11$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $74b4fb1e807c4e11$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $fBy54.css)((0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $74b4fb1e807c4e11$export$e615f061ca585a6c = $74b4fb1e807c4e11$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $74b4fb1e807c4e11$var$getSerializedStylesMap(spacingProperty, $74b4fb1e807c4e11$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $74b4fb1e807c4e11$export$bf46c3f9eeafc71f = $74b4fb1e807c4e11$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $74b4fb1e807c4e11$var$getSerializedStylesMap(spacingProperty, $74b4fb1e807c4e11$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $74b4fb1e807c4e11$export$e7af83bafe7f9e63 = $74b4fb1e807c4e11$var$getSerializedStylesMap("backgroundColor", $74b4fb1e807c4e11$export$d1d79bf68ac056bd);
var $74b4fb1e807c4e11$export$3a1bcba60b23d7f0 = $74b4fb1e807c4e11$var$getSerializedStylesMap("color", $74b4fb1e807c4e11$export$8473307aa00d6ea1);
var $74b4fb1e807c4e11$export$f7183c9e2dbc2543 = $74b4fb1e807c4e11$var$getSerializedStylesMap("fontSize", $74b4fb1e807c4e11$export$6cc560b4dedf3816);
var $74b4fb1e807c4e11$export$45f3f4fe16f9f7d5 = $74b4fb1e807c4e11$var$getSerializedStylesMap("fontWeight", $74b4fb1e807c4e11$export$303e322c6b1ed114);
var $74b4fb1e807c4e11$export$68cc305da27dbaa4 = $74b4fb1e807c4e11$var$getSerializedStylesMap("fontFamily", $74b4fb1e807c4e11$export$3c7e9587132614b4);
var $74b4fb1e807c4e11$export$8be4a21014f48eb1 = $74b4fb1e807c4e11$var$getSerializedStylesMap("lineHeight", $74b4fb1e807c4e11$export$360c29a380c1a34);
var $74b4fb1e807c4e11$export$a1962444bbf058e = $74b4fb1e807c4e11$var$getSerializedStylesMap("font", $74b4fb1e807c4e11$export$b5bac06d7d8fd0d1);
var $74b4fb1e807c4e11$export$ca3e246f24657bd6 = $74b4fb1e807c4e11$var$getSerializedStylesMap("font", $74b4fb1e807c4e11$export$b27166c9cf2c9f74);
var $74b4fb1e807c4e11$export$ff257d957d48c421 = $74b4fb1e807c4e11$var$getSerializedStylesMap((0, $lyNF8.CURRENT_SURFACE_CSS_VAR), $74b4fb1e807c4e11$export$41a358c9c2356760);
var $74b4fb1e807c4e11$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $74b4fb1e807c4e11$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("lyNF8", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $fb234be6be000758$export$9d7b58831ae93caa; });
var $fb234be6be000758$export$4ef52930e33717cd = "data-theme";
var $fb234be6be000758$export$a00eac3f8684bcd0 = "data-color-mode";
var $fb234be6be000758$export$2112803007239c61 = "data-contrast-mode";
var $fb234be6be000758$export$352e418ed5b6193a = "data-custom-theme";
var $fb234be6be000758$export$2faeed762aac6741 = "light";
var $fb234be6be000758$export$6f0c6fb8c80fcc92 = "ds";
var $fb234be6be000758$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $fb234be6be000758$export$dddac1532e822863 = "--".concat($fb234be6be000758$export$6f0c6fb8c80fcc92, "-token-not-found");
var $fb234be6be000758$export$9d7b58831ae93caa = "--".concat($fb234be6be000758$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});



parcelRegister("aZ7gg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ff53bd3d85894a8$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $a1e9W = parcelRequire("a1e9W");

var $alxB5 = parcelRequire("alxB5");
var $7ff53bd3d85894a8$var$justifyContentMap = {
    start: (0, $fBy54.css)({
        justifyContent: "start"
    }),
    center: (0, $fBy54.css)({
        justifyContent: "center"
    }),
    end: (0, $fBy54.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $fBy54.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $fBy54.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $fBy54.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $fBy54.css)({
        justifyContent: "stretch"
    })
};
var $7ff53bd3d85894a8$var$flexDirectionMap = {
    column: (0, $fBy54.css)({
        flexDirection: "column"
    }),
    row: (0, $fBy54.css)({
        flexDirection: "row"
    })
};
var $7ff53bd3d85894a8$var$flexWrapMap = {
    wrap: (0, $fBy54.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $fBy54.css)({
        flexWrap: "nowrap"
    })
};
var $7ff53bd3d85894a8$var$alignItemsMap = {
    start: (0, $fBy54.css)({
        alignItems: "start"
    }),
    center: (0, $fBy54.css)({
        alignItems: "center"
    }),
    baseline: (0, $fBy54.css)({
        alignItems: "baseline"
    }),
    end: (0, $fBy54.css)({
        alignItems: "end"
    }),
    stretch: (0, $fBy54.css)({
        alignItems: "stretch"
    })
};
var $7ff53bd3d85894a8$var$baseStyles = (0, $fBy54.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $7ff53bd3d85894a8$var$Flex = /*#__PURE__*/ (0, $1Mpn7.memo)(/*#__PURE__*/ (0, $1Mpn7.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var xcssClassName = xcss && (0, $alxB5.parseXcss)(xcss);
    return (0, $fBy54.jsx)(Component, {
        css: [
            $7ff53bd3d85894a8$var$baseStyles,
            gap && (0, $a1e9W.spaceStylesMap).gap[gap],
            columnGap && (0, $a1e9W.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $a1e9W.spaceStylesMap).rowGap[rowGap],
            alignItems && $7ff53bd3d85894a8$var$alignItemsMap[alignItems],
            direction && $7ff53bd3d85894a8$var$flexDirectionMap[direction],
            justifyContent && $7ff53bd3d85894a8$var$justifyContentMap[justifyContent],
            wrap && $7ff53bd3d85894a8$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$7ff53bd3d85894a8$var$Flex.displayName = "Flex";
var $7ff53bd3d85894a8$export$2e2bcd8739ae039 = $7ff53bd3d85894a8$var$Flex;

});


parcelRegister("9ZwXq", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $746360398c9b6621$export$215b7063051591f1; });
$parcel$export(module.exports, "N20", function () { return $746360398c9b6621$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $746360398c9b6621$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N200", function () { return $746360398c9b6621$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $746360398c9b6621$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N30A", function () { return $746360398c9b6621$export$920c0d5c49070351; });
$parcel$export(module.exports, "heading", function () { return $746360398c9b6621$export$46e4a324ac90507f; });
$parcel$export(module.exports, "subtleHeading", function () { return $746360398c9b6621$export$79f3f2b82beb0d36; });
$parcel$export(module.exports, "skeleton", function () { return $746360398c9b6621$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5oRRt = parcelRequire("5oRRt");
var $746360398c9b6621$export$4b84fd0e2c617bd = "#FFEBE6";
var $746360398c9b6621$export$b34b069eff244586 = "#FFBDAD";
var $746360398c9b6621$export$be802dd0d8b57f35 = "#FF8F73";
var $746360398c9b6621$export$60847d42f9da92a6 = "#FF7452";
var $746360398c9b6621$export$4a7404f376229999 = "#FF5630";
var $746360398c9b6621$export$2010d0fb4295b346 = "#DE350B";
var $746360398c9b6621$export$2837b5a1a71d5c02 = "#BF2600";
var $746360398c9b6621$export$8d9596b529bbb9cf = "#FFFAE6";
var $746360398c9b6621$export$41060a744ab0b7ae = "#FFF0B3";
var $746360398c9b6621$export$1cc05bbbf340e559 = "#FFE380";
var $746360398c9b6621$export$5aae31392d72caaa = "#FFC400";
var $746360398c9b6621$export$c6930421db9fa514 = "#FFAB00";
var $746360398c9b6621$export$59619663aa6500fb = "#FF991F";
var $746360398c9b6621$export$874739ea9e379ab6 = "#FF8B00";
var $746360398c9b6621$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $746360398c9b6621$export$69a3bf21b9686c2b = "#ABF5D1";
var $746360398c9b6621$export$afbce1382ec95f73 = "#79F2C0";
var $746360398c9b6621$export$747d86715d4175de = "#57D9A3";
var $746360398c9b6621$export$940e1f69e873f202 = "#36B37E";
var $746360398c9b6621$export$a49394138f7b8e85 = "#00875A";
var $746360398c9b6621$export$6fa04827ac68a4fb = "#006644";
var $746360398c9b6621$export$226de0355ed012f8 = "#DEEBFF";
var $746360398c9b6621$export$8c13c2ee36917869 = "#B3D4FF";
var $746360398c9b6621$export$ecfc1dff386a3e7a = "#4C9AFF";
var $746360398c9b6621$export$215b7063051591f1 = "#2684FF";
var $746360398c9b6621$export$e62e8919cca44969 = "#0065FF";
var $746360398c9b6621$export$b3de0ae08da2ce64 = "#0052CC";
var $746360398c9b6621$export$a6ee3d71bc067634 = "#0747A6";
var $746360398c9b6621$export$363e4475840015bb = "#EAE6FF";
var $746360398c9b6621$export$4b0a4417ed59760f = "#C0B6F2";
var $746360398c9b6621$export$6011520a64d9a187 = "#998DD9";
var $746360398c9b6621$export$a7175d4e9206bc80 = "#8777D9";
var $746360398c9b6621$export$b48405b95304b5a1 = "#6554C0";
var $746360398c9b6621$export$c71e4279dd54a18d = "#5243AA";
var $746360398c9b6621$export$147899de772240ec = "#403294";
var $746360398c9b6621$export$2cf711fe14c66f06 = "#E6FCFF";
var $746360398c9b6621$export$7a8f4d33f6f9772c = "#B3F5FF";
var $746360398c9b6621$export$776c9c497ef08533 = "#79E2F2";
var $746360398c9b6621$export$69cb3ca10c1e330e = "#00C7E6";
var $746360398c9b6621$export$9dc1ef0f3f48059b = "#00B8D9";
var $746360398c9b6621$export$7c835c78b6fcdef8 = "#00A3BF";
var $746360398c9b6621$export$6036577f95c3877e = "#008DA6";
var $746360398c9b6621$export$29a4f05edc054374 = "#FFFFFF";
var $746360398c9b6621$export$e655ef011c4aa1a2 = "#FAFBFC";
var $746360398c9b6621$export$9fdfb749e33cdf97 = "#F4F5F7";
var $746360398c9b6621$export$3e51e8f1440314ba = "#EBECF0";
var $746360398c9b6621$export$1ce2d1575d444ceb = "#DFE1E6";
var $746360398c9b6621$export$8754fc7e6d8b3000 = "#C1C7D0";
var $746360398c9b6621$export$c2e91cbeada39b8b = "#B3BAC5";
var $746360398c9b6621$export$5f71e19f3a7ad9de = "#A5ADBA";
var $746360398c9b6621$export$eaa8c8a70ac22806 = "#97A0AF";
var $746360398c9b6621$export$7c87d337fb91a97d = "#8993A4";
var $746360398c9b6621$export$d6447c357493214f = "#7A869A";
var $746360398c9b6621$export$f563ee71e9ee74cd = "#6B778C";
var $746360398c9b6621$export$e2ef2124cf4024b1 = "#5E6C84";
var $746360398c9b6621$export$eece5f492e429f08 = "#505F79";
var $746360398c9b6621$export$c39c0fe0f26207ae = "#42526E";
var $746360398c9b6621$export$7090862dc3038a9f = "#344563";
var $746360398c9b6621$export$ad0bacf983b7ddaa = "#253858";
var $746360398c9b6621$export$7d61b15e0da132af = "#172B4D";
var $746360398c9b6621$export$fbda843f0a27fe96 = "#091E42";
var $746360398c9b6621$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $746360398c9b6621$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $746360398c9b6621$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $746360398c9b6621$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $746360398c9b6621$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $746360398c9b6621$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $746360398c9b6621$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $746360398c9b6621$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $746360398c9b6621$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $746360398c9b6621$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $746360398c9b6621$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $746360398c9b6621$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $746360398c9b6621$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $746360398c9b6621$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $746360398c9b6621$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $746360398c9b6621$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $746360398c9b6621$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $746360398c9b6621$export$2f6319cf7d736c2a = "#E6EDFA";
var $746360398c9b6621$export$95126bc8884d6634 = "#DCE5F5";
var $746360398c9b6621$export$8338d8c35d44ff1 = "#CED9EB";
var $746360398c9b6621$export$5368d76ae4fbbda7 = "#B8C7E0";
var $746360398c9b6621$export$9f0a771d16ec8d36 = "#ABBBD6";
var $746360398c9b6621$export$abcf8c38338b4aa5 = "#9FB0CC";
var $746360398c9b6621$export$97e81faa16a182c7 = "#8C9CB8";
var $746360398c9b6621$export$bfe21c59123ecf33 = "#7988A3";
var $746360398c9b6621$export$ee82aa2ea6a1558 = "#67758F";
var $746360398c9b6621$export$682927c6ed76be02 = "#56637A";
var $746360398c9b6621$export$91fd9994c5be9757 = "#455166";
var $746360398c9b6621$export$d281fbfe3cff2df6 = "#3B475C";
var $746360398c9b6621$export$3902c91d8b98a753 = "#313D52";
var $746360398c9b6621$export$8e8133c1ba5845b5 = "#283447";
var $746360398c9b6621$export$33ff357f6620b39 = "#202B3D";
var $746360398c9b6621$export$633847cf062b69e0 = "#1B2638";
var $746360398c9b6621$export$9776a6e503bdbf76 = "#121A29";
var $746360398c9b6621$export$6c813d5160dff5db = "#0E1624";
var $746360398c9b6621$export$3d4f271a500072a = "#0D1424";
var $746360398c9b6621$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $746360398c9b6621$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $746360398c9b6621$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $746360398c9b6621$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $746360398c9b6621$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $746360398c9b6621$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $746360398c9b6621$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $746360398c9b6621$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $746360398c9b6621$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $746360398c9b6621$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $746360398c9b6621$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $746360398c9b6621$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $746360398c9b6621$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $746360398c9b6621$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $746360398c9b6621$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $746360398c9b6621$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $746360398c9b6621$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $746360398c9b6621$export$8ce1fd94bee2f412 = (0, $5oRRt.default)({
    light: "var(--ds-surface, ".concat($746360398c9b6621$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($746360398c9b6621$export$633847cf062b69e0, ")")
});
var $746360398c9b6621$export$b861914ea877b580 = (0, $5oRRt.default)({
    light: "var(--ds-background-selected, ".concat($746360398c9b6621$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($746360398c9b6621$export$8c13c2ee36917869, ")")
});
var $746360398c9b6621$export$3f1b020df94387af = (0, $5oRRt.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($746360398c9b6621$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($746360398c9b6621$export$d281fbfe3cff2df6, ")")
});
var $746360398c9b6621$export$c0183dbab98ca63e = (0, $5oRRt.default)({
    light: "var(--ds-surface-overlay, ".concat($746360398c9b6621$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($746360398c9b6621$export$8e8133c1ba5845b5, ")")
});
var $746360398c9b6621$export$6f093cfa640b7166 = (0, $5oRRt.default)({
    light: "var(--ds-text, ".concat($746360398c9b6621$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($746360398c9b6621$export$5368d76ae4fbbda7, ")")
});
var $746360398c9b6621$export$42f8e9c698766e7a = (0, $5oRRt.default)({
    light: "var(--ds-text, ".concat($746360398c9b6621$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($746360398c9b6621$export$5368d76ae4fbbda7, ")")
});
var $746360398c9b6621$export$c2d157ca1c34b6e3 = (0, $5oRRt.default)({
    light: "var(--ds-text-selected, ".concat($746360398c9b6621$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($746360398c9b6621$export$b3de0ae08da2ce64, ")")
});
var $746360398c9b6621$export$1905ba28d7cf066f = (0, $5oRRt.default)({
    light: "var(--ds-text-subtlest, ".concat($746360398c9b6621$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($746360398c9b6621$export$97e81faa16a182c7, ")")
});
var $746360398c9b6621$export$bd9002130d306d39 = (0, $5oRRt.default)({
    light: "var(--ds-text-subtlest, ".concat($746360398c9b6621$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($746360398c9b6621$export$bfe21c59123ecf33, ")")
});
var $746360398c9b6621$export$46e4a324ac90507f = (0, $5oRRt.default)({
    light: "var(--ds-text, ".concat($746360398c9b6621$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($746360398c9b6621$export$5368d76ae4fbbda7, ")")
});
var $746360398c9b6621$export$79f3f2b82beb0d36 = (0, $5oRRt.default)({
    light: "var(--ds-text-subtlest, ".concat($746360398c9b6621$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($746360398c9b6621$export$97e81faa16a182c7, ")")
});
var $746360398c9b6621$export$7bb0d5c671655cc4 = (0, $5oRRt.default)({
    light: $746360398c9b6621$export$9fdfb749e33cdf97,
    dark: $746360398c9b6621$export$8e8133c1ba5845b5
});
var $746360398c9b6621$export$9c30223ca0a664fb = (0, $5oRRt.default)({
    light: "var(--ds-link, ".concat($746360398c9b6621$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($746360398c9b6621$export$ecfc1dff386a3e7a, ")")
});
var $746360398c9b6621$export$7ed258b0728b004b = (0, $5oRRt.default)({
    light: "var(--ds-link-pressed, ".concat($746360398c9b6621$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($746360398c9b6621$export$215b7063051591f1, ")")
});
var $746360398c9b6621$export$dfa920d8decc8a59 = (0, $5oRRt.default)({
    light: "var(--ds-link-pressed, ".concat($746360398c9b6621$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($746360398c9b6621$export$ecfc1dff386a3e7a, ")")
});
var $746360398c9b6621$export$6069e6ad5c78f632 = (0, $5oRRt.default)({
    light: "var(--ds-border-focused, ".concat($746360398c9b6621$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($746360398c9b6621$export$215b7063051591f1, ")")
});
var $746360398c9b6621$export$9ad721cf3b3debe0 = (0, $5oRRt.default)({
    light: "var(--ds-background-brand-bold, ".concat($746360398c9b6621$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($746360398c9b6621$export$ecfc1dff386a3e7a, ")")
});
var $746360398c9b6621$export$2aa0182783e7e9de = (0, $5oRRt.default)({
    light: $746360398c9b6621$export$b3de0ae08da2ce64,
    dark: $746360398c9b6621$export$ecfc1dff386a3e7a
});
var $746360398c9b6621$export$8bf7dff220b82b4a = (0, $5oRRt.default)({
    light: $746360398c9b6621$export$9dc1ef0f3f48059b,
    dark: $746360398c9b6621$export$69cb3ca10c1e330e
});
var $746360398c9b6621$export$e13cce2a2d16a9d4 = (0, $5oRRt.default)({
    light: $746360398c9b6621$export$b48405b95304b5a1,
    dark: $746360398c9b6621$export$6011520a64d9a187
});
var $746360398c9b6621$export$a90204d1394caf30 = (0, $5oRRt.default)({
    light: $746360398c9b6621$export$4a7404f376229999,
    dark: $746360398c9b6621$export$4a7404f376229999
});
var $746360398c9b6621$export$594c5a8758200c32 = (0, $5oRRt.default)({
    light: $746360398c9b6621$export$c6930421db9fa514,
    dark: $746360398c9b6621$export$c6930421db9fa514
});
var $746360398c9b6621$export$955a2ebd2fb142ae = (0, $5oRRt.default)({
    light: $746360398c9b6621$export$940e1f69e873f202,
    dark: $746360398c9b6621$export$940e1f69e873f202
});
var $746360398c9b6621$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($746360398c9b6621$export$8d43898f60b96a82, ")");
};

});
parcelRegister("5oRRt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ee8f96324123469$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $fOMm3 = parcelRequire("fOMm3");
// Unpack custom variants, and get correct value for the current theme
function $3ee8f96324123469$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $fOMm3.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $3ee8f96324123469$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $3ee8f96324123469$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $fOMm3.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("fOMm3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b84108c8a5dad8fb$export$2e2bcd8739ae039; });

var $9ZRkI = parcelRequire("9ZRkI");
function $b84108c8a5dad8fb$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $9ZRkI.CHANNEL) in props.theme) return props.theme[0, $9ZRkI.CHANNEL];
        else if ("mode" in props.theme && (0, $9ZRkI.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $9ZRkI.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("9ZRkI", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $74732e634f5cba63$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $74732e634f5cba63$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $74732e634f5cba63$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $74732e634f5cba63$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $74732e634f5cba63$export$85e3c3ca0c6fb93; });

var $2Eqc7 = parcelRequire("2Eqc7");

var $9ZwXq = parcelRequire("9ZwXq");
var $74732e634f5cba63$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $74732e634f5cba63$export$c93026a968943f95 = "light";
var $74732e634f5cba63$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $74732e634f5cba63$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $74732e634f5cba63$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $74732e634f5cba63$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $74732e634f5cba63$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $74732e634f5cba63$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $74732e634f5cba63$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $74732e634f5cba63$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $9ZwXq.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $74732e634f5cba63$export$6d8204c2cb2e06b8() / 4;
    (0, $2Eqc7.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $74732e634f5cba63$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $74732e634f5cba63$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $74732e634f5cba63$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $2Eqc7.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $74732e634f5cba63$export$ba1d834b86d72a09 = $74732e634f5cba63$export$a1b3edb637fb4f35;
var $74732e634f5cba63$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $9ZwXq.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $9ZwXq.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $9ZwXq.N30A), ")")
            }
        }
    };
};

});




parcelRegister("lYgFP", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", function () { return $ffec2295d96f9e29$export$443076ec7ebce042; });
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $ffec2295d96f9e29$export$9ca534b70725964d; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $ffec2295d96f9e29$export$443076ec7ebce042 = /*#__PURE__*/ (0, $1Mpn7.createContext)("cozy");
var $ffec2295d96f9e29$export$9ca534b70725964d = /*#__PURE__*/ (0, $1Mpn7.createContext)("border");

});



parcelRegister("2ZTAv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22ec65dd7876ac5e$export$2e2bcd8739ae039; });
/* eslint-disable @atlassian/tangerine/import/entry-points */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $3jYyQ = parcelRequire("3jYyQ");

var $8Srxj = parcelRequire("8Srxj");
var $9GM4p = parcelRequire("9GM4p");
var $22ec65dd7876ac5e$var$baseStyles = (0, $9GM4p.xcss)({
    display: "inline-flex",
    borderRadius: "border.radius",
    position: "static",
    overflow: "hidden"
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $22ec65dd7876ac5e$var$Lozenge = /*#__PURE__*/ (0, $1Mpn7.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = appearance in $22ec65dd7876ac5e$var$backgroundColors[appearanceStyle] ? appearance : "default";
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $8Srxj.default), {
        as: "span",
        backgroundColor: $22ec65dd7876ac5e$var$backgroundColors[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        paddingInline: "space.050",
        xcss: $22ec65dd7876ac5e$var$baseStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $3jYyQ.default), {
        fontSize: "size.050",
        fontWeight: "bold",
        lineHeight: "lineHeight.100",
        textTransform: "uppercase",
        color: $22ec65dd7876ac5e$var$textColors[appearanceStyle][appearanceType],
        shouldTruncate: true,
        UNSAFE_style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        testId: testId && "".concat(testId, "--text")
    }, children));
});
$22ec65dd7876ac5e$var$Lozenge.displayName = "Lozenge";
var $22ec65dd7876ac5e$export$2e2bcd8739ae039 = $22ec65dd7876ac5e$var$Lozenge;
// Lozenge colors
var $22ec65dd7876ac5e$var$backgroundColors = {
    bold: {
        default: "color.background.neutral.bold",
        inprogress: "color.background.information.bold",
        moved: "color.background.warning.bold",
        new: "color.background.discovery.bold",
        removed: "color.background.danger.bold",
        success: "color.background.success.bold"
    },
    subtle: {
        default: "color.background.neutral",
        inprogress: "color.background.information",
        moved: "color.background.warning",
        new: "color.background.discovery",
        removed: "color.background.danger",
        success: "color.background.success"
    }
};
var $22ec65dd7876ac5e$var$textColors = {
    bold: {
        default: "inverse",
        inprogress: "inverse",
        moved: "warning.inverse",
        new: "inverse",
        removed: "inverse",
        success: "inverse"
    },
    subtle: {
        default: "subtle",
        inprogress: "information",
        moved: "warning",
        new: "discovery",
        removed: "danger",
        success: "success"
    }
};

});
parcelRegister("3jYyQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26b21fa0424cb11d$export$2e2bcd8739ae039; });

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $u2nzd = parcelRequire("u2nzd");

var $ioAsB = parcelRequire("ioAsB");

var $dmEAC = parcelRequire("dmEAC");
var $26b21fa0424cb11d$var$_excluded = [
    "children"
];
var $26b21fa0424cb11d$var$asAllowlist = [
    "span",
    "div",
    "p",
    "strong"
];
var $26b21fa0424cb11d$var$textAlignMap = {
    center: (0, $fBy54.css)({
        textAlign: "center"
    }),
    end: (0, $fBy54.css)({
        textAlign: "end"
    }),
    start: (0, $fBy54.css)({
        textAlign: "start"
    })
};
var $26b21fa0424cb11d$var$textTransformMap = {
    none: (0, $fBy54.css)({
        textTransform: "none"
    }),
    lowercase: (0, $fBy54.css)({
        textTransform: "lowercase"
    }),
    uppercase: (0, $fBy54.css)({
        textTransform: "uppercase"
    })
};
var $26b21fa0424cb11d$var$verticalAlignMap = {
    top: (0, $fBy54.css)({
        verticalAlign: "top"
    }),
    middle: (0, $fBy54.css)({
        verticalAlign: "middle"
    }),
    bottom: (0, $fBy54.css)({
        verticalAlign: "bottom"
    })
};
var $26b21fa0424cb11d$var$baseStyles = (0, $fBy54.css)({
    boxSizing: "border-box",
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)"
});
var $26b21fa0424cb11d$var$truncateStyles = (0, $fBy54.css)({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $26b21fa0424cb11d$var$useColor = function useColor(colorProp) {
    var surface = (0, $dmEAC.useSurface)();
    var inverseTextColor = (0, $ioAsB.default)[surface];
    /**
   * Where the color of the surface is inverted we override the user choice
   * as there is no valid choice that is not covered by the override.
   */ var color = inverseTextColor !== null && inverseTextColor !== void 0 ? inverseTextColor : colorProp;
    return color;
};
var $26b21fa0424cb11d$var$HasTextAncestorContext = /*#__PURE__*/ (0, $1Mpn7.createContext)(false);
var $26b21fa0424cb11d$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $1Mpn7.useContext)($26b21fa0424cb11d$var$HasTextAncestorContext);
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $26b21fa0424cb11d$var$Text = function Text(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref, $26b21fa0424cb11d$var$_excluded);
    var _props$as = props.as, Component = _props$as === void 0 ? "span" : _props$as, colorProp = props.color, fontSize = props.fontSize, fontWeight = props.fontWeight, lineHeight = props.lineHeight, _props$shouldTruncate = props.shouldTruncate, shouldTruncate = _props$shouldTruncate === void 0 ? false : _props$shouldTruncate, textAlign = props.textAlign, textTransform = props.textTransform, verticalAlign = props.verticalAlign, testId = props.testId, UNSAFE_style = props.UNSAFE_style, id = props.id;
    (0, $u2nzd.default)($26b21fa0424cb11d$var$asAllowlist.includes(Component), '@atlaskit/ds-explorations: Text received an invalid "as" value of "'.concat(Component, '"'));
    var color = $26b21fa0424cb11d$var$useColor(colorProp);
    var isWrapped = $26b21fa0424cb11d$var$useHasTextAncestor();
    /**
   * If the text is already wrapped and applies no props we can just
   * render the children directly as a fragment.
   */ if (isWrapped && Object.keys(props).length === 0) return (0, $fBy54.jsx)((0, $1Mpn7.Fragment), null, children);
    var component = (0, $fBy54.jsx)(Component, {
        style: UNSAFE_style,
        css: [
            $26b21fa0424cb11d$var$baseStyles,
            $26b21fa0424cb11d$var$fontFamilyMap.sans,
            color && $26b21fa0424cb11d$var$textColorMap[color],
            fontSize && $26b21fa0424cb11d$var$fontSizeMap[fontSize],
            fontWeight && $26b21fa0424cb11d$var$fontWeightMap[fontWeight],
            lineHeight && $26b21fa0424cb11d$var$lineHeightMap[lineHeight],
            shouldTruncate && $26b21fa0424cb11d$var$truncateStyles,
            textAlign && $26b21fa0424cb11d$var$textAlignMap[textAlign],
            textTransform && $26b21fa0424cb11d$var$textTransformMap[textTransform],
            verticalAlign && $26b21fa0424cb11d$var$verticalAlignMap[verticalAlign]
        ],
        "data-testid": testId,
        id: id
    }, children);
    return isWrapped ? // no need to re-apply context if the text is already wrapped
    component : (0, $fBy54.jsx)($26b21fa0424cb11d$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
};
var $26b21fa0424cb11d$export$2e2bcd8739ae039 = $26b21fa0424cb11d$var$Text;
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f42dabbb2f08c0ca0dd8a46fc3508937>>
 * @codegenId typography
 * @codegenCommand yarn codegen-styles
 * @codegenParams ["fontSize", "fontWeight", "fontFamily", "lineHeight"]
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-typography.tsx <<SignedSource::ca98df97c16967b7984f4ad4d557cc48>>
 */ var $26b21fa0424cb11d$var$fontSizeMap = {
    "size.050": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-050, 11px)"
    }),
    "size.075": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-075, 12px)"
    }),
    "size.100": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-100, 14px)"
    }),
    "size.200": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-200, 16px)"
    }),
    "size.300": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-300, 20px)"
    }),
    "size.400": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-400, 24px)"
    }),
    "size.500": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-500, 29px)"
    }),
    "size.600": (0, $fBy54.css)({
        fontSize: "var(--ds-font-size-600, 35px)"
    })
};
var $26b21fa0424cb11d$var$fontWeightMap = {
    bold: (0, $fBy54.css)({
        fontWeight: "var(--ds-font-weight-bold, 700)"
    }),
    medium: (0, $fBy54.css)({
        fontWeight: "var(--ds-font-weight-medium, 500)"
    }),
    regular: (0, $fBy54.css)({
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }),
    semibold: (0, $fBy54.css)({
        fontWeight: "var(--ds-font-weight-semibold, 600)"
    })
};
var $26b21fa0424cb11d$var$fontFamilyMap = {
    body: (0, $fBy54.css)({
        fontFamily: 'var(--ds-font-family-body, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    brand: (0, $fBy54.css)({
        fontFamily: "var(--ds-font-family-brand, Charlie Sans)"
    }),
    code: (0, $fBy54.css)({
        fontFamily: 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
    }),
    heading: (0, $fBy54.css)({
        fontFamily: 'var(--ds-font-family-heading, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    monospace: (0, $fBy54.css)({
        fontFamily: 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
    }),
    sans: (0, $fBy54.css)({
        fontFamily: 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
    })
};
var $26b21fa0424cb11d$var$lineHeightMap = {
    "lineHeight.1": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-1, 1)"
    }),
    "lineHeight.100": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-100, 16px)"
    }),
    "lineHeight.200": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-200, 20px)"
    }),
    "lineHeight.300": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-300, 24px)"
    }),
    "lineHeight.400": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-400, 28px)"
    }),
    "lineHeight.500": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-500, 32px)"
    }),
    "lineHeight.600": (0, $fBy54.css)({
        lineHeight: "var(--ds-font-lineHeight-600, 40px)"
    })
};
/**
 * @codegenEnd
 */ /**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95d4f240e36e302a634e8633a0782cba>>
 * @codegenId colors
 * @codegenCommand yarn codegen-styles
 * @codegenParams ["text"]
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::f1021f8d47ab63374e371ce18db72a1c>>
 */ var $26b21fa0424cb11d$var$textColorMap = {
    "color.text": (0, $fBy54.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    disabled: (0, $fBy54.css)({
        color: "var(--ds-text-disabled, #A5ADBA)"
    }),
    inverse: (0, $fBy54.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    selected: (0, $fBy54.css)({
        color: "var(--ds-text-selected, #0052CC)"
    }),
    brand: (0, $fBy54.css)({
        color: "var(--ds-text-brand, #0065FF)"
    }),
    danger: (0, $fBy54.css)({
        color: "var(--ds-text-danger, #DE350B)"
    }),
    warning: (0, $fBy54.css)({
        color: "var(--ds-text-warning, #974F0C)"
    }),
    "warning.inverse": (0, $fBy54.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }),
    success: (0, $fBy54.css)({
        color: "var(--ds-text-success, #006644)"
    }),
    discovery: (0, $fBy54.css)({
        color: "var(--ds-text-discovery, #403294)"
    }),
    information: (0, $fBy54.css)({
        color: "var(--ds-text-information, #0052CC)"
    }),
    subtlest: (0, $fBy54.css)({
        color: "var(--ds-text-subtlest, #7A869A)"
    }),
    subtle: (0, $fBy54.css)({
        color: "var(--ds-text-subtle, #42526E)"
    })
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("u2nzd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a4a5e60878c7fe$export$2e2bcd8739ae039; });
var $05a4a5e60878c7fe$var$isProduction = true;
var $05a4a5e60878c7fe$var$prefix = "Invariant failed";
function $05a4a5e60878c7fe$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($05a4a5e60878c7fe$var$isProduction) throw new Error($05a4a5e60878c7fe$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($05a4a5e60878c7fe$var$prefix, ": ").concat(provided) : $05a4a5e60878c7fe$var$prefix;
    throw new Error(value);
}

});

parcelRegister("ioAsB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d646c02824947ab0$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * The color map is used to map a background color token to a matching text color that will meet contrast.
 *
 * @codegen <<SignedSource::9db207c6fd205f6abc46eeb73ba02789>>
 * @codegenCommand yarn codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::f1021f8d47ab63374e371ce18db72a1c>>
 */ var $d646c02824947ab0$export$2e2bcd8739ae039 = {
    "neutral.bold": "inverse",
    "neutral.bold.hovered": "inverse",
    "neutral.bold.pressed": "inverse",
    "selected.bold": "inverse",
    "selected.bold.hovered": "inverse",
    "selected.bold.pressed": "inverse",
    "brand.bold": "inverse",
    "brand.bold.hovered": "inverse",
    "brand.bold.pressed": "inverse",
    "brand.boldest": "inverse",
    "brand.boldest.hovered": "inverse",
    "brand.boldest.pressed": "inverse",
    "danger.bold": "inverse",
    "danger.bold.hovered": "inverse",
    "danger.bold.pressed": "inverse",
    "warning.bold": "warning.inverse",
    "warning.bold.hovered": "warning.inverse",
    "warning.bold.pressed": "warning.inverse",
    "success.bold": "inverse",
    "success.bold.hovered": "inverse",
    "success.bold.pressed": "inverse",
    "discovery.bold": "inverse",
    "discovery.bold.hovered": "inverse",
    "discovery.bold.pressed": "inverse",
    "information.bold": "inverse",
    "information.bold.hovered": "inverse",
    "information.bold.pressed": "inverse"
};

});

parcelRegister("dmEAC", function(module, exports) {

$parcel$export(module.exports, "useSurface", function () { return $9bacd0abdabdc88b$export$1aeb4f6b93c4540d; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $9bacd0abdabdc88b$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1Mpn7.createContext)("elevation.surface");
var $9bacd0abdabdc88b$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1Mpn7.useContext)($9bacd0abdabdc88b$export$1ca2a26fecb070ae);
};
$9bacd0abdabdc88b$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("8Srxj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6768b9fe2778fdbb$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $kkeBY = parcelRequire("kkeBY");

var $9GM4p = parcelRequire("9GM4p");

var $JZ760 = parcelRequire("JZ760");
var $6768b9fe2778fdbb$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $6768b9fe2778fdbb$var$_excluded2 = [
    "className"
];
var $6768b9fe2778fdbb$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1Mpn7.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref, $6768b9fe2778fdbb$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(htmlAttributes, $6768b9fe2778fdbb$var$_excluded2);
    var className = xcss && (0, $9GM4p.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $fBy54.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $6768b9fe2778fdbb$var$baseStyles,
            backgroundColor && (0, $kkeBY.backgroundColorStylesMap)[backgroundColor],
            (0, $kkeBY.isSurfaceColorToken)(backgroundColor) && (0, $kkeBY.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $kkeBY.paddingStylesMap).padding[padding],
            paddingBlock && (0, $kkeBY.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $kkeBY.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $kkeBY.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $kkeBY.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $kkeBY.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $kkeBY.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $fBy54.jsx)((0, $JZ760.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $6768b9fe2778fdbb$export$2e2bcd8739ae039 = $6768b9fe2778fdbb$export$e71c4d32a2263218;
var $6768b9fe2778fdbb$var$baseStyles = (0, $fBy54.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("kkeBY", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $ecc102719d4eb47f$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "spaceMap", function () { return $ecc102719d4eb47f$export$1f52408f03b1c9b4; });
$parcel$export(module.exports, "borderColorMap", function () { return $ecc102719d4eb47f$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $ecc102719d4eb47f$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "shadowMap", function () { return $ecc102719d4eb47f$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "textColorMap", function () { return $ecc102719d4eb47f$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $ecc102719d4eb47f$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $ecc102719d4eb47f$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $ecc102719d4eb47f$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $ecc102719d4eb47f$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $ecc102719d4eb47f$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $ecc102719d4eb47f$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $ecc102719d4eb47f$export$5e65a44e5b6ecadb; });

var $jjExS = parcelRequire("jjExS");

var $fBy54 = parcelRequire("fBy54");

var $fAQtF = parcelRequire("fAQtF");
var $ecc102719d4eb47f$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $ecc102719d4eb47f$export$1f52408f03b1c9b4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $ecc102719d4eb47f$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $ecc102719d4eb47f$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $ecc102719d4eb47f$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $ecc102719d4eb47f$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $ecc102719d4eb47f$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $ecc102719d4eb47f$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)"
};
var $ecc102719d4eb47f$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $ecc102719d4eb47f$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $ecc102719d4eb47f$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $ecc102719d4eb47f$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $ecc102719d4eb47f$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $ecc102719d4eb47f$export$6cc560b4dedf3816 = {
    "font.size.050": "var(--ds-font-size-050, 11px)",
    "font.size.075": "var(--ds-font-size-075, 12px)",
    "font.size.100": "var(--ds-font-size-100, 14px)",
    "font.size.200": "var(--ds-font-size-200, 16px)",
    "font.size.300": "var(--ds-font-size-300, 20px)",
    "font.size.400": "var(--ds-font-size-400, 24px)",
    "font.size.500": "var(--ds-font-size-500, 29px)",
    "font.size.600": "var(--ds-font-size-600, 35px)"
};
var $ecc102719d4eb47f$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $ecc102719d4eb47f$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand": "var(--ds-font-family-brand, Charlie Sans)",
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.monospace": 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.sans": 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
};
var $ecc102719d4eb47f$export$360c29a380c1a34 = {
    "font.lineHeight.1": "var(--ds-font-lineHeight-1, 1)",
    "font.lineHeight.100": "var(--ds-font-lineHeight-100, 16px)",
    "font.lineHeight.200": "var(--ds-font-lineHeight-200, 20px)",
    "font.lineHeight.300": "var(--ds-font-lineHeight-300, 24px)",
    "font.lineHeight.400": "var(--ds-font-lineHeight-400, 28px)",
    "font.lineHeight.500": "var(--ds-font-lineHeight-500, 32px)",
    "font.lineHeight.600": "var(--ds-font-lineHeight-600, 40px)"
};
var $ecc102719d4eb47f$export$b5bac06d7d8fd0d1 = {
    body: "var(--ds-font-body, normal 400 14px/20px var(--ds-font-family-body))",
    "body.large": "var(--ds-font-body-large, normal 400 16px/24px var(--ds-font-family-body))",
    "body.small": "var(--ds-font-body-small, normal 400 11px/20px var(--ds-font-family-body))"
};
var $ecc102719d4eb47f$export$b27166c9cf2c9f74 = {
    ui: "var(--ds-font-ui, normal 400 14px/1 var(--ds-font-family-body))",
    "ui.small": "var(--ds-font-ui-small, normal 400 11px/1 var(--ds-font-family-body))"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $ecc102719d4eb47f$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $ecc102719d4eb47f$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $fBy54.css)((0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $ecc102719d4eb47f$export$e615f061ca585a6c = $ecc102719d4eb47f$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ecc102719d4eb47f$var$getSerializedStylesMap(spacingProperty, $ecc102719d4eb47f$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $ecc102719d4eb47f$export$bf46c3f9eeafc71f = $ecc102719d4eb47f$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ecc102719d4eb47f$var$getSerializedStylesMap(spacingProperty, $ecc102719d4eb47f$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $ecc102719d4eb47f$export$e7af83bafe7f9e63 = $ecc102719d4eb47f$var$getSerializedStylesMap("backgroundColor", $ecc102719d4eb47f$export$d1d79bf68ac056bd);
var $ecc102719d4eb47f$export$3a1bcba60b23d7f0 = $ecc102719d4eb47f$var$getSerializedStylesMap("color", $ecc102719d4eb47f$export$8473307aa00d6ea1);
var $ecc102719d4eb47f$export$f7183c9e2dbc2543 = $ecc102719d4eb47f$var$getSerializedStylesMap("fontSize", $ecc102719d4eb47f$export$6cc560b4dedf3816);
var $ecc102719d4eb47f$export$45f3f4fe16f9f7d5 = $ecc102719d4eb47f$var$getSerializedStylesMap("fontWeight", $ecc102719d4eb47f$export$303e322c6b1ed114);
var $ecc102719d4eb47f$export$68cc305da27dbaa4 = $ecc102719d4eb47f$var$getSerializedStylesMap("fontFamily", $ecc102719d4eb47f$export$3c7e9587132614b4);
var $ecc102719d4eb47f$export$8be4a21014f48eb1 = $ecc102719d4eb47f$var$getSerializedStylesMap("lineHeight", $ecc102719d4eb47f$export$360c29a380c1a34);
var $ecc102719d4eb47f$export$a1962444bbf058e = $ecc102719d4eb47f$var$getSerializedStylesMap("font", $ecc102719d4eb47f$export$b5bac06d7d8fd0d1);
var $ecc102719d4eb47f$export$ca3e246f24657bd6 = $ecc102719d4eb47f$var$getSerializedStylesMap("font", $ecc102719d4eb47f$export$b27166c9cf2c9f74);
var $ecc102719d4eb47f$export$ff257d957d48c421 = $ecc102719d4eb47f$var$getSerializedStylesMap((0, $fAQtF.CURRENT_SURFACE_CSS_VAR), $ecc102719d4eb47f$export$41a358c9c2356760);
var $ecc102719d4eb47f$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $ecc102719d4eb47f$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("fAQtF", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $b5a2ecc202bbe0a5$export$9d7b58831ae93caa; });
var $b5a2ecc202bbe0a5$export$4ef52930e33717cd = "data-theme";
var $b5a2ecc202bbe0a5$export$a00eac3f8684bcd0 = "data-color-mode";
var $b5a2ecc202bbe0a5$export$2112803007239c61 = "data-contrast-mode";
var $b5a2ecc202bbe0a5$export$352e418ed5b6193a = "data-custom-theme";
var $b5a2ecc202bbe0a5$export$2faeed762aac6741 = "light";
var $b5a2ecc202bbe0a5$export$6f0c6fb8c80fcc92 = "ds";
var $b5a2ecc202bbe0a5$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $b5a2ecc202bbe0a5$export$dddac1532e822863 = "--".concat($b5a2ecc202bbe0a5$export$6f0c6fb8c80fcc92, "-token-not-found");
var $b5a2ecc202bbe0a5$export$9d7b58831ae93caa = "--".concat($b5a2ecc202bbe0a5$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("9GM4p", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $70dd5304dfdfc6bf$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $70dd5304dfdfc6bf$export$f6c783d06584602c; });

var $jjExS = parcelRequire("jjExS");

var $e6gyJ = parcelRequire("e6gyJ");

var $2nffd = parcelRequire("2nffd");

var $fBy54 = parcelRequire("fBy54");

var $kkeBY = parcelRequire("kkeBY");

var $3qWgZ = parcelRequire("3qWgZ");
var $70dd5304dfdfc6bf$var$tokensMap = {
    backgroundColor: (0, $kkeBY.backgroundColorMap),
    blockSize: (0, $kkeBY.dimensionMap),
    borderColor: (0, $kkeBY.borderColorMap),
    borderRadius: (0, $kkeBY.borderRadiusMap),
    borderWidth: (0, $kkeBY.borderWidthMap),
    bottom: (0, $kkeBY.spaceMap),
    boxShadow: (0, $kkeBY.shadowMap),
    color: (0, $kkeBY.textColorMap),
    columnGap: (0, $kkeBY.spaceMap),
    gap: (0, $kkeBY.spaceMap),
    height: (0, $kkeBY.dimensionMap),
    inlineSize: (0, $kkeBY.dimensionMap),
    inset: (0, $kkeBY.spaceMap),
    insetBlock: (0, $kkeBY.spaceMap),
    insetBlockEnd: (0, $kkeBY.spaceMap),
    insetBlockStart: (0, $kkeBY.spaceMap),
    insetInline: (0, $kkeBY.spaceMap),
    insetInlineEnd: (0, $kkeBY.spaceMap),
    insetInlineStart: (0, $kkeBY.spaceMap),
    margin: (0, $kkeBY.spaceMap),
    marginBlock: (0, $kkeBY.spaceMap),
    marginBlockEnd: (0, $kkeBY.spaceMap),
    marginBlockStart: (0, $kkeBY.spaceMap),
    marginBottom: (0, $kkeBY.spaceMap),
    marginInline: (0, $kkeBY.spaceMap),
    marginInlineEnd: (0, $kkeBY.spaceMap),
    marginInlineStart: (0, $kkeBY.spaceMap),
    marginLeft: (0, $kkeBY.spaceMap),
    marginRight: (0, $kkeBY.spaceMap),
    marginTop: (0, $kkeBY.spaceMap),
    left: (0, $kkeBY.spaceMap),
    maxBlockSize: (0, $kkeBY.dimensionMap),
    maxHeight: (0, $kkeBY.dimensionMap),
    maxInlineSize: (0, $kkeBY.dimensionMap),
    maxWidth: (0, $kkeBY.dimensionMap),
    minBlockSize: (0, $kkeBY.dimensionMap),
    minHeight: (0, $kkeBY.dimensionMap),
    minInlineSize: (0, $kkeBY.dimensionMap),
    minWidth: (0, $kkeBY.dimensionMap),
    outlineOffset: (0, $kkeBY.spaceMap),
    outlineWidth: (0, $kkeBY.borderWidthMap),
    outlineColor: (0, $kkeBY.borderColorMap),
    padding: (0, $kkeBY.spaceMap),
    paddingBlock: (0, $kkeBY.spaceMap),
    paddingBlockEnd: (0, $kkeBY.spaceMap),
    paddingBlockStart: (0, $kkeBY.spaceMap),
    paddingBottom: (0, $kkeBY.spaceMap),
    paddingInline: (0, $kkeBY.spaceMap),
    paddingInlineEnd: (0, $kkeBY.spaceMap),
    paddingInlineStart: (0, $kkeBY.spaceMap),
    paddingLeft: (0, $kkeBY.spaceMap),
    paddingRight: (0, $kkeBY.spaceMap),
    paddingTop: (0, $kkeBY.spaceMap),
    right: (0, $kkeBY.spaceMap),
    rowGap: (0, $kkeBY.spaceMap),
    top: (0, $kkeBY.spaceMap),
    width: (0, $kkeBY.dimensionMap),
    zIndex: (0, $kkeBY.layerMap)
};
var $70dd5304dfdfc6bf$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $70dd5304dfdfc6bf$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3qWgZ === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))($3qWgZ)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))($3qWgZ.env) === "object" && false;
};
var $70dd5304dfdfc6bf$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $70dd5304dfdfc6bf$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $70dd5304dfdfc6bf$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))(value) === "object" && $70dd5304dfdfc6bf$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($70dd5304dfdfc6bf$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($70dd5304dfdfc6bf$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $70dd5304dfdfc6bf$var$tokensMap)) return;
        var tokenValue = $70dd5304dfdfc6bf$var$tokensMap[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $70dd5304dfdfc6bf$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $70dd5304dfdfc6bf$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))({}, $70dd5304dfdfc6bf$var$uniqueSymbol, (0, $fBy54.css)(transformedStyles));
};
var $70dd5304dfdfc6bf$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$70dd5304dfdfc6bf$var$uniqueSymbol];
    typeof $3qWgZ === "undefined" || (0, (/*@__PURE__*/$parcel$interopDefault($2nffd)))($3qWgZ);
    return styles;
};
function $70dd5304dfdfc6bf$export$f6c783d06584602c(style) {
    return $70dd5304dfdfc6bf$var$baseXcss(style);
}

});

parcelRegister("JZ760", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $08a39bf12a0e276d$export$1ca2a26fecb070ae; });

var $1Mpn7 = parcelRequire("1Mpn7");
var $08a39bf12a0e276d$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1Mpn7.createContext)("elevation.surface");
var $08a39bf12a0e276d$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1Mpn7.useContext)($08a39bf12a0e276d$export$1ca2a26fecb070ae);
};
$08a39bf12a0e276d$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("8RcaX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $672cb7d548f8c71a$export$2e2bcd8739ae039; });

var $2ljoN = parcelRequire("2ljoN");
var $672cb7d548f8c71a$var$messages = (0, $2ljoN.defineMessages)({
    newLozenge: {
        id: "fabric.atlassianSwitcher.newLozenge",
        defaultMessage: "New",
        description: "The lozenge text for a lozenge indicating a new switcher item"
    }
});
var $672cb7d548f8c71a$export$2e2bcd8739ae039 = $672cb7d548f8c71a$var$messages;

});

parcelRegister("UCi4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aa2eec09514c69b$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $e6gyJ = parcelRequire("e6gyJ");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $hgJzq = parcelRequire("hgJzq");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $inZyb = parcelRequire("inZyb");
var $hNTqI = parcelRequire("hNTqI");

var $fBy54 = parcelRequire("fBy54");

var $6vES8 = parcelRequire("6vES8");

var $3Bj0N = parcelRequire("3Bj0N");
parcelRequire("l9sEk");
var $5p8VA = parcelRequire("5p8VA");
var $l9sEk = parcelRequire("l9sEk");
var $g1gbh = parcelRequire("g1gbh");

var $Yi5je = parcelRequire("Yi5je");

var $ariLb = parcelRequire("ariLb");

var $cy2yA = parcelRequire("cy2yA");

var $k8M01 = parcelRequire("k8M01");

var $5gYcE = parcelRequire("5gYcE");

var $iJ0X7 = parcelRequire("iJ0X7");

var $buKGS = parcelRequire("buKGS");
function $0aa2eec09514c69b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0aa2eec09514c69b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0aa2eec09514c69b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0aa2eec09514c69b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0aa2eec09514c69b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0aa2eec09514c69b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $0aa2eec09514c69b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $0aa2eec09514c69b$var$TRIGGER_SUBJECT = "errorBoundary";
var $0aa2eec09514c69b$var$ACTION_SUBJECT = "rendered";
// This image is also used as the generic error message in Notifications
var $0aa2eec09514c69b$var$robotsImgStyles = (0, $fBy54.css)({
    height: 200
});
var $0aa2eec09514c69b$var$trelloErrorImgStyles = (0, $fBy54.css)({
    width: 140,
    height: 88
});
var $0aa2eec09514c69b$var$unverifiedUserImageStyles = (0, $fBy54.css)({
    height: 150
});
var $0aa2eec09514c69b$var$errorContentStyles = (0, $fBy54.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
});
var $0aa2eec09514c69b$var$errorHeadingStyles = (0, $fBy54.css)({
    maxWidth: 240,
    marginTop: "var(--ds-space-400, 32px)"
});
var $0aa2eec09514c69b$var$errorMessageStyles = (0, $fBy54.css)({
    maxWidth: 240,
    marginTop: "var(--ds-space-300, 24px)"
});
var $0aa2eec09514c69b$var$loginButtonStyles = (0, $fBy54.css)({
    marginTop: "var(--ds-space-300, 24px)"
});
var $0aa2eec09514c69b$var$errorBoundaryBoxStyles = (0, $fBy54.css)({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center"
});
var $0aa2eec09514c69b$var$errorBoundaryBoxDrawerStyles = (0, $fBy54.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    paddingTop: 128,
    paddingRight: "var(--ds-space-800, 64px)"
});
var $0aa2eec09514c69b$var$errorBoundaryBoxNonDrawerStyles = (0, $fBy54.css)({
    margin: "var(--ds-space-600, 48px)".concat(" 0")
});
var $0aa2eec09514c69b$var$loginButtonNonDrawerStyles = (0, $fBy54.css)({
    justifyContent: "center",
    alignSelf: "stretch"
});
var $0aa2eec09514c69b$var$ErrorMessage = function ErrorMessage(props) {
    return (0, $fBy54.jsx)("p", {
        css: $0aa2eec09514c69b$var$errorMessageStyles
    }, props.children);
};
var $0aa2eec09514c69b$var$ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(ErrorBoundary, _React$Component);
    var _super = $0aa2eec09514c69b$var$_createSuper(ErrorBoundary);
    function ErrorBoundary() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, ErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "state", {
            hasError: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "fireOperationalEvent", function(payload) {
            if (_this.props.createAnalyticsEvent) _this.props.createAnalyticsEvent($0aa2eec09514c69b$var$_objectSpread({
                eventType: (0, $5p8VA.OPERATIONAL_EVENT_TYPE),
                actionSubject: _this.props.triggerSubject || $0aa2eec09514c69b$var$TRIGGER_SUBJECT
            }, payload)).fire((0, $l9sEk.NAVIGATION_CHANNEL));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "handleLogin", function(_, analyticsEvent) {
            analyticsEvent.update({
                eventType: (0, $5p8VA.UI_EVENT_TYPE),
                actionSubjectId: "login"
            }).fire((0, $l9sEk.NAVIGATION_CHANNEL));
            if (_this.props.product !== (0, $k8M01.Product).TRELLO) window.location.reload();
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                var _this2 = this, _this$props$onErrorCa, _this$props;
                var reason = error instanceof (0, $iJ0X7.SwitcherLoadError) ? error.reason() : (0, $ariLb.errorToReason)(error);
                this.setState({
                    hasError: true,
                    reason: reason
                }, function() {
                    _this2.fireOperationalEvent({
                        action: $0aa2eec09514c69b$var$ACTION_SUBJECT,
                        attributes: $0aa2eec09514c69b$var$_objectSpread($0aa2eec09514c69b$var$_objectSpread({}, reason), _this2.props.extraAnalyticProps)
                    });
                });
                (_this$props$onErrorCa = (_this$props = this.props).onErrorCallback) === null || _this$props$onErrorCa === void 0 || _this$props$onErrorCa.call(_this$props, error);
            }
        },
        {
            key: "renderErrorBody",
            value: function renderErrorBody(appearance) {
                var reason = this.state.reason;
                if (!reason) return;
                if (reason.name === (0, $buKGS.FETCH_ERROR_NAME)) {
                    var isTrello = this.props.product === (0, $k8M01.Product).TRELLO;
                    if (reason.status === 401) // Not authorised http error
                    return (0, $fBy54.jsx)((0, $1Mpn7.Fragment), null, (0, $fBy54.jsx)($0aa2eec09514c69b$var$ErrorMessage, null, (0, $fBy54.jsx)((0, $inZyb.default), (0, $cy2yA.default).errorTextLoggedOut)), isTrello ? (0, $fBy54.jsx)((0, $5gYcE.default), {
                        css: [
                            $0aa2eec09514c69b$var$loginButtonStyles,
                            appearance !== "drawer" && $0aa2eec09514c69b$var$loginButtonNonDrawerStyles
                        ],
                        appearance: "link",
                        href: (0, $Yi5je.getLoginUrl)((0, $k8M01.Product).TRELLO),
                        onClick: this.handleLogin
                    }, (0, $fBy54.jsx)((0, $inZyb.default), (0, $cy2yA.default).login)) : (0, $fBy54.jsx)((0, $5gYcE.default), {
                        css: [
                            $0aa2eec09514c69b$var$loginButtonStyles,
                            appearance !== "drawer" && $0aa2eec09514c69b$var$loginButtonNonDrawerStyles
                        ],
                        onClick: this.handleLogin
                    }, (0, $fBy54.jsx)((0, $inZyb.default), (0, $cy2yA.default).login)));
                    if (reason.status === 403) return (0, $fBy54.jsx)($0aa2eec09514c69b$var$ErrorMessage, null, (0, $fBy54.jsx)((0, $inZyb.default), (0, $cy2yA.default).errorTextUnverified));
                    return (0, $fBy54.jsx)($0aa2eec09514c69b$var$ErrorMessage, null, (0, $fBy54.jsx)((0, $inZyb.default), (0, $cy2yA.default).errorTextNetwork));
                }
                // Default error message
                return (0, $fBy54.jsx)($0aa2eec09514c69b$var$ErrorMessage, null, (0, $fBy54.jsx)((0, $inZyb.default), (0, $cy2yA.default).errorText));
            }
        },
        {
            key: "renderErrorHeading",
            value: function renderErrorHeading() {
                var reason = this.state.reason;
                if (!reason) return;
                if (reason.name === (0, $buKGS.FETCH_ERROR_NAME) && reason.status === 401) return (0, $fBy54.jsx)((0, $inZyb.default), (0, $cy2yA.default).errorHeadingLoggedOut);
                if (reason.name === (0, $buKGS.FETCH_ERROR_NAME) && reason.status === 403) return (0, $fBy54.jsx)((0, $inZyb.default), (0, $cy2yA.default).errorHeadingUnverified);
                return (0, $fBy54.jsx)((0, $inZyb.default), (0, $cy2yA.default).errorHeading);
            }
        },
        {
            key: "renderErrorImage",
            value: function renderErrorImage() {
                var _this$props2 = this.props, intl = _this$props2.intl, product = _this$props2.product;
                var reason = this.state.reason;
                if (product === (0, $k8M01.Product).TRELLO) return (0, $fBy54.jsx)("img", {
                    css: $0aa2eec09514c69b$var$trelloErrorImgStyles,
                    src: (0, $6vES8.default),
                    alt: intl.formatMessage((0, $cy2yA.default).errorImageAltText)
                });
                if (reason.status === 403) return (0, $fBy54.jsx)("img", {
                    css: $0aa2eec09514c69b$var$unverifiedUserImageStyles,
                    src: (0, $3Bj0N.default),
                    alt: intl.formatMessage((0, $cy2yA.default).errorImageAltText)
                });
                return (0, $fBy54.jsx)($0aa2eec09514c69b$var$RobotImage, {
                    css: $0aa2eec09514c69b$var$robotsImgStyles,
                    alt: intl.formatMessage((0, $cy2yA.default).errorImageAltText)
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, appearance = _this$props3.appearance, hideFallbackUI = _this$props3.hideFallbackUI;
                var hasError = this.state.hasError;
                if (hasError && hideFallbackUI) return (0, $fBy54.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null);
                if (hasError) return (0, $fBy54.jsx)("div", {
                    css: [
                        $0aa2eec09514c69b$var$errorBoundaryBoxStyles,
                        appearance === "drawer" ? $0aa2eec09514c69b$var$errorBoundaryBoxDrawerStyles : $0aa2eec09514c69b$var$errorBoundaryBoxNonDrawerStyles
                    ],
                    "data-testid": "error-boundary"
                }, (0, $fBy54.jsx)("div", {
                    css: $0aa2eec09514c69b$var$errorContentStyles
                }, this.renderErrorImage(), (0, $fBy54.jsx)("h3", {
                    css: $0aa2eec09514c69b$var$errorHeadingStyles
                }, this.renderErrorHeading()), this.renderErrorBody(appearance)));
                return this.props.children;
            }
        }
    ]);
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Component);

var $0aa2eec09514c69b$var$RobotImage = function RobotImage(props) {
    var _useState = (0, $1Mpn7.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), imgSrc = _useState2[0], setImgSrc = _useState2[1];
    (0, $1Mpn7.useEffect)(function() {
        (parcelRequire("1DnwK")).then(function(src) {
            return setImgSrc(src.default);
        });
    }, []);
    return (0, $fBy54.jsx)("img", (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({}, props, {
        src: imgSrc
    }));
};
var $0aa2eec09514c69b$export$2e2bcd8739ae039 = (0, $g1gbh.default)()((0, $hNTqI.default)($0aa2eec09514c69b$var$ErrorBoundary));

});
parcelRegister("6vES8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bd557ae096fbeea$export$2e2bcd8739ae039; });
var $4bd557ae096fbeea$export$2e2bcd8739ae039 = "data:image/svg+xml;base64,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";

});

parcelRegister("3Bj0N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29f39327068d7185$export$2e2bcd8739ae039; });
var $29f39327068d7185$export$2e2bcd8739ae039 = "data:image/svg+xml;base64,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";

});

parcelRegister("Yi5je", function(module, exports) {

$parcel$export(module.exports, "Environment", function () { return $0b53a1f14ad9cc17$export$7dc6752a22ab011a; });
$parcel$export(module.exports, "getEnvName", function () { return $0b53a1f14ad9cc17$export$186d9db1ec46a9ca; });
$parcel$export(module.exports, "getLoginUrl", function () { return $0b53a1f14ad9cc17$export$8abe2e83e8d74da2; });

var $k8M01 = parcelRequire("k8M01");
var $0b53a1f14ad9cc17$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Staging"] = "stg";
    Environment["Production"] = "prod";
    return Environment;
}({});
var $0b53a1f14ad9cc17$export$186d9db1ec46a9ca = function getEnvName() {
    var _window;
    var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.origin;
    return [
        "https://trello.com"
    ].includes(origin) ? $0b53a1f14ad9cc17$export$7dc6752a22ab011a.Production : $0b53a1f14ad9cc17$export$7dc6752a22ab011a.Staging;
};
var $0b53a1f14ad9cc17$var$getProduct = function getProduct(product) {
    if (product) {
        var lowerJira = (0, $k8M01.Product).JIRA.toLowerCase();
        var lowerProduct = product.toLowerCase();
        if (lowerProduct.includes(lowerJira)) return lowerJira;
        return lowerProduct;
    }
};
var $0b53a1f14ad9cc17$export$8abe2e83e8d74da2 = function getLoginUrl(productType) {
    var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0b53a1f14ad9cc17$export$186d9db1ec46a9ca();
    var continueUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : String(window.location);
    var loginHint = arguments.length > 3 ? arguments[3] : undefined;
    var baseUrl = env === $0b53a1f14ad9cc17$export$7dc6752a22ab011a.Production ? "https://id.atlassian.com/login" : "https://id.stg.internal.atlassian.com/login";
    var product = $0b53a1f14ad9cc17$var$getProduct(productType);
    return "".concat(baseUrl, "?continue=").concat(encodeURIComponent(continueUrl)).concat(product ? "&application=".concat(encodeURIComponent(product)) : "", "\n  ").concat(loginHint ? "&login_hint=".concat(encodeURIComponent(loginHint)) : "");
};

});

parcelRegister("cy2yA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $922aa4c307ccd3c1$export$2e2bcd8739ae039; });

var $2ljoN = parcelRequire("2ljoN");
var $922aa4c307ccd3c1$var$messages = (0, $2ljoN.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.title",
        defaultMessage: "Get started with cloud",
        description: "The title text for the empty state explore products content, which prompts users to try new products."
    },
    emptyStateExploreProductsBody: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.body",
        defaultMessage: "Try a product to start collaborating with your team.",
        description: "The body text for the empty state explore products content, which prompts users to try new products."
    },
    emptyStateExploreProductsLink: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.link",
        defaultMessage: "Explore products",
        description: "The text for the empty state explore products link, which prompts users to try new products."
    },
    atlassianStart: {
        id: "fabric.atlassianSwitcher.start",
        defaultMessage: "Atlassian Start",
        description: "The text of a link redirecting the user to the Start site"
    },
    recent: {
        id: "fabric.atlassianSwitcher.recent",
        defaultMessage: "Recent",
        description: "In a context in which users are able to view recent projects or spaces they've viewed, this text is the title of the section displaying all the recent projects or spaces."
    },
    more: {
        id: "fabric.atlassianSwitcher.more",
        defaultMessage: "More",
        description: "In a context in which users are able to view predefined custom links, this text is the title of the section displaying all existing custom links."
    },
    try: {
        id: "fabric.atlassianSwitcher.try",
        defaultMessage: "Try",
        description: "This text appears as a way to encourage the user to try a new Atlassian product."
    },
    manageList: {
        id: "fabric.atlassianSwitcher.manageList",
        defaultMessage: "Manage list",
        description: "This text is for the action for a user to manage the values present in an editable list of links."
    },
    jiraProject: {
        id: "fabric.atlassianSwitcher.jiraProject",
        defaultMessage: "Jira project",
        description: "In a context in which several items are listed , this text describes that the specific type of a given item is a Jira project"
    },
    confluenceSpace: {
        id: "fabric.atlassianSwitcher.confluenceSpace",
        defaultMessage: "Confluence space",
        description: "In a context in which several items are listed , this text describes that the specific type of a given item is a Confluence space"
    },
    administration: {
        id: "fabric.atlassianSwitcher.administration",
        defaultMessage: "Administration",
        description: "The text of a link redirecting the user to the site administration"
    },
    moreAtlassianProductsLink: {
        id: "fabric.atlassianSwitcher.moreAtlassianProducts",
        defaultMessage: "More Atlassian products",
        description: "The text of a link redirecting the user to Discover More Atlassian products"
    },
    slackIntegrationLink: {
        id: "fabric.atlassianSwitcher.slackIntegrationLink",
        defaultMessage: "Slack",
        description: "The text of a link which opens the Slack Authentication popup"
    },
    slackIntegrationLinkDescription: {
        id: "fabric.atlassianSwitcher.slackIntegrationLinkDescription",
        defaultMessage: "Integrate Slack with your Atlassian products",
        description: "The description of a link which opens the Slack Authentication popup"
    },
    browseApps: {
        id: "fabric.atlassianSwitcher.browseApps",
        defaultMessage: "Browse Marketplace apps",
        description: "The text of a link redirecting the user to Discover Embedded Marketplace within in the product (Marketplace is a brand name. Please dont translate it)"
    },
    errorEmptyPartialResults: {
        id: "fabric.atlassianSwitcher.errorEmptyPartialResults",
        defaultMessage: "We can't display your products right now.",
        description: "Heading of the error message when available products returns a partial result and no sites"
    },
    errorHeading: {
        id: "fabric.atlassianSwitcher.errorHeading",
        defaultMessage: "Something\u2019s gone wrong",
        description: "Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests."
    },
    errorText: {
        id: "fabric.atlassianSwitcher.errorText",
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: "Text that is displayed when an unknown error happens in the Atlassian Switcher."
    },
    errorImageAltText: {
        id: "fabric.atlassianSwitcher.errorImageAltText",
        defaultMessage: "A broken robot and a number of people busy fixing it.",
        description: "Text displayed as alt text when an error occurs in the Atlassian Switcher"
    },
    errorTextNetwork: {
        id: "fabric.atlassianSwitcher.errorTextNetwork",
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: "Text that is displayed when we detect a network issue."
    },
    errorHeadingLoggedOut: {
        id: "fabric.atlassianSwitcher.errorHeadingLoggedOut",
        defaultMessage: "Your Atlassian account is logged out",
        description: "Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests."
    },
    errorTextLoggedOut: {
        id: "fabric.atlassianSwitcher.errorTextLoggedOut",
        defaultMessage: "Log in again to use the Atlassian\xa0switcher.",
        description: "Text that is displayed when we detect user is logged out."
    },
    errorHeadingUnverified: {
        id: "fabric.atlassianSwitcher.errorHeadingUnverified",
        defaultMessage: "Your account is unverified",
        description: "Heading that is displayed when we detect user account is unverified."
    },
    errorPartialResults: {
        id: "fabric.atlassianSwitcher.errorPartialResults",
        defaultMessage: "We can't display some of your products right now.",
        description: "Heading of the error message when available products returns a partial result and 1 or more sites"
    },
    errorPartialResultsRefresh: {
        id: "fabric.atlassianSwitcher.errorPartialResultsRefresh",
        defaultMessage: "Refresh the page, or try again later.",
        description: "Subtitle of the error message when available products returns a partial result"
    },
    errorTextUnverified: {
        id: "fabric.atlassianSwitcher.errorTextUnverified",
        defaultMessage: "Please confirm your email address to view a list of available products.",
        description: "Text that is displayed when we detect user account is unverified."
    },
    login: {
        id: "fabric.atlassianSwitcher.login",
        defaultMessage: "Log in",
        description: "Text in log in button."
    },
    discover: {
        id: "fabric.atlassianSwitcher.discover",
        defaultMessage: "Discover",
        description: 'The header of "Discover" section'
    },
    productDescriptionConfluence: {
        id: "fabric.atlassianSwitcher.product.description.confluence",
        defaultMessage: "Document collaboration",
        description: "Text displayed under the Confluence product recommendation."
    },
    productDescriptionJiraServiceManagement: {
        id: "fabric.atlassianSwitcher.product.description.jsm",
        defaultMessage: "Collaborative IT service management",
        description: "Text displayed under the Jira Service Management product recommendation."
    },
    productDescriptionJiraSoftware: {
        id: "fabric.atlassianSwitcher.product.description.jsw",
        defaultMessage: "Project and issue tracking",
        description: "Text displayed under the Jira Software product recommendation."
    },
    productDescriptionOpsgenie: {
        id: "fabric.atlassianSwitcher.product.description.opsgenie",
        defaultMessage: "Modern incident management",
        description: "Text displayed under the Opsgenie product recommendation."
    },
    productDescriptionCompass: {
        id: "fabric.atlassianSwitcher.product.description.compass",
        defaultMessage: "Component manager",
        description: "Text displayed under the Compass product recommendation."
    },
    join: {
        id: "fabric.atlassianSwitcher.join",
        defaultMessage: "Join",
        description: "Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators."
    }
});
var $922aa4c307ccd3c1$export$2e2bcd8739ae039 = $922aa4c307ccd3c1$var$messages;

});

parcelRegister("5gYcE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d6d2573122387bf$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $4LA0w = parcelRequire("4LA0w");
function $3d6d2573122387bf$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $4LA0w.default), props);
}

});
parcelRegister("4LA0w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37877b8c95eb9bbf$export$2e2bcd8739ae039; });

var $fjkYW = parcelRequire("fjkYW");

var $e6gyJ = parcelRequire("e6gyJ");

var $jjExS = parcelRequire("jjExS");

var $04Kcc = parcelRequire("04Kcc");

var $1Mpn7 = parcelRequire("1Mpn7");

var $iCmLV = parcelRequire("iCmLV");

var $6C4Za = parcelRequire("6C4Za");

var $aB1kl = parcelRequire("aB1kl");

var $kZskj = parcelRequire("kZskj");

var $11Nkl = parcelRequire("11Nkl");
var $37877b8c95eb9bbf$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $37877b8c95eb9bbf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37877b8c95eb9bbf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37877b8c95eb9bbf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37877b8c95eb9bbf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $37877b8c95eb9bbf$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $37877b8c95eb9bbf$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $37877b8c95eb9bbf$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $11Nkl.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref2, $37877b8c95eb9bbf$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $37877b8c95eb9bbf$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $1Mpn7.useState)($37877b8c95eb9bbf$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $1Mpn7.useCallback)(function(event) {
        setState(function(current) {
            return $37877b8c95eb9bbf$var$_objectSpread($37877b8c95eb9bbf$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $1Mpn7.useCallback)(function(event) {
        setState(function(current) {
            return $37877b8c95eb9bbf$var$_objectSpread($37877b8c95eb9bbf$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $1Mpn7.useCallback)(function(event) {
        setState(function(current) {
            return $37877b8c95eb9bbf$var$_objectSpread($37877b8c95eb9bbf$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $1Mpn7.useCallback)(function(event) {
        setState(function(current) {
            return $37877b8c95eb9bbf$var$_objectSpread($37877b8c95eb9bbf$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $1Mpn7.useCallback)(function(event) {
        setState(function(current) {
            return $37877b8c95eb9bbf$var$_objectSpread($37877b8c95eb9bbf$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $1Mpn7.useCallback)(function(event) {
        setState(function(current) {
            return $37877b8c95eb9bbf$var$_objectSpread($37877b8c95eb9bbf$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $11Nkl.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $iCmLV.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $11Nkl.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({
            mode: mode,
            state: $37877b8c95eb9bbf$var$getInteractionState($37877b8c95eb9bbf$var$_objectSpread($37877b8c95eb9bbf$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $aB1kl.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $6C4Za.default), (0, (/*@__PURE__*/$parcel$interopDefault($fjkYW)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $kZskj.default), restProps) : null,
                "aria-busy": isLoading,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $11Nkl.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$37877b8c95eb9bbf$var$CustomThemeButton.displayName = "CustomThemeButton";
var $37877b8c95eb9bbf$export$2e2bcd8739ae039 = $37877b8c95eb9bbf$var$CustomThemeButton;

});
parcelRegister("kZskj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f47f7a348a31d22d$export$2e2bcd8739ae039; });

var $1Mpn7 = parcelRequire("1Mpn7");

var $aeQDq = parcelRequire("aeQDq");
function $f47f7a348a31d22d$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $f47f7a348a31d22d$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $aeQDq.default), {
        size: size,
        appearance: $f47f7a348a31d22d$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("aeQDq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77440a67b7628e2c$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1Mpn7 = parcelRequire("1Mpn7");

var $fBy54 = parcelRequire("fBy54");

var $f3uqe = parcelRequire("f3uqe");

var $csE0A = parcelRequire("csE0A");

var $iCmLV = parcelRequire("iCmLV");

var $70JVv = parcelRequire("70JVv");
/**
 * Returns the appropriate circle stroke color.
 */ function $77440a67b7628e2c$var$getStrokeColor(_ref) {
    var mode = _ref.mode, appearance = _ref.appearance;
    if (mode === "light") return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $csE0A.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $csE0A.N0), ")");
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $csE0A.DN900), ")") : "var(--ds-icon-inverse, ".concat((0, $csE0A.DN500), ")");
}
var $77440a67b7628e2c$var$rotate = (0, $fBy54.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $77440a67b7628e2c$var$rotateStyles = (0, $fBy54.css)({
    animation: "".concat($77440a67b7628e2c$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $77440a67b7628e2c$var$loadIn = (0, $fBy54.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $77440a67b7628e2c$var$loadInStyles = (0, $fBy54.css)({
    animation: "".concat($77440a67b7628e2c$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $77440a67b7628e2c$var$wrapperStyles = (0, $fBy54.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $77440a67b7628e2c$var$circleStyles = (0, $fBy54.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $77440a67b7628e2c$var$useLayoutEffect = typeof window === "undefined" ? (0, $1Mpn7.useEffect) : (0, $1Mpn7.useLayoutEffect);
var $77440a67b7628e2c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).forwardRef(function Spinner(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "inherit" : _ref2$appearance, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 0 : _ref2$delay, interactionName = _ref2.interactionName, label = _ref2.label, _ref2$size = _ref2.size, providedSize = _ref2$size === void 0 ? "medium" : _ref2$size, testId = _ref2.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $70JVv.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var _useGlobalTheme = (0, $iCmLV.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var stroke = $77440a67b7628e2c$var$getStrokeColor({
        mode: mode,
        appearance: appearance
    });
    var context = (0, $1Mpn7.useContext)((0, $f3uqe.default));
    $77440a67b7628e2c$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $fBy54.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $77440a67b7628e2c$var$wrapperStyles,
            $77440a67b7628e2c$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $fBy54.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label,
        css: $77440a67b7628e2c$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        }
    }, (0, $fBy54.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $77440a67b7628e2c$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));

});
parcelRegister("70JVv", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $51ac2885c6479579$export$4e9f1640bbe7a1a8; });
var $51ac2885c6479579$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("11Nkl", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $0bfc25c3f08a1005$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $0bfc25c3f08a1005$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $0bfc25c3f08a1005$export$2e2bcd8739ae039; });

var $jjExS = parcelRequire("jjExS");

var $a7b0G = parcelRequire("a7b0G");

var $9ETxX = parcelRequire("9ETxX");
function $0bfc25c3f08a1005$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0bfc25c3f08a1005$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0bfc25c3f08a1005$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0bfc25c3f08a1005$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0bfc25c3f08a1005$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $0bfc25c3f08a1005$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $9ETxX.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $0bfc25c3f08a1005$var$stateToSelectorMap[state];
    if (selector) result = $0bfc25c3f08a1005$var$_objectSpread($0bfc25c3f08a1005$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $0bfc25c3f08a1005$var$_objectSpread($0bfc25c3f08a1005$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $0bfc25c3f08a1005$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $0bfc25c3f08a1005$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $0bfc25c3f08a1005$var$Theme = (0, $a7b0G.createTheme)(function(themeProps) {
    return {
        buttonStyles: $0bfc25c3f08a1005$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0bfc25c3f08a1005$export$2e2bcd8739ae039 = $0bfc25c3f08a1005$var$Theme;

});



parcelRegister("iJ0X7", function(module, exports) {

$parcel$export(module.exports, "SwitcherLoadErrorReason", function () { return $da1d2b22a7f7b6eb$export$2c6136f6e27d3fdd; });
$parcel$export(module.exports, "SwitcherLoadError", function () { return $da1d2b22a7f7b6eb$export$ff0950b3c2e7f03e; });

var $jjExS = parcelRequire("jjExS");

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $8B3ag = parcelRequire("8B3ag");

var $ariLb = parcelRequire("ariLb");
function $da1d2b22a7f7b6eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da1d2b22a7f7b6eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da1d2b22a7f7b6eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da1d2b22a7f7b6eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $da1d2b22a7f7b6eb$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $da1d2b22a7f7b6eb$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $da1d2b22a7f7b6eb$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $da1d2b22a7f7b6eb$export$2c6136f6e27d3fdd = /*#__PURE__*/ function(SwitcherLoadErrorReason) {
    SwitcherLoadErrorReason["AVAILABLE_PRODUCTS"] = "availableProducts";
    SwitcherLoadErrorReason["PRODUCT_CONFIGURATION"] = "productConfiguration";
    return SwitcherLoadErrorReason;
}({});
var $da1d2b22a7f7b6eb$export$ff0950b3c2e7f03e = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(SwitcherLoadError, _Error);
    var _super = $da1d2b22a7f7b6eb$var$_createSuper(SwitcherLoadError);
    function SwitcherLoadError(errorReason, resultError) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, SwitcherLoadError);
        _this = _super.call(this);
        _this.errorReason = errorReason;
        _this.resultError = resultError;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(SwitcherLoadError, [
        {
            key: "reason",
            value: function reason() {
                var potentialResultError = this.resultError;
                return $da1d2b22a7f7b6eb$var$_objectSpread($da1d2b22a7f7b6eb$var$_objectSpread({}, (0, $ariLb.errorToReason)(potentialResultError.error ? potentialResultError.error : this.resultError)), {}, {
                    source: this.errorReason
                });
            }
        }
    ]);
    return SwitcherLoadError;
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8B3ag)))(Error));

});

parcelRegister("buKGS", function(module, exports) {

$parcel$export(module.exports, "FETCH_ERROR_NAME", function () { return $85e6b6d78cfbef5e$export$83179404a61b001a; });
$parcel$export(module.exports, "FetchError", function () { return $85e6b6d78cfbef5e$export$26e841bcf1aeb894; });

var $6QU8A = parcelRequire("6QU8A");

var $2Yk1N = parcelRequire("2Yk1N");

var $hgJzq = parcelRequire("hgJzq");

var $eZhUW = parcelRequire("eZhUW");

var $kcuts = parcelRequire("kcuts");

var $6pDhi = parcelRequire("6pDhi");

var $8B3ag = parcelRequire("8B3ag");

var $jjExS = parcelRequire("jjExS");
function $85e6b6d78cfbef5e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $85e6b6d78cfbef5e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6pDhi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kcuts)))(this, result);
    };
}
function $85e6b6d78cfbef5e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $85e6b6d78cfbef5e$export$83179404a61b001a = "FetchError";
var $85e6b6d78cfbef5e$export$26e841bcf1aeb894 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eZhUW)))(FetchError, _Error);
    var _super = $85e6b6d78cfbef5e$var$_createSuper(FetchError);
    function FetchError(message, status) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6QU8A)))(this, FetchError);
        _this = _super.call(this, message);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))((0, (/*@__PURE__*/$parcel$interopDefault($hgJzq)))(_this), "name", $85e6b6d78cfbef5e$export$83179404a61b001a);
        _this.status = status;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2Yk1N)))(FetchError, null, [
        {
            key: "isFetchError",
            value: function isFetchError(value) {
                return value instanceof FetchError;
            }
        }
    ]);
    return FetchError;
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8B3ag)))(Error));

});

parcelRegister("1DnwK", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("bILJT")).then(function() {
    return parcelRequire("9cEGT");
});

});



parcelRegister("aaABR", function(module, exports) {

$parcel$export(module.exports, "Experience", function () { return $76773c73c189eeb4$export$c90b54e658fc4d7c; });
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", function () { return $76773c73c189eeb4$export$d54d7a2744fdf647; });
$parcel$export(module.exports, "ExperienceMark", function () { return $76773c73c189eeb4$export$cbf1e672c3e37474; });
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", function () { return $76773c73c189eeb4$export$755e75afbd377bc4; });
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", function () { return $76773c73c189eeb4$export$805ed806e0769ee4; });
$parcel$export(module.exports, "ExperienceMarkPhase", function () { return $76773c73c189eeb4$export$ec8391a70bbdbe59; });
$parcel$export(module.exports, "AbortReason", function () { return $76773c73c189eeb4$export$279d6315a97b520d; });
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", function () { return $76773c73c189eeb4$export$86919b84f9a64054; });

var $jjExS = parcelRequire("jjExS");

var $lzTNO = parcelRequire("lzTNO");

var $2feSJ = parcelRequire("2feSJ");
var $76773c73c189eeb4$var$_EXPERIENCE_CONFIGS, $76773c73c189eeb4$var$_EXPERIENCES_TO_MARKS;
var $76773c73c189eeb4$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_DISCOVER_SECTION"] = "render-discover-section";
    Experience["RENDER_JOIN_SECTION"] = "render-join-section";
    Experience["RENDER_RECENT_SECTION"] = "render-recent-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    return Experience;
}({});
var $76773c73c189eeb4$export$d54d7a2744fdf647 = ($76773c73c189eeb4$var$_EXPERIENCE_CONFIGS = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCE_CONFIGS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_CUSTOM_LINKS_SECTION, {
    type: (0, $lzTNO.ExperienceTypes).Load,
    performanceType: (0, $lzTNO.ExperiencePerformanceTypes).PageSegmentLoad
}), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCE_CONFIGS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_DISCOVER_SECTION, {
    type: (0, $lzTNO.ExperienceTypes).Load,
    performanceType: (0, $lzTNO.ExperiencePerformanceTypes).PageSegmentLoad
}), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCE_CONFIGS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_JOIN_SECTION, {
    type: (0, $lzTNO.ExperienceTypes).Load,
    performanceType: (0, $lzTNO.ExperiencePerformanceTypes).PageSegmentLoad
}), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCE_CONFIGS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_RECENT_SECTION, {
    type: (0, $lzTNO.ExperienceTypes).Load,
    performanceType: (0, $lzTNO.ExperiencePerformanceTypes).PageSegmentLoad
}), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCE_CONFIGS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_SWITCH_TO_SECTION, {
    type: (0, $lzTNO.ExperienceTypes).Load,
    performanceType: (0, $lzTNO.ExperiencePerformanceTypes).PageSegmentLoad
}), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCE_CONFIGS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_SWITCHER_EMPTY_STATE, {
    type: (0, $lzTNO.ExperienceTypes).Load,
    performanceType: (0, $lzTNO.ExperiencePerformanceTypes).PageSegmentLoad
}), $76773c73c189eeb4$var$_EXPERIENCE_CONFIGS);
var $76773c73c189eeb4$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_AVAILABLE_PRODUCTS"] = "api-available-products";
    ExperienceMark["API_COLLABORATION_GRAPH_RECENT_CONTAINERS"] = "api-collaboration-graph-recent-containers";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["API_PRODUCT_CONFIGURATION"] = "api-product-configuration";
    ExperienceMark["API_PRODUCT_RECOMMENDATIONS"] = "api-product-recommendations";
    ExperienceMark["API_XFLOW_SETTINGS"] = "api-xflow-settings";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
var $76773c73c189eeb4$var$allNonTestExperienceMarks = Object.values($76773c73c189eeb4$export$cbf1e672c3e37474).filter(function(mark) {
    return mark !== $76773c73c189eeb4$export$cbf1e672c3e37474.TEST_MARK;
});
var $76773c73c189eeb4$export$755e75afbd377bc4 = ($76773c73c189eeb4$var$_EXPERIENCES_TO_MARKS = {}, (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCES_TO_MARKS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_CUSTOM_LINKS_SECTION, $76773c73c189eeb4$var$allNonTestExperienceMarks), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCES_TO_MARKS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_DISCOVER_SECTION, $76773c73c189eeb4$var$allNonTestExperienceMarks), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCES_TO_MARKS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_JOIN_SECTION, $76773c73c189eeb4$var$allNonTestExperienceMarks), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCES_TO_MARKS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_RECENT_SECTION, $76773c73c189eeb4$var$allNonTestExperienceMarks), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCES_TO_MARKS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_SWITCH_TO_SECTION, $76773c73c189eeb4$var$allNonTestExperienceMarks), (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))($76773c73c189eeb4$var$_EXPERIENCES_TO_MARKS, $76773c73c189eeb4$export$c90b54e658fc4d7c.RENDER_SWITCHER_EMPTY_STATE, $76773c73c189eeb4$var$allNonTestExperienceMarks), $76773c73c189eeb4$var$_EXPERIENCES_TO_MARKS);
var $76773c73c189eeb4$export$805ed806e0769ee4 = (0, $2feSJ.invertRecordOfArrays)($76773c73c189eeb4$export$755e75afbd377bc4);
var $76773c73c189eeb4$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $76773c73c189eeb4$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
var $76773c73c189eeb4$export$86919b84f9a64054 = "atlassianSwitcher.render.start";

});
parcelRegister("2feSJ", function(module, exports) {

$parcel$export(module.exports, "invertRecordOfArrays", function () { return $1a2886ab7a6f530c$export$c371a74fe5222b3; });

var $e6gyJ = parcelRequire("e6gyJ");
function $1a2886ab7a6f530c$export$c371a74fe5222b3(record) {
    var invertedRecord = {};
    Object.entries(record).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e6gyJ)))(_ref, 2), key = _ref2[0], values = _ref2[1];
        values.forEach(function(value) {
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});


parcelRegister("jVPTG", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", function () { return $e82b98e4ac8a223f$export$e94f0da4fc0603c6; });
$parcel$export(module.exports, "useExperienceRenderAndMountMark", function () { return $e82b98e4ac8a223f$export$fb30551804b67d63; });
/* eslint-disable no-console */ 
var $4xpt7 = parcelRequire("4xpt7");

var $1Mpn7 = parcelRequire("1Mpn7");

var $7Xu8z = parcelRequire("7Xu8z");
function $e82b98e4ac8a223f$export$675e0d25df38d426(experienceName, customStartTime) {
    var experienceTracker = (0, $4xpt7.useExperienceTracker)();
    (0, $7Xu8z.useOnceImmediately)(function() {
        return experienceTracker.start(experienceName, customStartTime);
    });
}
function $e82b98e4ac8a223f$export$e94f0da4fc0603c6(experience, attributes) {
    var experienceTracker = (0, $4xpt7.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $1Mpn7.useLayoutEffect)(function() {
        return experienceTracker.success(experience, attributes);
    }, []);
}
function $e82b98e4ac8a223f$export$fb30551804b67d63(mark) {
    var experienceTracker = (0, $4xpt7.useExperienceTracker)();
    (0, $7Xu8z.useOnceImmediately)(function() {
        return experienceTracker.markStart(mark);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $1Mpn7.useLayoutEffect)(function() {
        return experienceTracker.markEnd(mark);
    }, []);
}

});
parcelRegister("7Xu8z", function(module, exports) {

$parcel$export(module.exports, "useSingleton", function () { return $5cb56bb594c655b7$export$abf4268d2dd55708; });
$parcel$export(module.exports, "useOnceImmediately", function () { return $5cb56bb594c655b7$export$ad4f8d0eee7a0e24; });

var $1Mpn7 = parcelRequire("1Mpn7");
function $5cb56bb594c655b7$export$abf4268d2dd55708(builder) {
    var ref = (0, $1Mpn7.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $5cb56bb594c655b7$export$ad4f8d0eee7a0e24(callback) {
    var wasCalledRef = (0, $1Mpn7.useRef)(false);
    var result = (0, $1Mpn7.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});



parcelRegister("8FWI1", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("1frsj")).then(function() {
    return parcelRequire("ldSvy");
});

});

parcelRegister("4TcDf", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("8IX4X")).then(function() {
    return parcelRequire("ixx99");
});

});

parcelRegister("5DvyD", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("7uWpt")).then(function() {
    return parcelRequire("9nfzx");
});

});

parcelRegister("55wt6", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("cSLUl")).then(function() {
    return parcelRequire("izwNm");
});

});

parcelRegister("c8OI7", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("3kpQg")).then(function() {
    return parcelRequire("egAxv");
});

});


parcelRegister("fFM8K", function(module, exports) {

$parcel$export(module.exports, "util", function () { return $5580cb23d3685811$export$7debb50ef11d5e0b; });
var $5580cb23d3685811$export$7debb50ef11d5e0b = {
    getCookie: function getCookie(key) {
        var encodedName = encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&");
        var regex = new RegExp("(?:(?:^|.*;)\\s*" + encodedName + "\\s*\\=\\s*([^;]*).*$)|^.*$");
        return decodeURIComponent(document.cookie.replace(regex, "$1")) || null;
    }
};

});

parcelRegister("95rD4", function(module, exports) {

$parcel$export(module.exports, "createAvailableProductsProvider", function () { return $69da03442e3abc60$export$e85da55f4b9409a; });

var $e8dor = parcelRequire("e8dor");

var $fGIeY = parcelRequire("fGIeY");

var $3uGRs = parcelRequire("3uGRs");

var $lafos = parcelRequire("lafos");

var $aaABR = parcelRequire("aaABR");
var $69da03442e3abc60$export$9eaa25cd86ea1b84 = "/gateway/api/available-products/api/available-products";
var $69da03442e3abc60$export$82b8d71821b278b = function defaultAvailableProductsFetch() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $69da03442e3abc60$export$9eaa25cd86ea1b84;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($e8dor)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).mark(function _callee() {
        var init, response, usingExperimentApi, defaultUnauthorizedResponse;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fGIeY))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (url === $69da03442e3abc60$export$9eaa25cd86ea1b84) init = {
                        headers: {
                            "Atl-App-Switcher-Private-API": "true"
                        }
                    };
                    _context.prev = 1;
                    _context.next = 4;
                    return (0, $lafos.fetchJsonWithNetworkRetries)(url, {
                        intervalsMS: [
                            50,
                            200,
                            1000
                        ]
                    }, init);
                case 4:
                    response = _context.sent;
                    return _context.abrupt("return", response);
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](1);
                    usingExperimentApi = url.indexOf("experiment-api") > -1;
                    if (!(usingExperimentApi && _context.t0.status === 401)) {
                        _context.next = 14;
                        break;
                    }
                    defaultUnauthorizedResponse = Promise.resolve({
                        sites: [],
                        links: [],
                        isPartial: false
                    });
                    return _context.abrupt("return", defaultUnauthorizedResponse);
                case 14:
                    throw _context.t0;
                case 15:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    }));
};
var $69da03442e3abc60$export$e85da55f4b9409a = function createAvailableProductsProvider() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $69da03442e3abc60$export$9eaa25cd86ea1b84;
    return (0, $3uGRs.createProviderWithCustomFetchData)("availableProducts", (0, $aaABR.ExperienceMark).API_AVAILABLE_PRODUCTS, $69da03442e3abc60$export$82b8d71821b278b(url));
};

});
parcelRegister("3uGRs", function(module, exports) {

$parcel$export(module.exports, "createProviderWithCustomFetchData", function () { return $28b56bce52f7ed32$export$310e48be95687c2f; });

var $5a4MH = parcelRequire("5a4MH");

var $lafos = parcelRequire("lafos");

var $8NsE4 = parcelRequire("8NsE4");
var $28b56bce52f7ed32$export$500fbc0cd14cdbaa = function createProvider(name, experienceMark, url) {
    var fetchMethod = (0, $8NsE4.withCached)(function(param) {
        return (0, $lafos.fetchJson)(url);
    });
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $5a4MH.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: function shouldRetryOnException() {
                return true;
            },
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
var $28b56bce52f7ed32$export$310e48be95687c2f = function createProviderWithCustomFetchData(name, experienceMark, fetchData, retryConfig) {
    var fetchMethod = (0, $8NsE4.withCached)(function(param) {
        return fetchData(param);
    });
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $5a4MH.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig)
    };
};

});
parcelRegister("lafos", function(module, exports) {

$parcel$export(module.exports, "fetchJson", function () { return $f68678fc57f16c34$export$6d71b655afe1638d; });
$parcel$export(module.exports, "fetchJsonWithNetworkRetries", function () { return $f68678fc57f16c34$export$16566b750080153d; });
$parcel$export(module.exports, "postJson", function () { return $f68678fc57f16c34$export$c776284ef4b1209a; });

var $jjExS = parcelRequire("jjExS");

var $buKGS = parcelRequire("buKGS");

var $cWqUY = parcelRequire("cWqUY");

var $D8inn = parcelRequire("D8inn");
function $f68678fc57f16c34$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f68678fc57f16c34$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f68678fc57f16c34$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f68678fc57f16c34$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f68678fc57f16c34$var$extraJsonFromResponse = function extraJsonFromResponse(response) {
    if (response.ok) return response.json();
    throw new (0, $buKGS.FetchError)("Unable to fetch ".concat(response.url, " ").concat(response.status, " ").concat(response.statusText), response.status);
};
var $f68678fc57f16c34$export$6d71b655afe1638d = function fetchJson(url, init) {
    return fetch(url, $f68678fc57f16c34$var$_objectSpread($f68678fc57f16c34$var$_objectSpread({
        credentials: "include"
    }, init), {}, {
        headers: $f68678fc57f16c34$var$_objectSpread({
            "Atl-App-Switcher-Version": (0, $D8inn.default).packageVersion
        }, init === null || init === void 0 ? void 0 : init.headers)
    })).then($f68678fc57f16c34$var$extraJsonFromResponse);
};
var $f68678fc57f16c34$export$16566b750080153d = function fetchJsonWithNetworkRetries(url, retryConfig, init) {
    return (0, $cWqUY.retryOnException)(function() {
        return fetch(url, $f68678fc57f16c34$var$_objectSpread($f68678fc57f16c34$var$_objectSpread({
            credentials: "include"
        }, init), {}, {
            headers: $f68678fc57f16c34$var$_objectSpread({
                "Atl-App-Switcher-Version": (0, $D8inn.default).packageVersion
            }, init === null || init === void 0 ? void 0 : init.headers)
        }));
    }, retryConfig).then($f68678fc57f16c34$var$extraJsonFromResponse);
};
var $f68678fc57f16c34$export$c776284ef4b1209a = function postJson(url, data) {
    return $f68678fc57f16c34$export$6d71b655afe1638d(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
};

});
parcelRegister("D8inn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $075a13ecaa944f27$export$2e2bcd8739ae039; });
var $075a13ecaa944f27$var$packageName = "@atlassian/switcher";
var $075a13ecaa944f27$var$packageVersion = "28.2.2";
var $075a13ecaa944f27$export$2e2bcd8739ae039 = {
    packageName: $075a13ecaa944f27$var$packageName,
    packageVersion: $075a13ecaa944f27$var$packageVersion
};

});


parcelRegister("8NsE4", function(module, exports) {

$parcel$export(module.exports, "withCached", function () { return $66791eaec396187a$export$7f51828d6b6af163; });
var $66791eaec396187a$export$d4d4b402ab64e2f4 = 5000;
var $66791eaec396187a$var$isPromise = function isPromise(p) {
    return typeof p.then === "function" && typeof p.catch === "function";
};
var $66791eaec396187a$export$7f51828d6b6af163 = function withCached(fn) {
    var resultCache = new Map();
    var promiseCache = new Map();
    function getCacheKey() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return JSON.stringify(args);
    }
    var cached = function cached() {
        var cacheKey = getCacheKey.apply(void 0, arguments);
        return resultCache.get(cacheKey);
    };
    var reset = function reset() {
        resultCache.clear();
        promiseCache.clear();
    };
    var execute = function execute() {
        var cacheKey = getCacheKey.apply(void 0, arguments);
        var cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        var maybePromise = fn.apply(void 0, arguments);
        promiseCache.set(cacheKey, maybePromise);
        if ($66791eaec396187a$var$isPromise(maybePromise)) maybePromise.then(function(result) {
            resultCache.set(cacheKey, result);
            setTimeout(function() {
                return promiseCache.delete(cacheKey);
            }, $66791eaec396187a$export$d4d4b402ab64e2f4);
        }).catch(function() {
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});



parcelRegister("8E9PO", function(module, exports) {

$parcel$export(module.exports, "createJoinableSitesProvider", function () { return $64b9b01cddb2dea8$export$c3b6af53f1ca17d8; });

var $3uGRs = parcelRequire("3uGRs");

var $aaABR = parcelRequire("aaABR");
var $64b9b01cddb2dea8$export$62986affcccd56a5 = function fetchEmptyData() {
    return Promise.resolve({
        sites: undefined
    });
};
var $64b9b01cddb2dea8$export$c3b6af53f1ca17d8 = function createJoinableSitesProvider() {
    var fetchData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $64b9b01cddb2dea8$export$62986affcccd56a5;
    var retryConfig = arguments.length > 1 ? arguments[1] : undefined;
    return (0, $3uGRs.createProviderWithCustomFetchData)("joinableSites", (0, $aaABR.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};

});

parcelRegister("fqWHu", function(module, exports) {
$parcel$export(module.exports, "AppSwitcherContainer", function () { return (parcelRequire("eBpDn")).AppSwitcherContainer; });
$parcel$export(module.exports, "AppSwitcherMenu", function () { return (parcelRequire("kZduL")).AppSwitcherMenu; });
$parcel$export(module.exports, "StyledAppSwitcherIcon", function () { return (parcelRequire("j5XuS")).StyledAppSwitcherIcon; });
$parcel$export(module.exports, "RemoteSwitcherContainer", function () { return (parcelRequire("7uLpc")).RemoteSwitcherContainer; });
parcelRequire("eBpDn");
parcelRequire("kZduL");
parcelRequire("j5XuS");
parcelRequire("7uLpc");

});
parcelRegister("eBpDn", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherContainer", function () { return $1e687ae757bc02de$export$7965bbb0402b233f; });

var $1DvYB = parcelRequire("1DvYB");

var $fBy54 = parcelRequire("fBy54");

var $1rY3h = parcelRequire("1rY3h");
var $1e687ae757bc02de$var$appSwitcherContainerStyle = /*#__PURE__*/ (0, $fBy54.css)("display:flex;justify-content:center;:hover{background:#ebecf0;border-radius:", (0, $1DvYB.wplToken)("space.300"), ";}&.has-text-label{border-radius:", (0, $1DvYB.wplToken)("space.075"), ";}");
var $1e687ae757bc02de$export$7965bbb0402b233f = function AppSwitcherContainer(_ref) {
    var children = _ref.children;
    return (0, $1rY3h.jsx)("div", {
        id: "global-nav--wac__app-switcher",
        css: $1e687ae757bc02de$var$appSwitcherContainerStyle,
        className: "has-text-label",
        "data-testid": "global-nav-app-switcher-container",
        children: children
    });
};

});

parcelRegister("kZduL", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherMenu", function () { return $7b11fae0d85e35f6$export$f4436cac969d25ee; });

var $1DvYB = parcelRequire("1DvYB");

var $fBy54 = parcelRequire("fBy54");

var $1rY3h = parcelRequire("1rY3h");
var $7b11fae0d85e35f6$export$f4436cac969d25ee = function AppSwitcherMenu(_ref) {
    var children = _ref.children;
    return (0, $1rY3h.jsx)("div", {
        css: $7b11fae0d85e35f6$var$appSwitcherMenuStyles,
        children: children
    });
};
var $7b11fae0d85e35f6$var$appSwitcherMenuStyles = /*#__PURE__*/ (0, $fBy54.css)("display:block;position:absolute;border-radius:", (0, $1DvYB.wplToken)("space.075"), ";background-color:#ffffff;min-width:160px;box-shadow:0px 8px 16px 0px rgba(0, 0, 0, 0.2);padding:0;z-index:19;svg{margin-bottom:0;}h1{margin-top:", (0, $1DvYB.wplToken)("space.0"), ";font-weight:normal;font-weight:500;}a{font-weight:400;}");

});

parcelRegister("j5XuS", function(module, exports) {

$parcel$export(module.exports, "StyledAppSwitcherIcon", function () { return $a1b7166adffc3c77$export$18e4e108a6922ae1; });

var $1DvYB = parcelRequire("1DvYB");

var $fBy54 = parcelRequire("fBy54");

var $1rY3h = parcelRequire("1rY3h");
var $a1b7166adffc3c77$export$18e4e108a6922ae1 = function StyledAppSwitcherIcon(_ref) {
    var appSwitcherLabel = _ref.appSwitcherLabel, allowJoinSitesProvider = _ref.allowJoinSitesProvider, toggleSwitcherDropdown = _ref.toggleSwitcherDropdown, setHasHovered = _ref.setHasHovered, children = _ref.children;
    return (0, $1rY3h.jsx)("div", {
        tabIndex: 0,
        className: "text-label-parent",
        "data-label": appSwitcherLabel,
        onClick: function onClick() {
            toggleSwitcherDropdown(allowJoinSitesProvider);
        },
        onKeyDown: function onKeyDown(e) {
            if (e.code == "Enter") toggleSwitcherDropdown(allowJoinSitesProvider);
        },
        onFocus: function onFocus() {
            return setHasHovered(true);
        },
        onMouseEnter: function onMouseEnter() {
            return setHasHovered(true);
        },
        css: $a1b7166adffc3c77$var$styledAppSwitcherIconStyle,
        "data-testid": "global-nav-styled-app-switcher-icon",
        children: children
    });
};
var $a1b7166adffc3c77$var$styledAppSwitcherIconStyle = /*#__PURE__*/ (0, $fBy54.css)("span{height:28px;width:28px;}display:flex;justify-content:center;cursor:pointer;&.text-label-parent{display:flex;align-items:center;border:1px solid #0052cc;padding:0 10px 0 14px;border-radius:", (0, $1DvYB.wplToken)("space.075"), ";&:before{content:attr(data-label);margin:0 ", (0, $1DvYB.wplToken)("space.075"), " 0 0;color:#0052cc;font-size:0.875rem;line-height:2.15;}&>span{width:", (0, $1DvYB.wplToken)("space.300"), ";height:", (0, $1DvYB.wplToken)("space.300"), ";}}");

});

parcelRegister("7uLpc", function(module, exports) {

$parcel$export(module.exports, "RemoteSwitcherContainer", function () { return $be9357e3a6ef2162$export$d2d76ea29ee7ce16; });

var $1DvYB = parcelRequire("1DvYB");

var $fBy54 = parcelRequire("fBy54");

var $1rY3h = parcelRequire("1rY3h");
var $be9357e3a6ef2162$var$remoteSwitcherContainerStyle = function remoteSwitcherContainerStyle(display) {
    return /*#__PURE__*/ (0, $fBy54.css)("display:", display ? "block" : "none", ";position:relative;right:330px;top:", (0, $1DvYB.wplToken)("space.400"), ";");
};
var $be9357e3a6ef2162$export$d2d76ea29ee7ce16 = function RemoteSwitcherContainer(_ref) {
    var display = _ref.display, children = _ref.children;
    return (0, $1rY3h.jsx)("div", {
        css: $be9357e3a6ef2162$var$remoteSwitcherContainerStyle(display),
        "data-testid": "global-nav-container",
        children: children
    });
};

});




})();
//# sourceMappingURL=app-switcher.6e5b1f02.js.map
